// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/Akkurat-Mono.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/Akkurat-Mono.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/Inter-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/Inter-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/Inter-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../fonts/Inter-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../fonts/Inter-SemiBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../fonts/Inter-SemiBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../fonts/Inter-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../fonts/Inter-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../fonts/Inter-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../fonts/Inter-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../fonts/Inter-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../fonts/Inter-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../fonts/Inter-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../fonts/Inter-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../fonts/Inter-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../../img/moon-icon-orange.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../../img/sun-icon-white.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../../img/remove-icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../../img/vector_iD_icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../../img/sunet_logo.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../../img/eduid-logo.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../../img/eduid-logo-darkmode.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../../img/sunet_logo_white.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** Note! Order of import below affects cascaded application of styles, so change with care. **/

/** Classic cross browser element reset **/

/* http://meyerweb.com/eric/tools/css/reset/
   v2.0 | 20110126
   License: none (public domain)
*/

html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font-family: inherit;
  vertical-align: baseline;
}

/* HTML5 display-role reset for older browsers */
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}

body {
  line-height: 1;
}

ol,
ul {
  list-style: none;
}

blockquote,
q {
  quotes: none;
}

blockquote::before,
blockquote::after,
q::before,
q::after {
  content: "";
  content: none;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}
/** System wide variables to reuse for consistency **/

/*
 * Colors
 * ========================================================================== */

/* CSS vars to enable dark mode overrides */
:root {
  --contrast-color: #fff;
  --body-txt: #161616;
  --body-gray: #f4f4f4;
  --txt-gray: #5e5e5e; /* text on bg gray */
  --border-gray: #d8d8d8;
  --txt-orange: #c23400; /* text on gray or orange */
  --bg-orange: #ffe7dd;
  --error-red: #d2143a;
  --error-red-t: #d2143a80; /* with 50% transparency */
  --bg-gray: #ebebeb;
  --shadow-green: #c1e1cd;
  --txt-green: #12633d;
  --bright-orange-filter: brightness(0) saturate(100%) invert(25%) sepia(28%) saturate(6161%) hue-rotate(4deg)
    brightness(93%) contrast(101%);
  --bright-orange: #ff4500; /* eduID, highlights */
  --btn-orange: #db3a00; /* white on orange */
  --success-green: #177d4d;

  /*
   * Typography
   * ========================================================================== */
  --inter-bold: "Inter-SemiBold", "Arial", "Helvetica", "sans-serif"; /* bold enough for normal text */
  --inter-regular: "Inter-Regular", "Arial", "Helvetica", "sans-serif";
  --inter-medium: "Inter-Medium", "Arial", "Helvetica", "sans-serif";
  --inter-light: "Inter-light", "Arial", "Helvetica", "sans-serif";
  --akkurat: "Akkurat", "Arial", "Helvetica", "sans-serif";
  --txt-xs: 0.75rem; /* 12px */
  --txt-sm: 0.875rem; /* 14px */
  --txt-md: 1rem; /* 16px (body 100%, default) */
  --txt-lg: 1.125rem; /* 18px */
  --txt-xl: 1.25rem; /* 20px */
  --txt-xxl: 1.375rem; /* 22px */
  --line-height: 1.4;
  --margin: 1rem;
  --list-indent: 2.25rem;

  /*
   * Layout
   * ========================================================================== */
  --border-width: 2px;

  /*
   * Shadows
   * ========================================================================== */
  --shadow-sm: 0 1px 3px 2px rgb(0 0 0 / 5%);
  --shadow-md: 0 4px 14px rgb(89 89 89 / 7%);
  --shadow-lg: 0 5px 17px rgb(89 89 89 / 7%);
  --shadow-nav: 0 -6px 17px rgb(89 89 89 / 7%);
}

/*
 * Breakpoints
 * ========================================================================== */

/* min-width variants */
@font-face {
  font-family: Akkurat;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: Inter-Bold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff"),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff2");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: Inter-SemiBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff"),
    url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("woff2");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: Inter-Medium;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("woff"),
    url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("woff2");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: Inter-Regular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("woff"),
    url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("woff2");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: Inter-Light;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format("woff"),
    url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format("woff2");
  font-weight: normal;
  font-style: normal;
}
/** Site wide typography **/

h1,
h2,
h3,
h4,
h5,
.heading-2,
.heading-4 {
  margin-top: 0;
  margin-bottom: 1em;
  line-height: 1.2;
  font-family: var(--inter-bold);
  font-weight: normal;

  @media (max-width: 768px) {
    overflow-wrap: anywhere;
  }
}

h1 {
  font-size: 2rem;
  margin-top: 0.5em;
  margin-bottom: 0.5em;
  font-family: var(--inter-light);

  @media (max-width: 768px) {
    font-size: 1.75rem;
  }
}

h2,
.heading-2 {
  font-size: 1.5rem;
  margin-bottom: 0.75em;

  @media (max-width: 768px) {
    font-size: 1.375rem;
  }
}

h3 {
  font-size: 1.375rem;
  margin-bottom: 0.75em;

  @media (max-width: 768px) {
    font-size: 1.25rem;
  }
}

h4,
.heading-4 {
  font-size: 1.25rem;
  margin-bottom: 0.5em;
}

h5,
.heading-5 {
  font-family: var(--inter-light);
  text-transform: uppercase;
  font-size: var(--txt-sm);
  margin-bottom: 0.5em;
}

.lead {
  margin-bottom: 2rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid var(--border-gray);

  p {
    font-size: var(--txt-xl);
  }

  @media (max-width: 768px) {
    margin-bottom: 1.25rem;
    padding-bottom: 0;

    p {
      font-size: var(--txt-lg);
    }
  }
}

p {
  font-size: var(--txt-lg);
  line-height: var(--line-height);
  margin-bottom: 1rem;

  + p {
    margin-top: -0.5rem;
  }

  @media (max-width: 768px) {
    font-size: var(--txt-md);
  }
}

p.verified {
  color: var(--body-txt);
}

p.no-data.data {
  color: var(--txt-gray);
}

.text-large {
  font-size: var(--txt-lg);
}

.text-medium {
  font-size: var(--txt-md);
}

.text-small {
  font-size: var(--txt-sm);
}

/* only for body text, Akkurat links and buttons need separate handling */
strong,
b,
.text-bold {
  font-family: var(--inter-bold);
  font-weight: normal;
}

em {
  font-style: italic;
}

.verbatim {
  text-transform: none;
}

code,
.code {
  font-family: monospace;
  color: var(--txt-gray);
}

.error-txt {
  color: var(--error-red);
  font-size: var(--txt-sm) !important;
}

.suggestion-txt {
  font-style: italic;
  color: var(--txt-green);
  font-size: var(--txt-sm);
  display: block;
  line-height: normal;

  &.md {
    font-size: var(--txt-md);
  }
}
/* Overall page structure */

* {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

*,
::after,
::before {
  box-sizing: border-box;
}

body {
  min-height: 100vh;
  font-family: var(--inter-regular);
  font-size: 16px;
  line-height: 1.5;
  color: var(--body-txt);
  scroll-behavior: smooth;
  display: flex;
  padding: env(safe-area-inset-top, 1.25rem) env(safe-area-inset-right, 1.25rem) env(safe-area-inset-bottom, 1.25rem)
    env(safe-area-inset-left, 1.25rem);
}

#root,
.page-wrapper {
  display: flex;
  flex: 1;
  flex-direction: column;
}

.panel {
  display: flex;
  flex-direction: column;
  flex: 1;
  background-color: var(--body-gray);

  .content {
    padding-top: 2rem;
    padding-bottom: 4rem;

    @media (max-width: 823px) {
      padding-top: 1.5rem;
      padding-bottom: 3rem;
    }
  }
}

/* in common for content pages and landing */
#content {
  height: 100%;
}

/* same styling as .phoneview-form-container, #delete-account-container,#change-password-container */

/* in Email.js = replaced these with with <article> */
#content article {
  margin-bottom: 2.5rem;
  padding-bottom: 2.5rem;
  border-bottom: 1px solid var(--border-gray);

  &:last-of-type {
    border-bottom: none;
    margin-bottom: 0;
  }

  @media (max-width: 768px) {
    margin-bottom: 1.75rem;
    padding-bottom: 1.75rem;
  }

  /* nested */
  article {
    margin-bottom: 1.75rem;
    padding-bottom: 1.75rem;
    border-bottom: 1px dashed var(--border-gray);

    @media (max-width: 768px) {
      margin-bottom: 1rem;
      padding-bottom: 1rem;
    }

    &:last-of-type {
      padding-bottom: 0;
    }
  }
}

/* this is a horizontal-margin and should be renamed */
.horizontal-content-margin,
.vertical-content-margin {
  padding: 0;
  width: 58%;
  max-width: 870px;
  margin: 0 auto;

  /* this is added to prevent margin collapse (look for other solution if causing problems) */
  display: flex;
  flex-direction: column;
}

/* Mimic lead paragraph border */
hr.border-line {
  margin: 0.5rem 0 2rem;
  border-bottom: 2px solid var(--border-gray);
  border-top: none;
  opacity: unset;
}

hr.border-line-lesser {
  border-bottom: 1px dashed var(--border-gray);
}

/* eg for help-texts */
.top-divider {
  border-top: 1px dashed var(--txt-gray);
  margin: 0.5rem 0 0;
  padding: 0.5rem 1rem 0.25rem 0;
  display: block;
}

@media (max-width: 823px) {
  .horizontal-content-margin,
  .vertical-content-margin {
    width: calc(80% - 2rem);
  }
}

@media (max-width: 768px) {
  .horizontal-content-margin,
  .vertical-content-margin {
    width: calc(80% - 1.25rem);
  }
}

@media (max-width: 568px) {
  .horizontal-content-margin,
  .vertical-content-margin {
    width: calc(100% - 2rem);
  }
}

@media (max-width: 414px) {
  .horizontal-content-margin,
  .vertical-content-margin {
    width: calc(100% - 2 * var(--margin));
  }
}

/* Utility classes - possibly move to separate file */
.flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;

  &.baseline {
    align-items: baseline;
  }
}

/* hides object from view but still accessible to screen readers */
.visuallyhidden {
  border: 0;
  clip-path: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

.display-none {
  display: none;
}

/* Spacing utility classes */
.m-b-md {
  margin-bottom: 1.5rem;
}
/* Form layout elements */

/* top margin here assumes that text above has bottom margin of 1rem */
.single-input-form .form-group {
  margin-bottom: 0;
  width: 100%;

  & .text-muted {
    margin-top: 0;
  }
}

/* text under inputs */
.small,
small {
  font-size: 100% !important;

  &.form-text {
    margin-top: 0 !important;
  }
}

.form-group {
  margin-bottom: 0;
}

form {
  display: flex;
  flex-direction: column;
  margin-top: 1.25rem;

  .form-wrapper {
    min-height: 6rem;
    margin-bottom: 0.5rem;
  }

  /* places two wrapped input groups on one row */
  .input-pair {
    @media (min-width: 1200px) {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      -moz-column-gap: 1rem;
           column-gap: 1rem;

      > .form-wrapper {
        flex: 1;
      }
    }
  }
}

.input-container {
  margin-bottom: 1.125rem;
  margin-right: 0.5rem;
  flex: 1;
}

.element-pair,
.button-pair {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
}

.element-pair {
  margin-top: 1rem;
  align-items: unset;
}

/* single input and button on a row */
.single-input-form {
  flex-direction: row;
  align-items: center;

  .buttons {
    align-self: center;
  }

  button {
    margin: 0.5rem 0 0 1rem;
  }

  @media (max-width: 568px) {
    flex-direction: column;

    button {
      margin: 0;
    }
  }
}

#reset-password-email-form {
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 568px) {
    flex-direction: column;
    align-items: unset;

    button {
      width: 100%;
      margin-top: 1rem;
    }
  }
}

/* fieldset used to group, possibly incorrectly */
fieldset {
  width: 100%;
  position: relative;

  &:not(:empty, :last-of-type) {
    margin-bottom: 1.25em;
  }

  legend {
    display: flex;
    flex-direction: column;
    font-size: var(--txt-md);
    font-family: var(--inter-bold);
    letter-spacing: 0.5px;
    line-height: 1;
    color: var(--body-txt);
    margin: 0 5px 5px 0;
  }

  legend.required::after {
    content: " *";
    color: var(--txt-orange);
  }
}

.input-validate-error {
  font-family: monospace;
  font-size: var(--txt-xs);
  color: var(--error-red);
  display: inline-block;
  line-height: 1.3;
  margin-top: 5px;
}

.input-label-help-text-container,
.response-code-inputs {
  display: flex;
  flex-flow: row wrap;
  align-items: baseline;

  & label {
    letter-spacing: 0;
    font-size: var(--txt-md);
  }

  /* for orange asterisk after label */
  & label.required::after {
    content: " *";
    color: var(--txt-orange);
  }

  /* is this used? I think not // */
  & .help-block {
    font-size: var(--txt-md);
    text-transform: lowercase;
  }
}

.response-code-inputs {
  label {
    width: 100%;
  }
}

/* smallish grayish additional info underneath corresponding form elements */
.help-text {
  margin: 0.5rem 0 0;
  color: var(--txt-gray);
  font-size: var(--txt-sm);
  line-height: 1.3;

  &.black {
    color: var(--body-txt);
  }

  .btn + & {
    @media (max-width: 768px) {
      text-align: center;
    }

    @media (max-width: 414px) {
      margin: 0 0 0.75rem;
    }
  }
}
/* Inputs and form controls, mainly non button */
input {
  box-sizing: border-box;
  font-family: var(--inter-regular);
  font-size: var(--txt-xl);
  color: var(--body-txt);
  box-shadow: none;
  border-radius: 0;
  border: none;
  width: 100%;
  padding: 1.25rem 0.5rem;
  height: 3rem;
  background-color: var(--contrast-color);
}

/* Form controls and interactive states */
input,
input.is-valid,
input:focus,
input.is-valid:focus {
  outline: var(--border-width) solid var(--border-gray);
  background-image: none;
  background-color: var(--contrast-color);
  transition: none;
  border: none;
  box-shadow: none;
}

input::-moz-placeholder {
  font-family: var(--inter-regular);
  font-size: var(--txt-xl);
}

input::placeholder {
  font-family: var(--inter-regular);
  font-size: var(--txt-xl);
}

:hover:not(:focus, :disabled) {
  &[type="text"],
  &[type="password"],
  &[type="email"] {
    padding-top: calc(1.25rem + var(--border-width));
    border-bottom: var(--border-width) solid var(--body-txt) !important;
  }
}

input.is-invalid,
input.is-invalid:focus {
  outline: var(--border-width) solid var(--error-red-t);
  background-image: none;
}

/* tab-focus */
:focus-visible,
#mfa-security-key:focus {
  outline: var(--border-width) dashed var(--body-txt) !important;
  transition: none !important;

  /* has parents with overflow hidden */
  table & {
    outline-offset: calc(-1 * var(--border-width));
  }

  &.toggle-checkbox + .toggle-switch {
    outline: var(--border-width) dashed var(--body-txt) !important;
    transition: none;
  }
}

input:disabled,
input[readonly] {
  color: var(--txt-txt);
  background-color: var(--bg-gray);
  pointer-events: none;
  cursor: not-allowed;

  :focus,
  :hover {
    outline: none;
  }
}

input[readonly] {
  outline: none;
}

/* removing chrome autocomplete babyblue */
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
  box-shadow: 0 0 0 1000px var(--contrast-color) inset !important;
}

/* Radio buttons */
input[type="radio"] {
  /* remove standard background appearance */
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  outline: none;
  margin: 0;

  /* create custom radio button appearance */
  display: inline-block;
  width: 1rem;
  height: 1rem;
  min-width: 1rem;
  min-height: 1rem;
  align-self: center;

  /* background-color only for content */
  background-clip: content-box;
  box-shadow: var(--shadow-lg);
  border: var(--border-width) solid var(--bright-orange);
  background-color: transparent;
  border-radius: 50%;

  /* to prevent overwrite from input padding, this ensures that the radio button remains round */
  padding: 0;

  &:hover {
    background-color: var(--bright-orange);
    cursor: pointer;
    border: none;
  }

  &:checked {
    background-color: var(--bright-orange);
    border: none;

    .error {
      background: var(--error-red);
      color: var(--contrast-color);
      border: none;
    }
  }
}

/* optional styles for centering radio buttons */
.radio-input-container {
  display: flex;

  label {
    margin-top: 5px;

    &:hover {
      cursor: pointer;
    }
  }

  span {
    font-size: var(--txt-xl);
    align-self: center;
    color: var(--body-txt);
    font-family: var(--inter-regular);
    font-weight: normal;
    margin: 0 2rem 0 0;
    margin-left: 8px;
  }
}

/* Login username-pw / reset-password set-new-password */
.password-input {
  position: relative;

  input[name="currentPassword"].is-valid {
    background-image: none;
  }
}

#copy-new-password {
  background-color: var(--bg-gray);
}

input#display-none-new-password {
  display: none;
}

/* Checkbox */
input[type="checkbox"] {
  height: 1rem;
  width: 1rem;
  margin-right: 0.5rem;
  border: none;
  outline: none;
  box-shadow: none;
}

/* Switch toggle */
.toggle {
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;

  > legend,
  > span {
    flex: 1;
  }

  > span {
    margin-right: 10px;
  }
}

.toggle-switch {
  display: inline-block;
  background: var(--border-gray);
  border-radius: 16px;
  width: 54px;
  height: 28px;
  position: relative;
  vertical-align: middle;
  transition: all 0.25s;

  &::before,
  &::after {
    content: "";
  }

  &::before {
    display: block;
    background: var(--contrast-color);
    border-radius: 50%;
    width: 22px;
    height: 22px;
    position: absolute;
    top: 3px;
    left: 3px;
    transition: left 0.25s;
  }

  .toggle:hover &::before {
    transform: scale(0.9);
  }

  .toggle-checkbox:checked + & {
    background: var(--bright-orange);

    &::before {
      left: 29px;
    }
  }
}

/* orange moon bc default light bg */
#color-mode + .toggle-switch {
  background-repeat: no-repeat;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  background-position: 82%;
  background-size: 17px;
}

/* checked is dark mode */
#color-mode:checked + .toggle-switch {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  background-position: 10%;
  background-size: 22px;
}

.toggle-checkbox {
  position: absolute;
  border: 0;
  clip-path: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  width: 1px;
}

/* Select */
select {
  padding: 5px;
  border-radius: 3px;
  width: 100%;
  background-color: var(--contrast-color);
  height: 40px;
  margin-top: 3px;
}

/* react-select */
/* stylelint-disable-next-line selector-class-pattern */
.select__multi-value__label {
  font-size: var(--txt-xl) !important;
  align-self: center !important;
}

/* Cross browser */

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
          appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -webkit-appearance: textfield;
     -moz-appearance: textfield;
          appearance: textfield;
}

input.display-none {
  display: none;
}

input:-webkit-autofill {
  background-color: transparent !important;
  box-shadow: 0 0 0 50px var(--contrast-color) inset;
}

/* Responsive */
@media (max-width: 568px) {
  input,
  .radio-input-container span {
    font-size: var(--txt-md);
  }

  .input-container {
    margin: 0;
  }

  input::-moz-placeholder {
    font-size: var(--txt-md);
  }

  input::placeholder {
    font-size: var(--txt-md);
  }

  footer .toggle {
    flex-direction: column;
    align-self: end;

    > span {
      margin: 0 0 5px;
    }
  }
}

@media (max-width: 768px) {
  .radio-input-container {
    flex-direction: column;

    label {
      margin-bottom: 10px;
    }
  }
}
label,
.form-label {
  display: flex;
  font-size: var(--txt-md);
  font-family: var(--inter-bold);
  letter-spacing: 0.5px;
  line-height: 1;
  color: var(--body-txt);
  margin: 0 5px 5px 0;
}

.border-toggle-area {
  border-color: var(--border-gray);
  border-width: var(--border-width);
  border-style: solid;
  border-radius: 10px;
  padding: var(--margin);

  label {
    margin: 0;
  }

  legend {
    margin-right: 5px;
  }
}

/* stylelint-disable-next-line selector-id-pattern */
#uniqueId-container label {
  white-space: nowrap;
}
button:disabled {
  cursor: not-allowed;
  pointer-events: all;
  opacity: 0.4;
}

a.button,
button {
  font-family: var(--akkurat);
  letter-spacing: 1px;
  font-size: var(--txt-md);
  font-weight: bold;
  line-height: 1;
  text-transform: uppercase;
  height: 3rem;
  border-radius: 1.5rem;
  box-shadow: var(--shadow-lg);
  transition: all 0.3s ease;
  outline: 0;
  border: none;
  cursor: pointer;
}

button:disabled,
button.disabled {
  cursor: not-allowed !important;
  pointer-events: all !important;
  border-color: inherit;
  color: var(--contrast-color);

  &.primary {
    background-color: var(--btn-orange);
  }
}

button.primary,
button.primary:not(:disabled, .disabled):active,
button.primary:not(:disabled, .disabled):focus,
button.primary:not(:disabled, .disabled):active:focus,
button.primary:not(:disabled, .disabled):hover {
  color: #fff;
  border: solid 2px var(--bright-orange);
  background-color: var(--btn-orange);
  box-shadow: none;
  min-width: 100px;
  padding: 0 1.125rem;

  &.sm {
    padding: 0.5rem 1rem;
    font-size: 13px;
    min-width: -moz-fit-content;
    min-width: fit-content;
    width: auto;
    height: auto;
    margin-top: 0;
    margin-bottom: 0;
    letter-spacing: 1px;
  }
}

button.secondary,
button.secondary:not(:disabled, .disabled):active,
button.secondary:not(:disabled, .disabled):focus,
button.secondary:not(:disabled, .disabled):active:focus,
button.secondary:not(:disabled, .disabled):hover {
  color: var(--txt-orange);
  border: solid 2px var(--bright-orange);
  background-color: var(--contrast-color);
  box-shadow: none;
  min-width: 100px;
  padding: 0 1.125rem;

  /* Login, Logout, Register button in Header */
  &.sm {
    padding: 0.5rem 1rem;
    font-size: 13px;
    min-width: -moz-fit-content;
    min-width: fit-content;
    width: auto;
    height: auto;
    margin-top: 0;
    margin-bottom: 0;
    letter-spacing: 1px;
  }
}

button.primary,
button.secondary,
/* stylelint-disable-next-line selector-class-pattern */
.mfa-select .react-select__control {
  &:hover {
    transform: scale(0.95);

    &:disabled,
    .disabled {
      transform: scale(1);
    }
  }
}

/* CLOSE buttons in modals */
button.close {
  background-color: transparent;
  margin: 0;
  box-shadow: none;
  height: 1rem;
  width: 1rem;
  position: relative;
  display: inline-block;
  cursor: pointer;

  &:hover,
  &:not(:disabled, .disabled):active,
  &:not(:disabled, .disabled):focus,
  &:not(:disabled, .disabled):active:focus {
    background-color: transparent;
    box-shadow: none;
    transform: scale(0.8);
  }

  &.sm {
    font-size: var(--txt-xs);
  }
}

.close::before,
.close::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 20px;
  height: 2px;
  background-color: var(--body-txt);
  transform-origin: center;

  :hover > & {
    background-color: var(--bright-orange);
  }
}

.close::before {
  transform: translate(-50%, -50%) rotate(45deg);
}

.close::after {
  transform: translate(-50%, -50%) rotate(-45deg);
}

/* styles for links that are also buttons */
button.link {
  background-color: transparent;
  color: var(--txt-orange);
  border-radius: 0;
  border: none;
  box-shadow: none;
  margin: 0;
  text-decoration: none;
  padding: 0;
  line-height: 1.25;

  &:hover,
  &:active {
    color: var(--txt-orange);
    background-color: transparent;
    text-decoration: underline;
    box-shadow: none;
  }

  &.sm {
    font-size: var(--txt-xs);
  }

  &.normal-case {
    text-transform: none;
  }

  &.disabled,
  &:disabled,
  &[disabled] {
    color: var(--txt-gray);
    opacity: 1;
    box-shadow: none;
    text-decoration: none;
  }
}

/* icon left of button text */
button.icon {
  display: flex;
  align-items: center;
  justify-content: center;

  svg,
  img {
    margin-right: 0.5rem;
    width: auto;
    transition: transform 0.5s;
  }

  /* round arrow update link */
  &.refresh:hover svg {
    transform-origin: center;
    transform: rotate(360deg);
  }

  &.refresh[disabled]:hover svg {
    transform: none;
  }

  span {
    text-align: left;
    line-height: var(--line-height);
  }
}

/* TODO possibly replace with .buttons - check SAMLResponseForm */
.flex-buttons {
  display: flex;
  -moz-column-gap: 1rem;
       column-gap: 1rem;
  margin: 1em 0 0;

  button {
    min-width: 100px;
  }

  button[type="submit"] {
    order: 2;
  }
}

/* Wraps all buttons for responsive behaviour independent on number */
.buttons {
  display: flex;
  -moz-column-gap: 1rem;
       column-gap: 1rem;
  padding: 0.5rem 0;
  width: 100%;

  &.flex-direction-column {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 0.5rem;
    width: 100%;
  }

  button {
    min-width: 100px;
  }

  @media (min-width: 414px) {
    width: auto;
  }

  @media (max-width: 768px) {
    justify-content: center;
    align-self: normal;
  }

  @media (max-width: 414px) {
    flex-direction: column-reverse;

    &.flex-direction-column {
      grid-template-columns: 1fr;
    }

    button[type="submit"] {
      order: 1;
    }

    button {
      margin: 0.5rem 0 !important;
    }
  }
}

.buttons-center {
  display: flex;
  -moz-column-gap: 1rem;
       column-gap: 1rem;
  padding: 0.5rem 0;
  width: 100%;
  align-items: center;
}

/* textual toggle control, eg. copy/copied right after input */
.txt-toggle-btn {
  height: auto;

  /* and show/hide just before input */
  &:has(+ input) {
    position: absolute;
    right: 0;
    top: -1.1rem;
  }
}

/* Instance/icon unique styles to be set in targeted css */
button.icon-only {
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: none;
  background: transparent;
  border-color: transparent;
  margin: 0;
  padding: 0;
}

@media (max-width: 414px) {
  button:not(.sm) {
    font-size: var(--txt-sm);
  }

  button.primary,
  button.secondary {
    width: 100%;
  }

  button.link {
    width: auto;
    padding: 0;
  }
}

/* menu name control */
button.header-user {
  &:hover,
  &:focus-within {
    background-color: var(--body-gray) !important;
  }
}

/* Scroll To top button */
button.scroll-to-top {
  display: block;
  position: fixed;
  bottom: 7rem;
  right: 1rem;

  /* round button */
  border-radius: 50% !important;
  min-width: -moz-fit-content !important;
  min-width: fit-content !important;
  width: 50px;
  height: 50px;
  padding: 0 !important;

  @media (max-width: 568px) {
    width: 40px;
    height: 40px;
    right: 0.5rem;
    bottom: 6.5rem;
  }
}

.remove {
  width: 1.2rem;
  height: 1.2rem !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  cursor: pointer;
  box-shadow: none !important;
  background-color: transparent;
  filter: brightness(0) saturate(100%);

  &:not(:disabled):hover {
    filter: var(--bright-orange-filter);
    transform: scale(0.8);
  }
}

.copybutton {
  position: absolute;
  width: auto !important;
  right: 1rem;

  svg {
    color: var(--body-txt);
  }

  #icon-check {
    display: none;
  }

  .tool-tip-text {
    visibility: hidden;
    width: 100px;
    background-color: var(--body-txt);
    color: var(--contrast-color);
    font-size: var(--txt-sm);
    font-family: var(--inter-regular);
    border-radius: 4px;
    padding: 6px;
    position: absolute;
    z-index: 5;
    bottom: 85%;
    left: 1rem;
    margin-left: -75px;
    opacity: 0;
    transition: opacity 0.3s;
    text-transform: none;
    line-height: 1.2;
  }

  .tool-tip-text::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 2.6rem;
    margin-left: 20px;
    border-width: 5px;
    border-style: solid;
    border-color: var(--body-txt) transparent transparent transparent;
  }

  &:hover .tool-tip-text {
    visibility: visible;
    opacity: 1;
  }
}

button.flex {
  display: flex;
  align-items: center;

  img {
    width: auto;
    padding-right: 10px;
  }
}
/* Textual non-button-styled links */

a {
  color: var(--txt-orange);
  font-family: var(--akkurat);
  text-decoration: none;
  transition: all 0.2s ease;
  cursor: pointer;
  border-bottom: none;

  &:hover {
    color: var(--txt-orange);
    border-bottom: none;
    text-decoration: underline;
  }

  /* hiding opt in beta link */
  &#stable-link.hidden {
    display: none;
  }
}

a .disabled,
a.disabled {
  color: var(--txt-gray);
  text-decoration: none;
  pointer-events: none;

  &:hover {
    cursor: not-allowed;
  }
}

.wizard-link-wrapper {
  display: flex;
  justify-content: space-between;
  padding-top: 2.5rem;
  gap: 20px;
  font-size: var(--txt-sm);

  a,
  .link {
    display: grid;
    align-items: center;
    overflow-wrap: anywhere;

    &.left {
      grid-template-columns: 0.1fr 1fr;
    }

    &.right {
      grid-template-columns: 1fr 0.1fr;
      justify-items: end;
      text-align: end;
    }
  }

  .link {
    font-size: 0.875rem;
    font-weight: 400;
    letter-spacing: normal;
  }
}
img {
  width: 100%;
}

/* TODO - reuse btn-close instead of these svg icons: remove (Orcid, TableList) and close (CreateGroup, Notifications) */
svg {
  &.remove,
  &.close {
    transform-origin: center;
    transform: rotate(45deg);
    margin: 0;
    padding: 0;

    &.remove,
    &.remove:hover {
      fill: #ff500d;
    }

    &.close {
      fill: #808080;

      &:hover {
        fill: var(--txt-gray);
      }
    }
  }
}

.close {
  opacity: 1;
}

.circle-icon {
  box-shadow: var(--shadow-sm);
  border-radius: 50%;
  width: 24px !important;
  height: 24px !important;
  margin-right: 0.75rem;
  vertical-align: text-top;

  &.bankid-icon {
    background: #fff;
  }

  @media (max-width: 768px) {
    width: 20px !important;
    height: 20px !important;
    margin-right: 0.5rem;
  }
}
/* Modals
-------------------------------------------------- */
dialog[open] {
  all: unset;
}

.modal {
  display: flex !important;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden auto;
  outline: 0;
  z-index: 100;

  &.show {
    background-color: rgb(0 0 0 / 50%);
    transition: opacity 0.3s ease;
  }

  .modal-dialog.security-confirm-modal {
    .modal-body {
      display: block;
    }
  }

  /* Note: .modal-dialog styles are defined outside this block
     because native CSS nesting & does not support BEM concatenation */
}

.modal-dialog {
  max-width: calc(870px - 4rem);
  background-color: var(--contrast-color);
  border-radius: 20px;
  margin: auto;

  .modal-content {
    background-color: var(--contrast-color);
    border-radius: 20px;

    .modal-header {
      border-bottom: none;
      padding: 1.5rem 1.5rem 0;
      align-items: baseline;
      display: flex;

      .modal-title {
        width: 100%;
        display: flex;
        text-transform: none;
        justify-content: space-between;
        font-size: 1.5rem;
        margin-bottom: 0.75em;
      }
    }

    .modal-body {
      padding: 0 1.5rem 1rem;
      display: flex;
      flex-direction: column;
      font-size: var(--txt-xl);
      line-height: 1.4;

      /* captcha image */
      img {
        padding-bottom: 1rem;
      }

      audio {
        margin-bottom: 1rem;
      }

      input {
        background-color: var(--body-gray);
      }

      form {
        margin-top: 0;
      }

      /* move to lists? */
      ol {
        list-style-position: inside;
        list-style-type: decimal;

        li {
          margin-bottom: 1.125rem;

          span {
            margin-top: 0.5rem;
            font-family: var(--inter-bold);
            display: block;
            font-size: var(--txt-md);
          }
        }
      }

      @media (max-width: 823px) {
        font-size: var(--txt-lg);

        input {
          font-size: inherit;

          &::-moz-placeholder {
            font-size: inherit;
          }

          &::placeholder {
            font-size: inherit;
          }
        }
      }
    }

    .modal-footer {
      border-top: none;
      margin: 1rem 1rem 2rem;
      padding-top: 0;
      padding-bottom: 0;
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      text-align: center;
    }
  }

  @media (max-width: 823px) {
    .modal-body {
      font-size: var(--txt-lg);

      input {
        font-size: inherit;

        &::-moz-placeholder {
          font-size: inherit;
        }

        &::placeholder {
          font-size: inherit;
        }
      }
    }
  }
}
/** Table styles **/

table {
  width: 100%;
  font-size: var(--txt-lg);
  font-family: var(--inter-light);
  table-layout: fixed;
  background-color: var(--contrast-color);

  @media (max-width: 768px) {
    font-size: var(--txt-md);
  }

  & tbody {
    margin-bottom: 1rem;

    & th:first-child {
      padding-left: 1rem;
      line-height: 1;
    }

    & td {
      text-align: left;
      vertical-align: middle;
      line-height: 1;

      &.value-status {
        & button {
          margin: 0;
          padding: 0;
        }

        & span {
          font-family: var(--akkurat);
          letter-spacing: 1px;
          font-weight: bold;
          padding: 0;
          font-size: var(--txt-xs);
          text-transform: uppercase;
        }
      }

      .verified {
        text-transform: uppercase;
        font-size: var(--txt-xs);
        font-family: var(--inter-bold);
        font-weight: normal;
      }

      &.remove-data {
        & .icon-button {
          margin: 0;
          padding: 0;
        }
      }

      &.primary {
        color: var(--body-txt);
      }

      &.verified,
      &.unverified,
      &.primary {
        padding: 0.75rem 1rem;
      }

      .btn-remove-webauthn {
        padding: 0;
      }
    }

    & tr {
      &.border-row {
        font-size: var(--txt-xs);
        border-bottom: 1px solid var(--border-gray);
        height: 2rem;

        &:last-of-type {
          border-bottom: none;
        }
      }

      &td:first-child {
        padding-left: 1rem;
        padding-right: 1rem;
      }
    }

    & tr.status {
      height: auto;

      td:last-child {
        text-align: center;

        a {
          font-size: var(--txt-xs);
        }
      }
    }

    & tr.display-none {
      display: none;
    }
  }

  .email-display & {
    tr.display-none {
      display: none;
    }

    tr {
      display: grid;
      grid-template-columns: 3fr 1.5fr 0.5fr;
      gap: 5px;
      align-items: center;
    }

    tr > * {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    tr:not(:last-child) {
      border-bottom: 1px solid var(--body-gray);
    }
  }
}

caption {
  caption-side: top;
  color: inherit;
}

/* Help page list */
.keys,
  /* Security keys in use */
  .active-keys {
  table-layout: auto;
  font-size: var(--txt-sm);

  tr {
    height: auto;
  }

  th {
    border-bottom: 2px dashed var(--border-gray);
    padding: 1rem 0.5rem 0.75rem;

    &:first-child {
      width: 2rem;
    }
  }

  th,
  td {
    vertical-align: top;
    line-height: 1.25;

    &:first-child {
      padding-left: 1rem;
    }

    &:last-child {
      padding-right: 1rem;
    }
  }

  td {
    overflow-wrap: break-word;
    padding: 0.5rem;
  }
}

.keys {
  font-family: monospace;
  color: var(--txt-gray);

  tr {
    &:nth-child(even) {
      background-color: var(--bg-gray);
    }

    th {
      &:first-child {
        width: 2rem;
      }
    }
  }
}

.key-update {
  display: flex;
  align-items: center;
  -moz-column-gap: 2rem;
       column-gap: 2rem;

  label {
    display: inline-block;
  }
}

.table-responsive {
  overflow-x: inherit;
}
/* styles for ordered list with large number */

.listed-steps {
  margin-left: var(--list-indent);
  list-style-type: decimal;

  li {
    font-size: var(--txt-lg);
    line-height: 1.25;
    margin-bottom: 2em;

    &::marker {
      font-size: var(--txt-md);
      font-family: var(--akkurat);
      font-weight: bold;
    }

    fieldset:last-of-type {
      margin-bottom: 0;
    }
  }

  @media (max-width: 568px) {
    /* counteracts additional list left margin in mobile mode */
    .x-adjust {
      margin-left: calc(-1 * var(--list-indent));
    }
  }
}

dl.terms {
  dt {
    font-size: 1.25rem;
    margin-bottom: 0.5em;
  }

  dd {
    margin-bottom: 0.5rem;
    font-size: var(--txt-md);
    display: list-item;
    list-style-position: inside;

    + dt {
      margin-top: 1.5rem;
    }
  }

  margin-bottom: 1rem;
}

.nested {
  margin: 0.5rem 0 0 0.5rem;
  list-style: circle;

  li {
    margin: 0 0 0.75rem 1.75rem;
  }
}

ul.bullets,
ol.numbers {
  list-style-position: inside;
  margin-bottom: 1.5rem;

  > li {
    list-style-position: inside;
    margin-bottom: 1rem;
  }
}

ul.bullets {
  list-style-type: disc;
}

ol.numbers {
  list-style: numeric;
}

ul.bullets ol {
  list-style: numeric;
  list-style-position: inside;
  margin-bottom: 1rem;
  margin-top: 0.5rem;
  margin-left: 1rem;
}
/* White plate to highlight content, use .figure if not semantically a "figure" */

figure,
.figure {
  background: var(--contrast-color);
  text-align: center;
  margin: 1em 0;
  padding: 1em;
  position: relative;

  figcaption,
  .figcaption {
    font-size: var(--txt-sm);
    font-weight: bold;
    font-family: var(--akkurat);
    color: var(--body-txt);
  }

  &.identity-summary {
    padding: 1em 0.5em;
    align-items: center;
    margin: 0;

    @media (max-width: 768px) {
      padding: 0.5em;
    }

    &:not(:last-of-type) {
      border-bottom: 1px solid var(--bg-gray);
    }

    &:last-of-type {
      margin-bottom: 1em;
    }
  }

  &.tight {
    padding: 0.5rem 1rem;
  }

  &.grid-container {
    display: grid;
    grid-template-columns: 10% 35% 50% 5%;
    text-align: left;
    vertical-align: middle;
    line-height: 1;

    > div {
      padding: 0.3rem;
      align-self: center;

      .display-data.verified {
        font-size: var(--txt-md);
      }
    }

    .close {
      align-self: center;
    }
  }
}

.captcha-responsive {
  width: 70%;
  margin-left: auto;
  margin-right: auto;

  button.refresh {
    margin-left: auto;
    margin-right: auto;
  }

  @media (max-width: 768px) {
    width: 100%;

    audio {
      width: 100%;
    }
  }
}

/* white with orange rounded border */
.notice-box {
  padding: 1.25rem 1rem 0.5rem;
  margin: 1rem 0;
  border: 1px solid var(--bright-orange);
  border-radius: 10px;
  background: var(--contrast-color);

  .help-text {
    padding-bottom: 0.75rem;
  }

  ul.bullets {
    list-style-position: inside;
    list-style-type: disc;
    margin-bottom: 1.5rem;
  }
}

/* SECURITY TABLE */
figure.webauthn-token-holder {
  display: grid;
  grid-template-columns: 7% 93%;
  padding: 0.5rem 1rem;
  text-align: left;
  margin: 0;
  border-bottom: 1px solid var(--bg-gray);

  > div span[aria-label="date used"] {
    margin-left: 1.5em;
  }

  img {
    margin-top: 0.3rem;
    width: 80%;
  }

  &:first-of-type {
    margin-top: 1rem;
  }

  &:last-of-type {
    border-bottom: none;
    margin-bottom: 1rem;
  }

  & div:first-child {
    display: flex;
    justify-content: space-between;
  }

  & div:nth-child(2) {
    & p:last-child {
      margin-left: 1rem;
    }
  }

  span {
    font-size: var(--txt-sm);
    margin-bottom: 0.2rem;
  }

  .verified {
    strong {
      font-family: var(--akkurat);
      letter-spacing: 1px;
      font-weight: bold;
      padding: 0;
      font-size: var(--txt-xs);
      text-transform: uppercase;
    }
  }

  .link {
    height: auto;
    margin-right: 2rem;
  }

  button.close {
    justify-self: flex-end;
  }
}
/** Digital timer **/

.expires-meter {
  color: var(--body-txt);
  font-size: var(--txt-xl);
  text-align: center;

  .expires-symbol {
    padding-right: 0.5rem;
    line-height: 1;

    svg {
      height: 1.25rem;
      width: 1.25rem;
    }
  }

  .timer {
    margin-top: 0;
    font-family: var(--akkurat);

    a {
      margin-right: 0.5rem;
    }

    .display-none {
      display: none;
    }

    span#timer-in {
      font-family: var(--akkurat);
      color: var(--txt-gray);
      font-size: var(--txt-md);
    }
  }
}
.help-content > li {
  border-bottom: 1px solid var(--border-gray);
  padding-top: 2rem;
  padding-bottom: 2rem;

  &:last-child {
    border-bottom: none;
  }
}

.help-content {
  article {
    padding-bottom: 1em !important;

    > h5 {
      margin-top: -2rem;
      padding-top: 2rem;
    }
  }

  h3 {
    line-height: 1.2;
    font-size: 1.5rem;
    margin-bottom: 0.75em;
  }

  h4:not(:first-of-type) {
    margin-top: 1.25em;
  }

  p {
    font-size: inherit;
    margin-bottom: 1.25em;
  }

  section {
    padding: 1.25rem 1rem 0.5rem;
    margin: 1rem 0;
    border: 1px solid var(--bright-orange);
    border-radius: 10px;
    background: var(--contrast-color);
  }

  .accordion:not(:last-child) {
    margin-bottom: 1rem;
  }

  dl.link-list {
    margin-bottom: 2rem;

    dt {
      margin-bottom: 0.5rem;
    }

    dd a::before {
      content: "➔ ";
    }
  }
}
table.orcid {
  tr {
    height: auto;

    td {
      &.orcid-link {
        vertical-align: middle;
        padding: 0.75rem 0;
      }

      &:first-of-type,
      &:last-of-type {
        vertical-align: top;
        width: 3rem;
        padding: 0.75rem 1rem;
      }
    }
  }
}

span.orcid-logo {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  background-repeat: no-repeat;
}

/* remove or merge with above? */
.orcid-logo {
  display: inline-flex;
  height: 22px;
  width: 22px;
  position: relative;
}

.orcid-link {
  font-size: var(--txt-md);
  line-height: 1.2;
  overflow-wrap: anywhere;

  a {
    margin: 0;
  }
}

button .orcid-logo {
  height: 22px;
  width: 22px;
}
fieldset.toggle-change-password-options {
  padding-bottom: 2rem;
  margin-bottom: 0.75rem;
  border-bottom: 1px solid var(--border-gray);
}

.pw-suggested {
  margin-top: 1.25rem;
}

.password-custom-help {
  list-style-type: disc;
  margin: 1rem;
}

/* Password strength meter */

.meter-wrapper {
  background: var(--border-gray);
  border-radius: 10px;
  height: 20px;
  overflow: hidden;
  line-height: 0;
  margin-bottom: 1.25rem;

  .form-field-error-area:empty + & {
    display: none;
  }
}

meter {
  width: 100%;
  height: 20px;
  border: none;
  background: repeating-linear-gradient(
    -55deg,
    var(--border-gray),
    var(--border-gray) 10px,
    var(--bg-gray) 10px,
    var(--bg-gray) 20px
  );
}

/* Webkit browsers */
meter::-webkit-meter-bar {
  height: 20px;
  background: repeating-linear-gradient(
    -55deg,
    var(--border-gray),
    var(--border-gray) 10px,
    var(--bg-gray) 10px,
    var(--bg-gray) 20px
  );
}

meter::-webkit-meter-optimum-value {
  background: var(--txt-gray);
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}

/* Works in case we need more steps and colors, eg 1-4. */

/* meter[value="1"]::-webkit-meter-optimum-value { */

/*   background: var(--error-red); */

/* } */

/* Gecko browsers */
:-moz-meter-optimum::-moz-meter-bar {
  background: var(--txt-gray);
}

.form-field-error-area {
  font-size: var(--txt-xs) !important;
  color: var(--error-red) !important;
  font-weight: bold;
  margin-top: 0.75rem;
  display: inline-block;
}

.form-field-error-area.success {
  color: var(--txt-green) !important;
}
/* --- PROFILE STYLES --- // */
.profile-grid-cell {
  display: flex;
  flex-direction: column;

  .display-nin-show-hide {
    display: flex;

    /* show and hide button */
    button {
      margin: 0 0.5rem;
      height: auto;
    }
  }
}

/* stylelint-disable-next-line selector-id-pattern */
#uniqueId-container {
  display: flex;
  flex-direction: row;
  align-items: baseline;

  button.link {
    padding: 0.75rem 0 0.75rem 1rem;
  }
}

.display-data {
  font-size: var(--txt-xl);
  overflow-wrap: break-word;

  &:not(a) {
    font-family: var(--inter-light);
  }

  &.no-data {
    color: var(--txt-gray);
  }

  &.verified {
    color: var(--body-txt);
  }

  @media (max-width: 768px) {
    font-size: var(--txt-lg);

    &:not(a) {
      font-family: var(--inter-light);
    }
  }
}

/* --- STATUS OVERVIEW STYLES--- // */
.status-boxes {
  margin: 1rem 0;
}

.status-box {
  box-shadow: var(--shadow-sm);
  border-radius: 6px;
  overflow: hidden;
  display: grid;
  grid-template-columns: 30px 1fr;
  grid-template-rows: auto;
  gap: 10px;
  align-items: center;
  padding: 1rem;
  background-color: var(--contrast-color);
  margin-top: 0.5rem;
  border: 1px var(--success-green) solid;

  h3 {
    line-height: 1.4;
    margin-bottom: 0.3rem;
    color: var(--body-txt);
  }

  p {
    margin-bottom: 0.5rem;
  }

  &.success {
    border-color: rgb(23 125 77 / 25%);

    &:nth-of-type(1) {
      background-color: #f3f9f5;
      background-color: rgb(23 125 77 / 10%);
    }

    &:nth-of-type(2) {
      background-color: #e6f3eb;
      background-color: rgb(23 125 77 / 20%);
    }

    &:nth-of-type(3) {
      background-color: #daede1;
      background-color: rgb(23 125 77 / 30%);
    }

    &:nth-of-type(4) {
      background-color: #cde7d7;
      background-color: rgb(23 125 77 / 40%);
    }
  }
}

.checkbox-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;

  input[type="checkbox"] {
    display: block;
    width: 20px;
    height: 20px;
  }

  svg {
    color: var(--txt-green);
    height: 1.5rem;

    &.disabled {
      color: var(--border-gray);
    }
  }

  div {
    width: 1.5rem;
    height: 1.5rem;
    border: 2px solid var(--border-gray);
    border-radius: 50%;
    background-color: var(--contrast-color);
  }
}

/* alt option divider */
.or-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  margin: 2rem auto 0;
  color: var(--txt-gray);

  span {
    max-width: 80%;
    text-align: center;
  }

  .line {
    flex: 1;
    height: 1px;
    background-color: var(--border-gray);
  }
}
#suggested-password {
  display: table;
  padding: 0.125rem 0.5rem;
  background: var(--bg-orange);
  font-size: var(--txt-xxl);
  border: none;
  color: var(--bright-orange);
}

.form-content {
  width: 100%;
}

.hide {
  display: none;
}
footer {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  padding: 1rem;
  border-top: 6px solid var(--bright-orange);
  background-color: var(--body-gray);
  font-size: var(--txt-sm);

  .logo-wrapper {
    display: flex;
    align-items: baseline;
    font-size: var(--txt-xs);

    .sunet-logo {
      width: 40px;
      height: 50px;
      margin-right: 8px;
      background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
      background-size: contain;
      background-repeat: no-repeat;
    }
  }
}

footer nav ul {
  display: flex;
  align-items: baseline;
  margin: 0;
  padding: 0;
}

footer nav {
  /* button link lookalike */
  .help-link {
    padding: 0;
    margin-right: 1rem;
    letter-spacing: 1px;
    font-size: var(--txt-sm);
    line-height: 1;
  }

  button {
    height: auto;
    font-size: var(--txt-sm);
    font-weight: normal;
  }
}

footer nav .lang-selected {
  margin: 0;
  cursor: pointer;
  color: var(--txt-orange);
  font-size: var(--txt-sm);
}

#language-selector {
  display: flex;

  button.link {
    svg {
      margin-right: 0.2rem;
    }
  }
}

.non-selected {
  margin: 0;
  display: none;
}

@media (max-width: 414px) {
  footer {
    align-items: flex-end;

    nav ul {
      display: flex;
      flex-direction: column;
      align-items: flex-end;

      .help-link {
        margin-right: 0;
      }
    }
  }
}
/* (desktop first) */

header {
  background-color: var(--contrast-color);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;

  .eduid-logo {
    width: 113px;
    height: 40px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
    background-size: contain;
    background-repeat: no-repeat;
    margin-right: var(--margin);
    display: flex;
    flex: 1;
    text-align: left;

    @media (max-width: 768px) {
      height: 34px;
      width: 95px;
    }
  }

  nav {
    flex: 2;

    .mobile-user-btn {
      display: none;
    }

    .nav-menu {
      display: flex;
      align-items: center;
      justify-content: space-between;

      a {
        transition: none;

        &.active,
        &:hover {
          color: var(--txt-orange) !important;
        }
      }

      /* top level menu item */
      .menu-item-wrapper {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        padding-left: 0.85rem;

        a {
          color: var(--body-txt);
          font-size: var(--txt-sm);
          flex: 1;
        }

        &:has(a.active) {
          background-color: var(--body-gray);
          border-radius: 1.5rem;
          margin: 0.5rem 0 0.25rem;
        }

        /* chevron */
        button {
          background-color: transparent;
          box-shadow: none;
          padding: 0 0.75rem;

          svg {
            color: var(--body-txt);
          }

          @media (max-width: 1200px) {
            &:hover svg {
              color: var(--bright-orange);
            }
          }
        }
      }

      /* note: submenu-open only applied for mobile */
      .submenu,
      .submenu-open {
        li a {
          color: var(--txt-gray);
          font-size: var(--txt-xs);
          display: inline-block;
          padding: 0.625rem 0.85rem;
        }
      }

      .submenu {
        max-height: 0;
        margin-bottom: 0;
        opacity: 0;
        visibility: hidden;
      }

      /* individual desktop submenus */
      @media (min-width: 1200px) {
        li {
          display: inline-block;
        }

        .submenu {
          position: absolute;
          min-width: 10rem;
          z-index: 100;
          padding-top: 0.5rem;
          filter: drop-shadow(var(--shadow-nav));

          li {
            border-bottom: 1px solid var(--body-gray);
            background: var(--contrast-color);
            padding-top: 0.25rem;

            &:first-child {
              border-top-left-radius: 10px;
              border-top-right-radius: 10px;
            }

            &:last-child {
              border-bottom-left-radius: 10px;
              border-bottom-right-radius: 10px;
              padding-bottom: 0.375rem;
            }
          }
        }

        /* visible submenus on hover */
        li:hover {
          svg {
            transform: rotate(180deg);
          }

          .submenu {
            opacity: 1;
            visibility: visible;
            display: flex;
            flex-direction: column;
          }
        }
      }

      .logout-button-wrapper {
        display: flex;
        align-items: center;
      }
    }

    /* 2 items: in desktop header / mobile menu */
    .user-name {
      overflow: hidden;
      max-width: 40vw;
      text-overflow: ellipsis;
      white-space: nowrap;
      display: inline-block;
      padding: 0.5rem 1rem 0.5rem 0;
      font-family: var(--inter-bold);
      font-size: var(--txt-sm);
      text-align: right;
    }
  }

  /* combined mobile menu */
  @media (max-width: 1200px) {
    nav {
      flex: unset;

      .mobile-user-btn {
        display: flex;
        text-transform: lowercase;
        background: none;
        box-shadow: none;
        padding: 0;
        align-items: center;
        color: var(--body-txt);

        svg {
          font-size: 1.5rem;
          width: 24px;
        }

        &:hover svg {
          color: var(--bright-orange);
        }
      }

      .nav-menu {
        display: none;

        ul {
          width: 100%;
        }

        /* visible nav on click */
        &.active {
          display: flex;
          flex-direction: column;
          opacity: 1;
          position: absolute;
          top: 4.5rem;
          right: var(--margin);
          width: 20rem;
          background-color: var(--contrast-color);
          box-shadow: var(--shadow-nav);
          border-radius: 10px;
          padding: var(--margin);
          z-index: 200;
          transition: all 0.5s ease;
        }

        .logout-button-wrapper {
          margin: 0.5rem 0;
          padding-top: 1rem;
          border-top: 1px solid var(--border-gray);
          width: calc(100% - 1.7rem);

          .user-name {
            display: none;
          }
        }

        /* small screen full width menu */
        @media (max-width: 414px) {
          min-width: calc(100% - 2 * var(--margin));
          left: var(--margin);
        }
      }
    }
  }
}
/** Dynamic user communications **/

/* Top notification bar */
.notifications-area {
  width: 100%;
  position: sticky;
  top: 0;
  z-index: 150;
  opacity: 0.95;
}

.alert.alert-dismissible {
  position: relative;
  margin: 0;
  padding: 1rem 0;
  border-radius: 0;

  &.alert-danger,
  &.alert-success {
    color: var(--error-red);
    background-color: var(--bg-orange);
    border: none;
  }

  span {
    padding-right: 0.5rem;

    @media (max-width: 568px) {
      margin: 0;
    }
  }

  .close {
    position: absolute;
    height: 1.5rem;
    width: 1.5rem;
    right: 1rem;
    top: 1rem;
    padding: 0;
    border-radius: 50%;

    &:hover {
      color: var(--bright-orange);
    }

    @media (max-width: 568px) {
      font-size: var(--txt-xs);
    }
  }

  @media (max-width: 568px) {
    padding: 1rem;
  }
}

/* Green italic recommendation, see typography */
.suggestion {
  @media (min-width: 1200px) {
    position: absolute;
    right: 0;
    max-width: 25%;
    top: 1rem;
  }

  .status-box & {
    position: static;
    max-width: 100%;
  }

  .options & {
    margin: 1rem auto 0;
    width: 75%;
  }
}

/* Hover info bubble */
.custom-tooltip-wrapper {
  position: relative;
  display: inline-block;

  .trigger {
    width: 2.25rem;
    height: 2.25rem;
    min-width: 2.25rem;
    min-height: 2.25rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: var(--contrast-color);
    margin-left: 0.5rem;
    box-shadow: none;
    border-radius: 50%;
    color: var(--txt-orange);

    &:hover {
      transform: scale(0.8);
    }

    svg {
      pointer-events: none;
      height: 1em;
    }

    @media (max-width: 414px) {
      width: 2rem;
      height: 2rem;
      min-width: 2rem;
      min-height: 2rem;
    }
  }

  .custom-tooltip-popover {
    position: absolute;
    top: 110%;
    transform: translateX(-50%);
    z-index: 1000;
    min-width: 250px;
    max-width: 260px;
    box-shadow: var(--shadow-md);
    border-radius: 10px;
    background: var(--contrast-color);
    padding: 1rem 1rem 1.125rem;

    @media (max-width: 823px) {
      transform: translateX(-82.5%);
    }
  }
}
/** Reset pw flow specific styles **/

.description-without-security {
  margin-top: 1.5rem;
}

#reset-password-form {
  margin-top: 0;

  &.form-group {
    margin-bottom: 0;
  }
}

@media (max-width: 568px) {
  #reset-password-form {
    flex-direction: column;
    align-items: unset;

    & #reset-password-button {
      width: 100%;
      margin-left: 0;
    }
  }
}
/** Signup flow specific styles **/

h3 {
  &.register-header {
    margin-top: 0;
    margin-bottom: 1rem;
  }
}

#captcha {
  transform: scale(1.2);
  transform-origin: 0 0;
  margin-bottom: 2rem;
}

#resend-button {
  width: -moz-fit-content;
  width: fit-content;
  justify-content: center;
}

.signup-timer-wrapper {
  display: flex;
  align-items: center;

  span {
    margin-right: 0.5rem;
  }
}

@media (max-width: 568px) {
  #resend-button {
    width: 100%;
  }
}

@media (max-width: 414px) {
  #captcha {
    transform: scale(0.9);
    margin-bottom: 0;
  }

  .captcha {
    margin: 0;
  }
}

/* TODO: consider using --bp-xs (414px) instead of hardcoded 375px.
   375px matches iPhone SE/6/7/8 portrait — likely a targeted fix for text overflow on small phones. */
@media (width <= 375px) {
  #resend-button {
    font-size: var(--txt-xs);
  }
}

.enter-code,
.expiration-info {
  form {
    margin-bottom: 1.25rem;
  }

  /* TODO: This is a duplicate of the same things from Other Device */

  @media (max-width: 768px) {
    .response-code-inputs {
      input {
        margin: 5px -1px 5px 0;
        height: 3rem;
        width: 2.5rem;

        &:nth-child(4) {
          margin-right: 1rem;
        }
      }
    }
  }

  @media (max-width: 414px) {
    .response-code-inputs {
      display: flex;
      justify-content: space-around;
    }
  }
}

.response-code-inputs {
  input {
    display: inline-block;
    border: 2px solid var(--border-gray);
    font-size: 1.75rem;
    margin: 5px;
    height: 4rem;
    width: 3.5rem;
    text-align: center;
    border-radius: 5px;
    outline: none;

    &:focus {
      box-shadow: none;
      position: relative;
    }

    &:nth-child(4) {
      margin-right: 1.5rem;
    }
  }

  &:first-child {
    margin-left: 0;
  }
}

section#register-with-name,
.register-password {
  margin-top: 2rem;
}

.with-digital-id .buttons {
  margin-top: 1rem;
}

.digital-id-option {
  > div {
    padding: 0.5rem 1rem;
    border: 1px var(--success-green) solid;
    border-radius: 6px;
    margin-top: 1rem;

    button#signup-eidas img {
      background: white;
      padding: 5px;
      -o-object-fit: contain;
         object-fit: contain;
    }
  }

  .flex-column {
    display: flex;
    flex-direction: row;
    align-items: center;

    p {
      margin: 0;
    }
  }
}

/* signup recommendation-box  */

.access-requirements {
  margin: 1.5rem 0;
}

.recommendation-box {
  display: flex;
}

.recommendation-box span {
  background-color: var(--success-green);
  height: -moz-max-content;
  height: max-content;
  color: white;
  font-size: 13px;
  font-weight: 800;
  padding: 2px 5px;
}
/** Content wrapping load spinner **/

#eduid-splash-and-children {
  position: relative;
  display: flex;
  flex: 1;
  flex-direction: column;
}

#eduid-splash-spinner {
  height: 100%;
  width: calc(100% + 2 * (var(--border-width)));
  left: -var(--border-width);
  background-color: var(--body-gray);
  position: absolute;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;

  /* Pure-CSS loading spinner: a rotating conic-gradient arc, masked to a ring. */
  .spinner {
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 50%;
    color: var(--txt-gray);
    background: conic-gradient(from 0deg, transparent 0 8%, currentcolor);
    -webkit-mask: radial-gradient(farthest-side, transparent calc(100% - 4px), #000 0);
            mask: radial-gradient(farthest-side, transparent calc(100% - 4px), #000 0);
    animation: splash-spin 1s linear infinite;
  }
}

@keyframes splash-spin {
  to {
    transform: rotate(1turn);
  }
}

@media (prefers-reduced-motion: reduce) {
  #eduid-splash-spinner .spinner {
    animation-duration: 5s;
  }
}
.error-page {
  h1 {
    color: var(--error-red);
  }

  & span {
    line-height: 1.5;
    font-family: var(--inter-bold);
    font-size: var(--txt-xxl);
  }

  & ul {
    margin-bottom: 3.5rem;
    font-size: var(--txt-xl);

    div {
      margin-left: 2rem;

      li:nth-child(1),
      li:nth-child(3),
      li:nth-child(5) {
        list-style-type: disc;
        margin-top: 1rem;
        font-family: var(--inter-bold);
      }

      li:nth-child(even) {
        margin-top: 0;
      }
    }
  }

  & li {
    line-height: 1.5;
    font-family: var(--inter-regular);
    margin-top: 24px;
  }

  & .technical-info-heading span {
    font-family: var(--inter-bold);
    font-size: var(--txt-xl);
  }

  & .technical-info-box {
    background-color: var(--contrast-color);
    padding: 1rem;

    .technical-info-text {
      display: flex;
      justify-content: flex-start;

      p {
        font-size: var(--txt-md);
        padding-bottom: 0;
      }

      p:first-child {
        text-transform: uppercase;
        font-family: var(--inter-bold);
        width: 8.125rem;
        padding-right: 1rem;
      }

      p:last-child {
        color: var(--error-red);
      }
    }
  }

  .specific-error {
    margin-bottom: 1.5rem;
  }
}

/* small reddish alert with exclamation symbol */
.warning-text {
  color: var(--error-red);
  font-size: var(--txt-sm);

  .warning-symbol {
    padding-right: 0.5rem;
  }
}

@media (max-width: 568px) {
  .technical-info-text {
    flex-direction: column;

    p:last-child {
      color: var(--error-red);
    }
  }
}

.error-info {
  text-align: left;
  font-size: var(--txt-md);

  tr {
    height: auto;
  }

  td:not(.plain-cell) {
    &:first-child {
      text-transform: uppercase;
      padding-left: 0;
    }

    &:last-child {
      color: var(--error-red);
    }
  }

  th,
  td {
    padding: 0.325rem 0;

    &:last-child {
      width: 70%;
    }
  }
}
/* username and password */
.username-pw {
  margin-bottom: 2rem;

  form {
    margin-top: 0;

    .form-group {
      margin-bottom: var(--margin);
    }

    .welcome-back-container {
      margin: 0 0 1rem;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;

      @media (max-width: 568px) {
        flex-direction: column;
        align-items: flex-start;

        h3 {
          margin-bottom: 0.5em;
        }
      }

      legend {
        font-size: 1.375rem;
        margin-bottom: 0.75em;
        display: block;
        width: -moz-fit-content !important;
        width: fit-content !important;
      }
    }

    .links {
      a {
        margin: 0.25rem 0;
        display: inline-block;
      }

      @media (max-width: 1200px) {
        margin-top: 1rem;
      }
    }

    .flex-between {
      flex-direction: row;
      text-align: right;

      @media (max-width: 1200px) {
        flex-direction: column;
        text-align: center;
      }
    }
  }
}

/* multi-factor authentication */
.options {
  display: flex;
  justify-content: center;
  flex-flow: column;
  align-items: center;
  margin-top: var(--margin);
  position: relative;

  .option-wrapper {
    width: 330px;
    margin-bottom: 2rem;

    .option {
      border-radius: 20px;
      background: var(--contrast-color);
      box-shadow: var(--shadow-md);
      padding: 1rem;
      min-height: 210px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      h3 {
        font-size: var(--txt-xl);
      }

      h3,
      .help-text {
        margin: 0;
      }

      /* duplicate in _buttons.scss? */
      .icon {
        background: transparent;
        padding: 0;
        margin: 0;
        height: auto;
        border: none;

        svg {
          color: var(--body-txt);
          height: 1rem;
          width: 1rem;
        }
      }

      .bottom {
        align-items: flex-end;

        img {
          max-width: 178px;
        }
      }
    }

    @media (max-width: 414px) {
      width: 100%;
    }
  }

  .help-text {
    text-align: center;
    margin-bottom: 2rem;
  }
}

/* use another device */
.use-another-device {
  &.device1 {
    .response-code-inputs {
      background: var(--contrast-color);
      text-align: center;
      margin: 1em 0;
      padding: 1em;
      position: relative;
      margin-bottom: 0;
    }

    .input-validate-error {
      margin-top: 0.5rem;
      display: inline-block;
    }

    .buttons {
      margin-top: 1rem;
    }
  }

  &.device2 .response-code-inputs {
    input {
      border: none;
      width: 1.75rem;
      padding: 0;

      &:nth-child(3) {
        margin-right: 1rem;
      }
    }
  }

  .expiration-info {
    position: relative;

    @media (max-width: 568px) {
      margin-left: calc(-1 * var(--list-indent));
    }
  }

  .expires-meter {
    margin-top: 1.5rem;

    @media (min-width: 768px) {
      position: absolute;
      bottom: 0.5rem;
      right: 0;
    }
  }

  form.response-code-form {
    margin-top: 0;
  }

  .finished.device2 {
    /* TODO: \$warning_size was an unused SCSS variable — remove or convert to --warning-size if needed */

    /* \$warning_size: 1.5rem; */

    display: flex;
    flex-direction: column;
    row-gap: 1rem;

    .response-code-form {
      align-items: center;
    }
  }

  .listed-steps {
    figure {
      img.qr-code {
        width: 200px;
      }
    }

    @media (max-width: 568px) {
      .x-adjust {
        margin-left: calc(-1 * var(--list-indent));
      }
    }
  }

  .developer {
    /* show QR URL at the bottom for non-production environments */
    height: 10rem;
    font-size: var(--txt-xs);
    overflow: hidden;
    word-break: break-all;
  }
}

/* security zone info */
section.intro .status-box {
  margin-bottom: 2rem;

  &.passkey {
    display: block;
  }
}

section.username-pw-option {
  margin-bottom: 1.5rem;

  a {
    text-align: right;
    margin-bottom: 1rem;
  }

  fieldset.border-toggle-area {
    margin-top: 1.5rem;
  }
}

section.other-device-option .buttons {
  margin-top: 1rem;
  margin-bottom: 1.5rem;
}

/* Remove margin-bottom from password field to eliminate extra space above forgot password link */
section.username-pw-option form .form-group:nth-of-type(2) {
  margin-bottom: 0;
}

.passkey-option .status-box {
  display: block;
  background-color: transparent;
  border: 0 solid !important;
  box-shadow: none;
  padding: 0;
  margin-bottom: 1.5rem;

  .text-wrapper {
    img {
      width: 6rem;
      margin-left: 1rem;
    }
  }

  .buttons {
    justify-content: space-between;
    align-items: center;
  }
}

section.add-key-section {
  margin-top: 1rem;
  position: relative;
}
/** Edit name form **/

.personal-data {
  .title {
    margin-bottom: 1.25rem;
  }

  @media (max-width: 414px) {
    .button-pair {
      flex-direction: column;
    }
  }

  .heading,
  .title {
    display: flex;
    justify-content: space-between;
    align-items: baseline;

    .link {
      height: 100%;
    }

    .close {
      padding: 0;
      border-radius: 0;
    }
  }

  .edit-data {
    background-color: var(--contrast-color);
    padding: 1rem;
  }
}

#add-personal-data {
  align-self: unset;
}

.personal-data-info {
  display: flex;
  flex-wrap: wrap;
}

/* styles for input on white bg */
.edit-data {
  p.verified {
    padding-bottom: 0;
  }
}

/* styles for displayed names */
.external-names {
  display: flex;
  flex-wrap: wrap;
  flex: 1;
  margin-bottom: 0;
}

.external-names,
.personal-data-info {
  .profile-grid-cell {
    flex: 1;
    flex-basis: 47%;
    justify-content: unset;
    margin: 0 1rem 1rem 0;
  }
}
.ladok {
  svg {
    transform: none;
  }

  input {
    height: initial;
  }

  label {
    &.flex-between {
      margin-right: 0;
    }
  }
}

.ladok-university {
  @media (max-width: 768px) {
    flex-direction: column;

    &.flex-between {
      align-items: flex-start;
    }
  }

  @media (min-width: 768px) {
    label {
      margin-bottom: 0;
    }
  }
}

.ladok-university-name {
  flex-grow: 1;
  text-align: right;
  white-space: nowrap;
}

.ladok-universities-status {
  color: var(--error-red);
  font-size: var(--txt-md);
}
/** React-select style overrides, final-form element prefixed by "react-select" **/
/* stylelint-disable selector-class-pattern */

form .react-select__control,
.basic-multi-select .select__control,
.select--is-disabled .select__control {
  border: 2px solid var(--border-gray);
  background-color: var(--contrast-color);
  color: var(--body-txt);

  .react-select__indicator {
    color: var(--txt-gray);
  }

  .react-select__single-value {
    color: var(--txt-gray);
  }

  &--is-disabled {
    background-color: var(--bg-gray);
    font-size: var(--txt-xl);

    * {
      color: var(--txt-gray);
    }

    .select__indicators {
      display: none;
    }
  }
}

form .react-select__menu,
.basic-multi-select .select__menu,
.select--is-disabled .select__menu {
  color: var(--body-txt);
  background-color: var(--contrast-color);
}

form .react-select__control:hover,
.basic-multi-select .select__control:hover,
.select--is-disabled .select__control:hover {
  border: 2px solid var(--txt-gray);
  box-shadow: none;
}

/* also focus-visible */
form .react-select__control--is-focused,
.basic-multi-select .select__control--is-focused,
.select--is-disabled .select__control--is-focused {
  outline: 2px dashed var(--body-txt) !important;
  box-shadow: none;
}

form .react-select__indicator-separator,
.basic-multi-select .select__indicator-separator,
.select--is-disabled .select__indicator-separator {
  width: 0;
}

form .react-select__placeholder,
.basic-multi-select .select__placeholder,
.select--is-disabled .select__placeholder {
  font-family: var(--inter-regular);
  color: var(--body-txt);
}

form .react-select__option--is-focused,
.basic-multi-select .select__option--is-focused,
.select--is-disabled .select__option--is-focused {
  background-color: var(--bg-orange);
  outline: 1px dashed var(--body-txt) !important;
  outline-offset: -1px;
}

form .react-select__option--is-selected,
.basic-multi-select .select__option--is-selected,
.select--is-disabled .select__option--is-selected {
  color: var(--txt-gray);
  background-color: inherit;
  font-family: var(--inter-bold);
  font-weight: normal;
}

.select-group {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 0.75rem;
  gap: 0.5rem;

  > div:nth-child(1) {
    flex: 2;
  }

  > div:nth-child(2) {
    flex: 1;
  }

  .select__control,
  div.default-surname {
    min-height: 3rem;
  }

  input {
    height: auto;

    &:focus {
      box-shadow: none;
    }
  }

  @media (max-width: 768px) {
    > div:nth-child(1) {
      flex: 1;
    }
  }

  @media (max-width: 568px) {
    flex-direction: column;

    > div {
      width: 100%;
    }
  }

  div.default-surname {
    display: inline-block;
    border: 2px solid var(--border-gray);
    border-radius: 4px;
    padding: 6px 12px;
    cursor: not-allowed;
    background-color: var(--bg-gray);
    color: var(--txt-gray);
    font-size: var(--txt-xl);
  }
}

/* login react select */
.mfa-select {
  height: 3rem;
  min-width: 100px;
  padding: 0 1.125rem;

  .react-select__placeholder {
    color: var(--txt-orange);
    font-family: var(--akkurat);
    text-transform: uppercase;
    font-weight: bold;
    font-size: var(--txt-md);
  }

  .css-tj5bde-Svg {
    color: var(--txt-orange);
  }

  .react-select__control {
    display: flex;
    height: 3rem;
    align-items: center;
    background-color: var(--contrast-color);
    border-radius: 1.5rem;
    cursor: pointer;
    border: solid 2px var(--bright-orange);

    &.react-select__control--is-disabled {
      cursor: not-allowed;
      pointer-events: all !important;
      background-color: var(--btn-orange);
      border-color: inherit;
      color: #fff;
      opacity: 0.4;

      .react-select__placeholder {
        color: var(--contrast-color);
      }

      svg.css-tj5bde-Svg {
        display: none;
      }
    }
  }

  .react-select__control:hover {
    border: solid 2px var(--bright-orange);
  }

  .react-select__value-container {
    height: 3rem;
    padding: 0;
    text-align: center;

    .react-select__single-value {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .react-select__menu {
    width: 90%;
    background-color: var(--contrast-color);
  }

  .react-select__menu-list {
    .react-select__option {
      display: flex;
      align-items: center;
    }
  }

  .select-option-text {
    color: var(--txt-orange);
    font-family: var(--akkurat);
    font-weight: bold;
  }
}

.mfa-select__control--is-focused {
  border-color: transparent;
}

.mfa-select__control:not(.custom-select__control--is-focused) {
  border-color: transparent;
}

/* stylelint-enable selector-class-pattern */
/* Accordion */

.accordion {
  box-shadow: var(--shadow-sm);
  border: 2px solid var(--border-gray);
  border-radius: 6px;

  form {
    margin-top: 0;
  }

  & details {
    & + details {
      border-top: 2px solid var(--border-gray);
    }

    &:first-of-type summary > div {
      border-radius: 4px 4px 0 0;
    }

    &:last-of-type summary > div {
      border-radius: 0 0 4px 4px;
    }

    &:last-of-type[open] summary > div {
      border-radius: 0;
    }

    &:last-of-type > .accordion-panel {
      border-radius: 0 0 4px 4px;
    }

    /* single item */
    &:only-of-type summary > div {
      border-radius: 4px;
    }

    &:only-of-type[open] summary > div {
      border-radius: 4px 4px 0 0;
    }

    &:only-of-type > .accordion-panel {
      border-radius: 0 0 4px 4px;
    }

    &[open] > summary > div {
      background: var(--bg-orange);
    }

    & summary {
      list-style: none;

      &::marker,
      &::-webkit-details-marker {
        display: none;
      }


      & > div {
        display: flex;
        cursor: pointer;
        background: var(--bg-gray);
        color: var(--txt-orange);
        position: relative;
        align-items: center;
        padding: 1rem;
        font-family: var(--akkurat);
        font-weight: bold;
        transition: all 0.1s ease-in;

        &:hover {
          background: var(--btn-orange);
          color: var(--contrast-color);

          & h3 {
            text-decoration: underline;
          }
        }

        & > span:first-child {
          & svg {
            text-align: center;
            font-size: var(--txt-sm);
            margin-right: 10px;
          }

          & + div {
            flex: 1;
            margin-right: 1.5rem;
          }
        }

        & h3 {
          font-family: var(--akkurat);
          font-size: var(--txt-lg);
          line-height: 1.4;
          margin-bottom: 0;

          @media (max-width: 768px) {
            font-size: var(--txt-md);
          }
        }

        & > div > span {
          font-size: var(--txt-xs);
          display: block;
          margin-bottom: 0;
        }

        /* stylelint-disable-next-line selector-class-pattern */
        & > svg.svg-inline--fa.fa-chevron-up,  
        /* stylelint-disable-next-line selector-class-pattern */
        & > svg.svg-inline--fa.fa-chevron-down {
          position: absolute;
          right: 1rem;
        }
      }
    }

    & > .accordion-panel {
      background-color: var(--contrast-color);
      padding: 1.5rem 1rem;
      animation: fadein 0.2s ease-in;

      @keyframes fadein {
        0% {
          opacity: 0;
        }

        100% {
          opacity: 1;
        }
      }
    }
  }

  /* Nested variant: card-like display for internal accordion groups */
  &.nested {
    border: none;
    box-shadow: none;
    border-radius: 0;

    & details {
      margin-bottom: 10px;
      border: 2px solid var(--border-gray);
      border-radius: 6px;

      & + details {
        border-top: 2px solid var(--border-gray);
      }

      &:hover {
        border-color: var(--bright-orange);

        &[open] {
          border-color: var(--border-gray);
        }
      }

      &[open] > summary > div {
        background: var(--bg-orange);
      }

      & summary > div {
        border-radius: 4px;

        &:hover {
          color: var(--contrast-color);
          background: var(--btn-orange);
        }

        & h3 {
          font-size: var(--txt-md);
          text-transform: uppercase;
          letter-spacing: 1px;
        }
      }

      & > .accordion-panel {
        padding: 1rem 1rem 1.25rem;
        border-radius: 0 0 4px 4px;

        & p {
          font-size: var(--txt-lg);
          line-height: 1.25;
        }
      }
    }
  }
}
/* Pre login/register root landing page */

.landing {
  background-image: radial-gradient(
    ellipse at 112% 100%,
    var(--body-gray) 0,
    var(--body-gray) 45%,
    #fafafa 45%,
    #fafafa 75%,
    var(--contrast-color) 75%
  );

  header,
  .panel,
  footer {
    background-color: transparent;
  }

  footer {
    border-top: none;
  }
}

.landing-content {
  h1 {
    font-size: 2.75rem;
    margin-bottom: 0.75em;

    @media (max-width: 768px) {
      font-size: 2rem;
    }
  }

  p {
    &.med-txt {
      font-size: var(--txt-sm) !important;
    }
  }

  .buttons {
    padding: 0.25rem 0 1rem;
  }
}

.landing-how-to {
  filter: drop-shadow(0 -6px 0 var(--shadow-green));
  transform: translateZ(0); /* prevent weird Safari filter bug */
  align-items: flex-end;
  box-shadow: 0 10px 10px -10px rgb(89 89 89 / 50%);
  overflow: hidden;
  margin-top: 1rem;

  div {
    flex: 1;
    padding: 4rem 3rem 2.5rem;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-left: -1rem;
    margin-right: -1rem;
    border-radius: 100% 100% 0 0;
    font-family: var(--inter-medium);
    font-size: var(--txt-sm);
    color: var(--txt-gray);

    &:nth-of-type(1) {
      background-color: #f3f9f5;
      margin-top: 1rem;
    }

    &:nth-of-type(2) {
      background-color: #e6f3eb;
    }

    &:nth-of-type(3) {
      background-color: #daede1;
    }

    &:nth-of-type(4) {
      background-color: #cde7d7;
      padding-top: 5rem;
    }
  }

  .icon-holder {
    margin-top: 0.5rem;

    img,
    svg {
      width: auto;
      height: 24px;
      margin: 5px;
    }
  }

  @media (min-width: 823px) {
    max-width: calc(870px + 4rem);
    margin: 1rem auto 2rem;
    border-radius: 0 0 4rem 3rem;
  }

  @media (max-width: 823px) {
    margin: 1rem auto 0;

    div {
      padding: 3rem 2rem 2rem;

      &:nth-of-type(4) {
        padding-top: 3rem;
      }
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    margin: 1rem 0 0.5rem;

    div {
      width: calc(100% + 4rem);
      margin-left: 0;
      margin-right: 0;
      margin-bottom: -5rem;
      padding: 3.5rem 3rem 6rem;

      &:nth-of-type(4) {
        padding-bottom: 4rem;
        margin-bottom: 0;
      }
    }
  }
}
/* System/browser set dark mode overrides */

html.dark {
  --contrast-color: #000;
  --body-txt: #f4f4f4;
  --body-gray: #2e2e2e;
  --txt-gray: #bdbdbd;
  --border-gray: #5e5e5e;
  --txt-orange: #ff6d32;
  --bg-orange: #36251e;
  --error-red: #ff5965;
  --error-red-t: #ff596580; /* with 50% transparency */
  --bg-gray: #202020;
  --shadow-green: #177d4d; /* success green */
  --txt-green: #30d98a;

  /* header and footer */
  header .eduid-logo {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___}) !important;
  }

  footer .sunet-logo {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___}) !important;
  }

  .header-user {
    color: #fff;
  }

  @media (max-width: 1200px) {
    header nav .nav-menu.active {
      box-shadow: 0 -6px 17px rgb(89 89 89 / 30%);
    }
  }

  @media (min-width: 1200px) {
    header nav .nav-menu .submenu {
      filter: drop-shadow(0 -6px 17px rgb(89 89 89 / 30%));
    }
  }

  /* landing and start page */
  .status-box.success,
  .landing-how-to div {
    color: #fff;

    &:nth-of-type(1) {
      background-color: #15221a;
    }

    &:nth-of-type(2) {
      background-color: #273e30;
    }

    &:nth-of-type(3) {
      background-color: #355543;
    }

    &:nth-of-type(4) {
      background-color: #3b634c;
    }
  }

  .landing {
    background-image: radial-gradient(
      ellipse at 112% 100%,
      var(--body-gray) 0,
      var(--body-gray) 45%,
      var(--bg-gray) 45%,
      var(--bg-gray) 75%,
      var(--contrast-color) 75%
    );
    color: var(--body-txt);

    .icon-holder {
      color: #fff;

      /* success green color */
      img {
        filter: brightness(0) saturate(100%) invert(94%) sepia(19%) hue-rotate(24deg) contrast(105%);
      }
    }
  }

  .step-container {
    background-color: var(--bg-gray);
    box-shadow: 0 -6px 17px rgb(89 89 89 / 30%);

    figure,
    #copy-new-password {
      background-color: #273e30;
    }

    .step-indicator .step-item:not(.active, .completed) .step-number {
      background-color: var(--contrast-color);
    }
  }

  button.secondary,
  button.secondary:not(:disabled, .disabled):active,
  button.secondary:not(:disabled, .disabled):focus,
  button.secondary:not(:disabled, .disabled):active:focus,
  button.secondary:not(:disabled, .disabled):hover,
  /* stylelint-disable-next-line selector-class-pattern */
  .mfa-select .react-select__placeholder,
  /* stylelint-disable-next-line selector-class-pattern */
  .mfa-select .react-select__single-value .select-option-text {
    color: #fff;
  }

  .remove {
    filter: invert(97%) sepia(0%) saturate(7500%) hue-rotate(295deg) brightness(105%) contrast(102%);

    &:hover {
      filter: var(--bright-orange-filter);
    }
  }

  /* form */
  input:disabled,
  input[readonly] {
    background-color: var(--bg-gray);
  }

  input:focus {
    color: var(--body-txt);
  }

  input:is(:-webkit-autofill, :-webkit-autofill) {
    color: var(--txt-gray) !important;
    -webkit-text-fill-color: var(--txt-gray) !important;
  }

  input:is(:-webkit-autofill, :autofill),
  input:-internal-autofill-selected {
    color: var(--txt-gray) !important;
    -webkit-text-fill-color: var(--txt-gray) !important;
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    color: var(--txt-gray) !important;
    -webkit-text-fill-color: var(--txt-gray) !important;
  }

  /* Akkurat less legible in the dark, possibly add letter-spacing as well */
  a {
    font-weight: bold;
  }

  ::-moz-placeholder {
    color: var(--txt-gray) !important;
    opacity: 1; /* Firefox */
  }

  ::placeholder {
    color: var(--txt-gray) !important;
    opacity: 1; /* Firefox */
  }

  .modal.show {
    background-color: rgb(46 46 46 / 75%);
  }
}
/* Plate to highlight content, with numbered steps at bottom.  */

.step-container {
  background-color: white;
  padding: 1rem 1.5rem;
  box-shadow: var(--shadow-sm);

  @media (min-width: 568px) {
    margin: 0 -1.5rem;
  }

  h1 {
    margin-bottom: 0.25em;
  }

  .destination-info {
    color: var(--txt-green);
    font-size: var(--txt-md);

    span {
      text-transform: uppercase;
    }
  }

  .lead {
    margin-bottom: 1.5rem;
    margin-top: 1rem;

    p {
      color: var(--txt-gray);
    }
  }

  .digital-id-option .buttons button.primary.sm {
    align-self: center;
    height: 33px;
    padding: 0 1rem;

    img.circle-icon {
      width: 18px !important;
      height: 18px !important;
    }

    span {
      display: inline-block;
      line-height: normal;
      vertical-align: middle;
    }
  }

  img.passkey-image {
    width: 5rem !important;
  }

  .mfa-alternative {
    border: 1px var(--success-green) solid;
    border-radius: 6px;
    padding: 1rem;
    margin-bottom: 1.5rem;
    margin-top: 1.5rem;

    .wizard-link-wrapper {
      padding-top: 0;

      button {
        height: 2rem;
      }
    }
  }

  figure {
    background-color: #daede1;

    &.signin-details {
      text-align: left;
    }
  }

  .heading {
    display: flex;
    justify-content: space-between;
    align-items: baseline;

    @media (max-width: 568px) {
      flex-direction: column;
      margin-bottom: 1rem;
    }
  }

  #copy-new-password {
    background-color: #daede1;
  }

  .hint {
    font-size: 14px !important;
    font-style: italic;
    border: 1px solid green;
    border-radius: 6px;
    padding: 1rem;
    margin-top: 0.5rem;
  }

  .border-line {
    margin-top: 1.5rem;
  }

  .step-indicator {
    display: grid;
    justify-items: center;
    margin-bottom: 1rem;

    &.steps-5 {
      grid-template-columns: repeat(5, 1fr);
    }

    &.steps-6 {
      grid-template-columns: repeat(6, 1fr);
    }

    .step-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 0.5rem;

      .step-number {
        width: 2.25rem;
        height: 2.25rem;
        border-radius: 50%;
        background-color: var(--bg-gray);
        color: var(--body-txt);
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        font-family: monospace;
        font-size: var(--txt-sm);
      }

      .step-label {
        font-size: var(--txt-xs);
        text-align: center;
        color: var(--txt-gray);
        padding: 0 0.25rem;
      }

      &.completed .step-number {
        background-color: #cde7d7;
        color: #161616;
      }

      &.active .step-number {
        background-color: var(--success-green);
        color: #f4f4f4;
      }

      &.active .step-label {
        font-weight: bold;
        color: var(--body-txt);
      }
    }

    @media (width <= 768px) {
      .step-item .step-label {
        display: none;
      }
    }
  }

  .edit-data {
    padding: 0;
    background-color: transparent;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/index.css","webpack://./src/styles/reset.css","webpack://./src/styles/variables.css","webpack://./src/styles/fonts.css","webpack://./src/styles/typography.css","webpack://./src/styles/base.css","webpack://./src/styles/forms.css","webpack://./src/styles/inputs.css","webpack://./src/styles/label.css","webpack://./src/styles/buttons.css","webpack://./src/styles/links.css","webpack://./src/styles/img.css","webpack://./src/styles/modals.css","webpack://./src/styles/tables.css","webpack://./src/styles/lists.css","webpack://./src/styles/figure.css","webpack://./src/styles/timer.css","webpack://./src/styles/Help.css","webpack://./src/styles/AccountLinking.css","webpack://./src/styles/ChangePassword.css","webpack://./src/styles/DashboardMain.css","webpack://./src/styles/Emails.css","webpack://./src/styles/Footer.css","webpack://./src/styles/Header.css","webpack://./src/styles/Notifications.css","webpack://./src/styles/ResetPassword.css","webpack://./src/styles/SignupMain.css","webpack://./src/styles/Splash.css","webpack://./src/styles/Errors.css","webpack://./src/styles/Login.css","webpack://./src/styles/PersonalData.css","webpack://./src/styles/Ladok.css","webpack://./src/styles/reactSelect.css","webpack://./src/styles/accordion.css","webpack://./src/styles/landingPage.css","webpack://./src/styles/darkmode.css","webpack://./src/styles/StepContainer.css"],"names":[],"mappings":"AAAA,+FAA+F;;ACA/F,0CAA0C;;AAE1C;;;CAGC;;AAED;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAiFE,SAAS;EACT,UAAU;EACV,SAAS;EACT,eAAe;EACf,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA,gDAAgD;AAChD;;;;;;;;;;;EAWE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;AACd;;AAEA;;;;EAIE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;ACxIA,qDAAqD;;AAErD;;+EAE+E;;AAE/E,2CAA2C;AAC3C;EACE,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB,EAAE,oBAAoB;EACzC,sBAAsB;EACtB,qBAAqB,EAAE,2BAA2B;EAClD,oBAAoB;EACpB,oBAAoB;EACpB,wBAAwB,EAAE,0BAA0B;EACpD,kBAAkB;EAClB,uBAAuB;EACvB,oBAAoB;EACpB;kCACgC;EAChC,wBAAwB,EAAE,sBAAsB;EAChD,qBAAqB,EAAE,oBAAoB;EAC3C,wBAAwB;;EAExB;;iFAE+E;EAC/E,kEAAkE,EAAE,gCAAgC;EACpG,oEAAoE;EACpE,kEAAkE;EAClE,gEAAgE;EAChE,wDAAwD;EACxD,iBAAiB,EAAE,SAAS;EAC5B,kBAAkB,EAAE,SAAS;EAC7B,cAAc,EAAE,8BAA8B;EAC9C,kBAAkB,EAAE,SAAS;EAC7B,iBAAiB,EAAE,SAAS;EAC5B,mBAAmB,EAAE,SAAS;EAC9B,kBAAkB;EAClB,cAAc;EACd,sBAAsB;;EAEtB;;iFAE+E;EAC/E,mBAAmB;;EAEnB;;iFAE+E;EAC/E,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;EAC1C,4CAA4C;AAC9C;;AAEA;;+EAE+E;;AAQ/E,uBAAuB;ACpEvB;EACE,oBAAoB;EACpB,uHAA0G;EAC1G,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB;2DACkD;EAClD,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B;2DACsD;EACtD,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB;4DACoD;EACpD,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B;4DACqD;EACrD,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB;4DACmD;EACnD,mBAAmB;EACnB,kBAAkB;AACpB;AC7CA,2BAA2B;;AAE3B;;;;;;;EAOE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,mBAAmB;;EAEnB;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,+BAA+B;;EAE/B;IACE,kBAAkB;EACpB;AACF;;AAEA;;EAEE,iBAAiB;EACjB,qBAAqB;;EAErB;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;;EAErB;IACE,kBAAkB;EACpB;AACF;;AAEA;;EAEE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;;EAEE,+BAA+B;EAC/B,yBAAyB;EACzB,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,2CAA2C;;EAE3C;IACE,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;;IAEjB;MACE,wBAAwB;IAC1B;EACF;AACF;;AAEA;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,mBAAmB;;EAEnB;IACE,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,yEAAyE;AACzE;;;EAGE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;EAEE,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,cAAc;EACd,mBAAmB;;EAEnB;IACE,wBAAwB;EAC1B;AACF;AC1JA,2BAA2B;;AAE3B;EACE,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,aAAa;EACb;sCACoC;AACtC;;AAEA;;EAEE,aAAa;EACb,OAAO;EACP,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,kCAAkC;;EAElC;IACE,iBAAiB;IACjB,oBAAoB;;IAEpB;MACE,mBAAmB;MACnB,oBAAoB;IACtB;EACF;AACF;;AAEA,4CAA4C;AAC5C;EACE,YAAY;AACd;;AAEA,oGAAoG;;AAEpG,qDAAqD;AACrD;EACE,qBAAqB;EACrB,sBAAsB;EACtB,2CAA2C;;EAE3C;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA,WAAW;EACX;IACE,sBAAsB;IACtB,uBAAuB;IACvB,4CAA4C;;IAE5C;MACE,mBAAmB;MACnB,oBAAoB;IACtB;;IAEA;MACE,iBAAiB;IACnB;EACF;AACF;;AAEA,sDAAsD;AACtD;;EAEE,UAAU;EACV,UAAU;EACV,gBAAgB;EAChB,cAAc;;EAEd,2FAA2F;EAC3F,aAAa;EACb,sBAAsB;AACxB;;AAEA,gCAAgC;AAChC;EACE,qBAAqB;EACrB,2CAA2C;EAC3C,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA,sBAAsB;AACtB;EACE,sCAAsC;EACtC,kBAAkB;EAClB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE;;IAEE,uBAAuB;EACzB;AACF;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;AACF;;AAEA;EACE;;IAEE,wBAAwB;EAC1B;AACF;;AAEA;EACE;;IAEE,qCAAqC;EACvC;AACF;;AAEA,qDAAqD;AACrD;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;;EAEnB;IACE,qBAAqB;EACvB;AACF;;AAEA,kEAAkE;AAClE;EACE,SAAS;EACT,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA,4BAA4B;AAC5B;EACE,qBAAqB;AACvB;ACpLA,yBAAyB;;AAEzB,sEAAsE;AACtE;EACE,gBAAgB;EAChB,WAAW;;EAEX;IACE,aAAa;EACf;AACF;;AAEA,sBAAsB;AACtB;;EAEE,0BAA0B;;EAE1B;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;;EAEnB;IACE,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA,+CAA+C;EAC/C;IACE;MACE,aAAa;MACb,8BAA8B;MAC9B,uBAAuB;MACvB,qBAAgB;WAAhB,gBAAgB;;MAEhB;QACE,OAAO;MACT;IACF;EACF;AACF;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,OAAO;AACT;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,qCAAqC;AACrC;EACE,mBAAmB;EACnB,mBAAmB;;EAEnB;IACE,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;;IAEtB;MACE,SAAS;IACX;EACF;AACF;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;;EAE9B;IACE,sBAAsB;IACtB,kBAAkB;;IAElB;MACE,WAAW;MACX,gBAAgB;IAClB;EACF;AACF;;AAEA,iDAAiD;AACjD;EACE,WAAW;EACX,kBAAkB;;EAElB;IACE,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,wBAAwB;IACxB,8BAA8B;IAC9B,qBAAqB;IACrB,cAAc;IACd,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,wBAAwB;EAC1B;AACF;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,uBAAuB;EACvB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;;EAErB;IACE,iBAAiB;IACjB,wBAAwB;EAC1B;;EAEA,oCAAoC;EACpC;IACE,aAAa;IACb,wBAAwB;EAC1B;;EAEA,iCAAiC;EACjC;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA,4EAA4E;AAC5E;EACE,kBAAkB;EAClB,sBAAsB;EACtB,wBAAwB;EACxB,gBAAgB;;EAEhB;IACE,sBAAsB;EACxB;;EAEA;IACE;MACE,kBAAkB;IACpB;;IAEA;MACE,mBAAmB;IACrB;EACF;AACF;AChMA,gDAAgD;AAChD;EACE,sBAAsB;EACtB,iCAAiC;EACjC,wBAAwB;EACxB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,uCAAuC;AACzC;;AAEA,yCAAyC;AACzC;;;;EAIE,qDAAqD;EACrD,sBAAsB;EACtB,uCAAuC;EACvC,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,wBAAwB;AAC1B;;AAHA;EACE,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA;EACE;;;IAGE,gDAAgD;IAChD,mEAAmE;EACrE;AACF;;AAEA;;EAEE,qDAAqD;EACrD,sBAAsB;AACxB;;AAEA,cAAc;AACd;;EAEE,8DAA8D;EAC9D,2BAA2B;;EAE3B,qCAAqC;EACrC;IACE,8CAA8C;EAChD;;EAEA;IACE,8DAA8D;IAC9D,gBAAgB;EAClB;AACF;;AAEA;;EAEE,qBAAqB;EACrB,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;;EAEnB;;IAEE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;AACf;;AAEA,0CAA0C;AAC1C;;;;;;;;;EASE,+DAA+D;AACjE;;AAEA,kBAAkB;AAClB;EACE,0CAA0C;EAC1C,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;EAChB,aAAa;EACb,SAAS;;EAET,0CAA0C;EAC1C,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;;EAElB,sCAAsC;EACtC,4BAA4B;EAC5B,4BAA4B;EAC5B,sDAAsD;EACtD,6BAA6B;EAC7B,kBAAkB;;EAElB,8FAA8F;EAC9F,UAAU;;EAEV;IACE,sCAAsC;IACtC,eAAe;IACf,YAAY;EACd;;EAEA;IACE,sCAAsC;IACtC,YAAY;;IAEZ;MACE,4BAA4B;MAC5B,4BAA4B;MAC5B,YAAY;IACd;EACF;AACF;;AAEA,gDAAgD;AAChD;EACE,aAAa;;EAEb;IACE,eAAe;;IAEf;MACE,eAAe;IACjB;EACF;;EAEA;IACE,wBAAwB;IACxB,kBAAkB;IAClB,sBAAsB;IACtB,iCAAiC;IACjC,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;EAClB;AACF;;AAEA,wDAAwD;AACxD;EACE,kBAAkB;;EAElB;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA,aAAa;AACb;EACE,YAAY;EACZ,WAAW;EACX,oBAAoB;EACpB,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;;EAEnB;;IAEE,OAAO;EACT;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,qBAAqB;EACrB,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;;EAErB;;IAEE,WAAW;EACb;;EAEA;IACE,cAAc;IACd,iCAAiC;IACjC,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,sBAAsB;EACxB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,gCAAgC;;IAEhC;MACE,UAAU;IACZ;EACF;AACF;;AAEA,oCAAoC;AACpC;EACE,4BAA4B;EAC5B,0DAAuD;EACvD,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA,yBAAyB;AACzB;EACE,0DAAqD;EACrD,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,UAAU;AACZ;;AAEA,WAAW;AACX;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,uCAAuC;EACvC,YAAY;EACZ,eAAe;AACjB;;AAEA,iBAAiB;AACjB,uDAAuD;AACvD;EACE,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA,kBAAkB;;AAElB,gCAAgC;AAChC;;EAEE,wBAAgB;UAAhB,gBAAgB;EAChB,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,6BAAqB;KAArB,0BAAqB;UAArB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wCAAwC;EACxC,kDAAkD;AACpD;;AAEA,eAAe;AACf;EACE;;IAEE,wBAAwB;EAC1B;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,wBAAwB;EAC1B;;EAFA;IACE,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;IACtB,eAAe;;IAEf;MACE,eAAe;IACjB;EACF;AACF;;AAEA;EACE;IACE,sBAAsB;;IAEtB;MACE,mBAAmB;IACrB;EACF;AACF;ACxVA;;EAEE,aAAa;EACb,wBAAwB;EACxB,8BAA8B;EAC9B,qBAAqB;EACrB,cAAc;EACd,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;EACjC,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;;EAEtB;IACE,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,oDAAoD;AACpD;EACE,mBAAmB;AACrB;AC9BA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;;EAEE,2BAA2B;EAC3B,mBAAmB;EACnB,wBAAwB;EACxB,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;EACrB,4BAA4B;EAC5B,yBAAyB;EACzB,UAAU;EACV,YAAY;EACZ,eAAe;AACjB;;AAEA;;EAEE,8BAA8B;EAC9B,8BAA8B;EAC9B,qBAAqB;EACrB,4BAA4B;;EAE5B;IACE,mCAAmC;EACrC;AACF;;AAEA;;;;;EAKE,WAAW;EACX,sCAAsC;EACtC,mCAAmC;EACnC,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;;EAEnB;IACE,oBAAoB;IACpB,eAAe;IACf,2BAAsB;IAAtB,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AAEA;;;;;EAKE,wBAAwB;EACxB,sCAAsC;EACtC,uCAAuC;EACvC,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;;EAEnB,6CAA6C;EAC7C;IACE,oBAAoB;IACpB,eAAe;IACf,2BAAsB;IAAtB,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AAEA;;;;EAIE;IACE,sBAAsB;;IAEtB;;MAEE,mBAAmB;IACrB;EACF;AACF;;AAEA,4BAA4B;AAC5B;EACE,6BAA6B;EAC7B,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;;EAEf;;;;IAIE,6BAA6B;IAC7B,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,WAAW;EACX,iCAAiC;EACjC,wBAAwB;;EAExB;IACE,sCAAsC;EACxC;AACF;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,+CAA+C;AACjD;;AAEA,2CAA2C;AAC3C;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,qBAAqB;EACrB,UAAU;EACV,iBAAiB;;EAEjB;;IAEE,wBAAwB;IACxB,6BAA6B;IAC7B,0BAA0B;IAC1B,gBAAgB;EAClB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,oBAAoB;EACtB;;EAEA;;;IAGE,sBAAsB;IACtB,UAAU;IACV,gBAAgB;IAChB,qBAAqB;EACvB;AACF;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB;;IAEE,oBAAoB;IACpB,WAAW;IACX,0BAA0B;EAC5B;;EAEA,4BAA4B;EAC5B;IACE,wBAAwB;IACxB,yBAAyB;EAC3B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,+BAA+B;EACjC;AACF;;AAEA,iEAAiE;AACjE;EACE,aAAa;EACb,qBAAgB;OAAhB,gBAAgB;EAChB,eAAe;;EAEf;IACE,gBAAgB;EAClB;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA,qEAAqE;AACrE;EACE,aAAa;EACb,qBAAgB;OAAhB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;;EAEX;IACE,aAAa;IACb,qCAAqC;IACrC,WAAW;IACX,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,8BAA8B;;IAE9B;MACE,0BAA0B;IAC5B;;IAEA;MACE,QAAQ;IACV;;IAEA;MACE,2BAA2B;IAC7B;EACF;AACF;;AAEA;EACE,aAAa;EACb,qBAAgB;OAAhB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA,8DAA8D;AAC9D;EACE,YAAY;;EAEZ,oCAAoC;EACpC;IACE,kBAAkB;IAClB,QAAQ;IACR,YAAY;EACd;AACF;;AAEA,0DAA0D;AAC1D;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,UAAU;EACZ;AACF;;AAEA,sBAAsB;AACtB;EACE;;IAEE,6CAA6C;EAC/C;AACF;;AAEA,yBAAyB;AACzB;EACE,cAAc;EACd,eAAe;EACf,YAAY;EACZ,WAAW;;EAEX,iBAAiB;EACjB,6BAA6B;EAC7B,sCAAiC;EAAjC,iCAAiC;EACjC,WAAW;EACX,YAAY;EACZ,qBAAqB;;EAErB;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,cAAc;EAChB;AACF;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,0DAAkD;EAClD,wBAAwB;EACxB,4BAA4B;EAC5B,2BAA2B;EAC3B,eAAe;EACf,2BAA2B;EAC3B,6BAA6B;EAC7B,oCAAoC;;EAEpC;IACE,mCAAmC;IACnC,qBAAqB;EACvB;AACF;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;;EAEX;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,iCAAiC;IACjC,4BAA4B;IAC5B,wBAAwB;IACxB,iCAAiC;IACjC,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,UAAU;IACV,wBAAwB;IACxB,oBAAoB;IACpB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,iEAAiE;EACnE;;EAEA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;;EAEnB;IACE,WAAW;IACX,mBAAmB;EACrB;AACF;AC3aA,oCAAoC;;AAEpC;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;;EAEnB;IACE,wBAAwB;IACxB,mBAAmB;IACnB,0BAA0B;EAC5B;;EAEA,4BAA4B;EAC5B;IACE,aAAa;EACf;AACF;;AAEA;;EAEE,sBAAsB;EACtB,qBAAqB;EACrB,oBAAoB;;EAEpB;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,wBAAwB;;EAExB;;IAEE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;IAEvB;MACE,gCAAgC;IAClC;;IAEA;MACE,gCAAgC;MAChC,kBAAkB;MAClB,eAAe;IACjB;EACF;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;EACxB;AACF;AC9DA;EACE,WAAW;AACb;;AAEA,wHAAwH;AACxH;EACE;;IAEE,wBAAwB;IACxB,wBAAwB;IACxB,SAAS;IACT,UAAU;;IAEV;;MAEE,aAAa;IACf;;IAEA;MACE,aAAa;;MAEb;QACE,qBAAqB;MACvB;IACF;EACF;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,wBAAwB;;EAExB;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,oBAAoB;EACtB;AACF;ACjDA;oDACoD;AACpD;EACE,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,UAAU;EACV,YAAY;;EAEZ;IACE,kCAAkC;IAClC,6BAA6B;EAC/B;;EAEA;IACE;MACE,cAAc;IAChB;EACF;;EAEA;sEACoE;AACtE;;AAEA;EACE,6BAA6B;EAC7B,uCAAuC;EACvC,mBAAmB;EACnB,YAAY;;EAEZ;IACE,uCAAuC;IACvC,mBAAmB;;IAEnB;MACE,mBAAmB;MACnB,wBAAwB;MACxB,qBAAqB;MACrB,aAAa;;MAEb;QACE,WAAW;QACX,aAAa;QACb,oBAAoB;QACpB,8BAA8B;QAC9B,iBAAiB;QACjB,qBAAqB;MACvB;IACF;;IAEA;MACE,sBAAsB;MACtB,aAAa;MACb,sBAAsB;MACtB,wBAAwB;MACxB,gBAAgB;;MAEhB,kBAAkB;MAClB;QACE,oBAAoB;MACtB;;MAEA;QACE,mBAAmB;MACrB;;MAEA;QACE,kCAAkC;MACpC;;MAEA;QACE,aAAa;MACf;;MAEA,mBAAmB;MACnB;QACE,2BAA2B;QAC3B,wBAAwB;;QAExB;UACE,uBAAuB;;UAEvB;YACE,kBAAkB;YAClB,8BAA8B;YAC9B,cAAc;YACd,wBAAwB;UAC1B;QACF;MACF;;MAEA;QACE,wBAAwB;;QAExB;UACE,kBAAkB;;UAElB;YACE,kBAAkB;UACpB;;UAFA;YACE,kBAAkB;UACpB;QACF;MACF;IACF;;IAEA;MACE,gBAAgB;MAChB,sBAAsB;MACtB,cAAc;MACd,iBAAiB;MACjB,aAAa;MACb,uBAAuB;MACvB,sBAAsB;MACtB,mBAAmB;MACnB,kBAAkB;IACpB;EACF;;EAEA;IACE;MACE,wBAAwB;;MAExB;QACE,kBAAkB;;QAElB;UACE,kBAAkB;QACpB;;QAFA;UACE,kBAAkB;QACpB;MACF;IACF;EACF;AACF;AC1IA,mBAAmB;;AAEnB;EACE,WAAW;EACX,wBAAwB;EACxB,+BAA+B;EAC/B,mBAAmB;EACnB,uCAAuC;;EAEvC;IACE,wBAAwB;EAC1B;;EAEA;IACE,mBAAmB;;IAEnB;MACE,kBAAkB;MAClB,cAAc;IAChB;;IAEA;MACE,gBAAgB;MAChB,sBAAsB;MACtB,cAAc;;MAEd;QACE;UACE,SAAS;UACT,UAAU;QACZ;;QAEA;UACE,2BAA2B;UAC3B,mBAAmB;UACnB,iBAAiB;UACjB,UAAU;UACV,wBAAwB;UACxB,yBAAyB;QAC3B;MACF;;MAEA;QACE,yBAAyB;QACzB,wBAAwB;QACxB,8BAA8B;QAC9B,mBAAmB;MACrB;;MAEA;QACE;UACE,SAAS;UACT,UAAU;QACZ;MACF;;MAEA;QACE,sBAAsB;MACxB;;MAEA;;;QAGE,qBAAqB;MACvB;;MAEA;QACE,UAAU;MACZ;IACF;;IAEA;MACE;QACE,wBAAwB;QACxB,2CAA2C;QAC3C,YAAY;;QAEZ;UACE,mBAAmB;QACrB;MACF;;MAEA;QACE,kBAAkB;QAClB,mBAAmB;MACrB;IACF;;IAEA;MACE,YAAY;;MAEZ;QACE,kBAAkB;;QAElB;UACE,wBAAwB;QAC1B;MACF;IACF;;IAEA;MACE,aAAa;IACf;EACF;;EAEA;IACE;MACE,aAAa;IACf;;IAEA;MACE,aAAa;MACb,sCAAsC;MACtC,QAAQ;MACR,mBAAmB;IACrB;;IAEA;MACE,gBAAgB;MAChB,mBAAmB;MACnB,uBAAuB;IACzB;;IAEA;MACE,yCAAyC;IAC3C;EACF;AACF;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;;;EAGE,kBAAkB;EAClB,wBAAwB;;EAExB;IACE,YAAY;EACd;;EAEA;IACE,4CAA4C;IAC5C,4BAA4B;;IAE5B;MACE,WAAW;IACb;EACF;;EAEA;;IAEE,mBAAmB;IACnB,iBAAiB;;IAEjB;MACE,kBAAkB;IACpB;;IAEA;MACE,mBAAmB;IACrB;EACF;;EAEA;IACE,yBAAyB;IACzB,eAAe;EACjB;AACF;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;;EAEtB;IACE;MACE,gCAAgC;IAClC;;IAEA;MACE;QACE,WAAW;MACb;IACF;EACF;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAgB;OAAhB,gBAAgB;;EAEhB;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,mBAAmB;AACrB;AC3MA,8CAA8C;;AAE9C;EACE,+BAA+B;EAC/B,wBAAwB;;EAExB;IACE,wBAAwB;IACxB,iBAAiB;IACjB,kBAAkB;;IAElB;MACE,wBAAwB;MACxB,2BAA2B;MAC3B,iBAAiB;IACnB;;IAEA;MACE,gBAAgB;IAClB;EACF;;EAEA;IACE,2DAA2D;IAC3D;MACE,0CAA0C;IAC5C;EACF;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,qBAAqB;IACrB,wBAAwB;IACxB,kBAAkB;IAClB,2BAA2B;;IAE3B;MACE,kBAAkB;IACpB;EACF;;EAEA,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;;EAElB;IACE,2BAA2B;EAC7B;AACF;;AAEA;;EAEE,2BAA2B;EAC3B,qBAAqB;;EAErB;IACE,2BAA2B;IAC3B,mBAAmB;EACrB;AACF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;ACpFA,iFAAiF;;AAEjF;;EAEE,iCAAiC;EACjC,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,kBAAkB;;EAElB;;IAEE,wBAAwB;IACxB,iBAAiB;IACjB,2BAA2B;IAC3B,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,SAAS;;IAET;MACE,cAAc;IAChB;;IAEA;MACE,uCAAuC;IACzC;;IAEA;MACE,kBAAkB;IACpB;EACF;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,qCAAqC;IACrC,gBAAgB;IAChB,sBAAsB;IACtB,cAAc;;IAEd;MACE,eAAe;MACf,kBAAkB;;MAElB;QACE,wBAAwB;MAC1B;IACF;;IAEA;MACE,kBAAkB;IACpB;EACF;AACF;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,kBAAkB;;EAElB;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,WAAW;;IAEX;MACE,WAAW;IACb;EACF;AACF;;AAEA,qCAAqC;AACrC;EACE,4BAA4B;EAC5B,cAAc;EACd,sCAAsC;EACtC,mBAAmB;EACnB,iCAAiC;;EAEjC;IACE,uBAAuB;EACzB;;EAEA;IACE,2BAA2B;IAC3B,qBAAqB;IACrB,qBAAqB;EACvB;AACF;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,6BAA6B;EAC7B,oBAAoB;EACpB,gBAAgB;EAChB,SAAS;EACT,uCAAuC;;EAEvC;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE;MACE,iBAAiB;IACnB;EACF;;EAEA;IACE,wBAAwB;IACxB,qBAAqB;EACvB;;EAEA;IACE;MACE,2BAA2B;MAC3B,mBAAmB;MACnB,iBAAiB;MACjB,UAAU;MACV,wBAAwB;MACxB,yBAAyB;IAC3B;EACF;;EAEA;IACE,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;AACF;AClKA,oBAAoB;;AAEpB;EACE,sBAAsB;EACtB,wBAAwB;EACxB,kBAAkB;;EAElB;IACE,qBAAqB;IACrB,cAAc;;IAEd;MACE,eAAe;MACf,cAAc;IAChB;EACF;;EAEA;IACE,aAAa;IACb,2BAA2B;;IAE3B;MACE,oBAAoB;IACtB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,2BAA2B;MAC3B,sBAAsB;MACtB,wBAAwB;IAC1B;EACF;AACF;ACnCA;EACE,2CAA2C;EAC3C,iBAAiB;EACjB,oBAAoB;;EAEpB;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,8BAA8B;;IAE9B;MACE,iBAAiB;MACjB,iBAAiB;IACnB;EACF;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,4BAA4B;IAC5B,cAAc;IACd,sCAAsC;IACtC,mBAAmB;IACnB,iCAAiC;EACnC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;;IAEnB;MACE,qBAAqB;IACvB;;IAEA;MACE,aAAa;IACf;EACF;AACF;AC1DA;EACE;IACE,YAAY;;IAEZ;MACE;QACE,sBAAsB;QACtB,kBAAkB;MACpB;;MAEA;;QAEE,mBAAmB;QACnB,WAAW;QACX,qBAAqB;MACvB;IACF;EACF;AACF;;AAEA;EACE,oDAA+C;EAC/C,4BAA4B;AAC9B;;AAEA,gCAAgC;AAChC;EACE,oBAAoB;EACpB,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,uBAAuB;;EAEvB;IACE,SAAS;EACX;AACF;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;AC9CA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA,4BAA4B;;AAE5B;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,sBAAsB;;EAEtB;IACE,aAAa;EACf;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ;;;;;;GAMC;AACH;;AAEA,oBAAoB;AACpB;EACE,YAAY;EACZ;;;;;;GAMC;AACH;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA,yDAAyD;;AAEzD,oDAAoD;;AAEpD,oCAAoC;;AAEpC,MAAM;;AAEN,mBAAmB;AACnB;EACE,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;EACnC,kCAAkC;EAClC,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;AACpC;ACpFA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;;EAEtB;IACE,aAAa;;IAEb,yBAAyB;IACzB;MACE,gBAAgB;MAChB,YAAY;IACd;EACF;AACF;;AAEA,oDAAoD;AACpD;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;;EAErB;IACE,+BAA+B;EACjC;AACF;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;;EAEzB;IACE,+BAA+B;EACjC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;;IAExB;MACE,+BAA+B;IACjC;EACF;AACF;;AAEA,qCAAqC;AACrC;EACE,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,+BAA+B;EAC/B,wBAAwB;EACxB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,uCAAuC;EACvC,kBAAkB;EAClB,sCAAsC;;EAEtC;IACE,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;EACxB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,kCAAkC;;IAElC;MACE,yBAAyB;MACzB,sCAAsC;IACxC;;IAEA;MACE,yBAAyB;MACzB,sCAAsC;IACxC;;IAEA;MACE,yBAAyB;MACzB,sCAAsC;IACxC;;IAEA;MACE,yBAAyB;MACzB,sCAAsC;IACxC;EACF;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;;EAEnB;IACE,cAAc;IACd,WAAW;IACX,YAAY;EACd;;EAEA;IACE,uBAAuB;IACvB,cAAc;;IAEd;MACE,yBAAyB;IAC3B;EACF;;EAEA;IACE,aAAa;IACb,cAAc;IACd,oCAAoC;IACpC,kBAAkB;IAClB,uCAAuC;EACzC;AACF;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,sBAAsB;;EAEtB;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,OAAO;IACP,WAAW;IACX,oCAAoC;EACtC;AACF;AC3JA;EACE,cAAc;EACd,wBAAwB;EACxB,4BAA4B;EAC5B,yBAAyB;EACzB,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;ACfA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,aAAa;EACb,0CAA0C;EAC1C,kCAAkC;EAClC,wBAAwB;;EAExB;IACE,aAAa;IACb,qBAAqB;IACrB,wBAAwB;;IAExB;MACE,WAAW;MACX,YAAY;MACZ,iBAAiB;MACjB,0DAAiD;MACjD,wBAAwB;MACxB,4BAA4B;IAC9B;EACF;AACF;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B;IACE,UAAU;IACV,kBAAkB;IAClB,mBAAmB;IACnB,wBAAwB;IACxB,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,wBAAwB;IACxB,mBAAmB;EACrB;AACF;;AAEA;EACE,SAAS;EACT,eAAe;EACf,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;;EAEb;IACE;MACE,oBAAoB;IACtB;EACF;AACF;;AAEA;EACE,SAAS;EACT,aAAa;AACf;;AAEA;EACE;IACE,qBAAqB;;IAErB;MACE,aAAa;MACb,sBAAsB;MACtB,qBAAqB;;MAErB;QACE,eAAe;MACjB;IACF;EACF;AACF;ACrFA,oBAAoB;;AAEpB;EACE,uCAAuC;EACvC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;;EAEb;IACE,YAAY;IACZ,YAAY;IACZ,0DAAiD;IACjD,wBAAwB;IACxB,4BAA4B;IAC5B,2BAA2B;IAC3B,aAAa;IACb,OAAO;IACP,gBAAgB;;IAEhB;MACE,YAAY;MACZ,WAAW;IACb;EACF;;EAEA;IACE,OAAO;;IAEP;MACE,aAAa;IACf;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,8BAA8B;;MAE9B;QACE,gBAAgB;;QAEhB;;UAEE,mCAAmC;QACrC;MACF;;MAEA,wBAAwB;MACxB;QACE,aAAa;QACb,8BAA8B;QAC9B,mBAAmB;QACnB,WAAW;QACX,qBAAqB;;QAErB;UACE,sBAAsB;UACtB,wBAAwB;UACxB,OAAO;QACT;;QAEA;UACE,kCAAkC;UAClC,qBAAqB;UACrB,wBAAwB;QAC1B;;QAEA,YAAY;QACZ;UACE,6BAA6B;UAC7B,gBAAgB;UAChB,kBAAkB;;UAElB;YACE,sBAAsB;UACxB;;UAEA;YACE;cACE,2BAA2B;YAC7B;UACF;QACF;MACF;;MAEA,+CAA+C;MAC/C;;QAEE;UACE,sBAAsB;UACtB,wBAAwB;UACxB,qBAAqB;UACrB,yBAAyB;QAC3B;MACF;;MAEA;QACE,aAAa;QACb,gBAAgB;QAChB,UAAU;QACV,kBAAkB;MACpB;;MAEA,gCAAgC;MAChC;QACE;UACE,qBAAqB;QACvB;;QAEA;UACE,kBAAkB;UAClB,gBAAgB;UAChB,YAAY;UACZ,mBAAmB;UACnB,sCAAsC;;UAEtC;YACE,yCAAyC;YACzC,iCAAiC;YACjC,oBAAoB;;YAEpB;cACE,4BAA4B;cAC5B,6BAA6B;YAC/B;;YAEA;cACE,+BAA+B;cAC/B,gCAAgC;cAChC,wBAAwB;YAC1B;UACF;QACF;;QAEA,8BAA8B;QAC9B;UACE;YACE,yBAAyB;UAC3B;;UAEA;YACE,UAAU;YACV,mBAAmB;YACnB,aAAa;YACb,sBAAsB;UACxB;QACF;MACF;;MAEA;QACE,aAAa;QACb,mBAAmB;MACrB;IACF;;IAEA,6CAA6C;IAC7C;MACE,gBAAgB;MAChB,eAAe;MACf,uBAAuB;MACvB,mBAAmB;MACnB,qBAAqB;MACrB,6BAA6B;MAC7B,8BAA8B;MAC9B,wBAAwB;MACxB,iBAAiB;IACnB;EACF;;EAEA,yBAAyB;EACzB;IACE;MACE,WAAW;;MAEX;QACE,aAAa;QACb,yBAAyB;QACzB,gBAAgB;QAChB,gBAAgB;QAChB,UAAU;QACV,mBAAmB;QACnB,sBAAsB;;QAEtB;UACE,iBAAiB;UACjB,WAAW;QACb;;QAEA;UACE,2BAA2B;QAC7B;MACF;;MAEA;QACE,aAAa;;QAEb;UACE,WAAW;QACb;;QAEA,yBAAyB;QACzB;UACE,aAAa;UACb,sBAAsB;UACtB,UAAU;UACV,kBAAkB;UAClB,WAAW;UACX,oBAAoB;UACpB,YAAY;UACZ,uCAAuC;UACvC,6BAA6B;UAC7B,mBAAmB;UACnB,sBAAsB;UACtB,YAAY;UACZ,yBAAyB;QAC3B;;QAEA;UACE,gBAAgB;UAChB,iBAAiB;UACjB,wCAAwC;UACxC,0BAA0B;;UAE1B;YACE,aAAa;UACf;QACF;;QAEA,iCAAiC;QACjC;UACE,yCAAyC;UACzC,mBAAmB;QACrB;MACF;IACF;EACF;AACF;AC5OA,kCAAkC;;AAElC,yBAAyB;AACzB;EACE,WAAW;EACX,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,eAAe;EACf,gBAAgB;;EAEhB;;IAEE,uBAAuB;IACvB,kCAAkC;IAClC,YAAY;EACd;;EAEA;IACE,qBAAqB;;IAErB;MACE,SAAS;IACX;EACF;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,WAAW;IACX,SAAS;IACT,UAAU;IACV,kBAAkB;;IAElB;MACE,2BAA2B;IAC7B;;IAEA;MACE,wBAAwB;IAC1B;EACF;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,gDAAgD;AAChD;EACE;IACE,kBAAkB;IAClB,QAAQ;IACR,cAAc;IACd,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,qBAAqB;;EAErB;IACE,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,iCAAiC;IACjC,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,wBAAwB;;IAExB;MACE,qBAAqB;IACvB;;IAEA;MACE,oBAAoB;MACpB,WAAW;IACb;;IAEA;MACE,WAAW;MACX,YAAY;MACZ,eAAe;MACf,gBAAgB;IAClB;EACF;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,2BAA2B;IAC3B,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,4BAA4B;IAC5B,mBAAmB;IACnB,iCAAiC;IACjC,2BAA2B;;IAE3B;MACE,6BAA6B;IAC/B;EACF;AACF;AC/HA,oCAAoC;;AAEpC;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;;EAEb;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,kBAAkB;;IAElB;MACE,WAAW;MACX,cAAc;IAChB;EACF;AACF;ACxBA,kCAAkC;;AAElC;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;AACF;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,uBAAkB;EAAlB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;;EAEnB;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,gBAAgB;EAClB;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;sGACsG;AACtG;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;;EAEE;IACE,sBAAsB;EACxB;;EAEA,mEAAmE;;EAEnE;IACE;MACE;QACE,sBAAsB;QACtB,YAAY;QACZ,aAAa;;QAEb;UACE,kBAAkB;QACpB;MACF;IACF;EACF;;EAEA;IACE;MACE,aAAa;MACb,6BAA6B;IAC/B;EACF;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,oCAAoC;IACpC,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;;IAEb;MACE,gBAAgB;MAChB,kBAAkB;IACpB;;IAEA;MACE,oBAAoB;IACtB;EACF;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,oBAAoB;IACpB,sCAAsC;IACtC,kBAAkB;IAClB,gBAAgB;;IAEhB;MACE,iBAAiB;MACjB,YAAY;MACZ,sBAAmB;SAAnB,mBAAmB;IACrB;EACF;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;;IAEnB;MACE,SAAS;IACX;EACF;AACF;;AAEA,+BAA+B;;AAE/B;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sCAAsC;EACtC,wBAAmB;EAAnB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AClKA,oCAAoC;;AAEpC;EACE,kBAAkB;EAClB,aAAa;EACb,OAAO;EACP,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,6CAA6C;EAC7C,0BAA0B;EAC1B,kCAAkC;EAClC,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,+EAA+E;EAC/E;IACE,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,sBAAsB;IACtB,qEAAqE;IACrE,kFAA0E;YAA1E,0EAA0E;IAC1E,yCAAyC;EAC3C;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;AC1CA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,8BAA8B;IAC9B,yBAAyB;EAC3B;;EAEA;IACE,qBAAqB;IACrB,wBAAwB;;IAExB;MACE,iBAAiB;;MAEjB;;;QAGE,qBAAqB;QACrB,gBAAgB;QAChB,8BAA8B;MAChC;;MAEA;QACE,aAAa;MACf;IACF;EACF;;EAEA;IACE,gBAAgB;IAChB,iCAAiC;IACjC,gBAAgB;EAClB;;EAEA;IACE,8BAA8B;IAC9B,wBAAwB;EAC1B;;EAEA;IACE,uCAAuC;IACvC,aAAa;;IAEb;MACE,aAAa;MACb,2BAA2B;;MAE3B;QACE,wBAAwB;QACxB,iBAAiB;MACnB;;MAEA;QACE,yBAAyB;QACzB,8BAA8B;QAC9B,eAAe;QACf,mBAAmB;MACrB;;MAEA;QACE,uBAAuB;MACzB;IACF;EACF;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA,gDAAgD;AAChD;EACE,uBAAuB;EACvB,wBAAwB;;EAExB;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,sBAAsB;;IAEtB;MACE,uBAAuB;IACzB;EACF;AACF;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;;EAExB;IACE,YAAY;EACd;;EAEA;IACE;MACE,yBAAyB;MACzB,eAAe;IACjB;;IAEA;MACE,uBAAuB;IACzB;EACF;;EAEA;;IAEE,mBAAmB;;IAEnB;MACE,UAAU;IACZ;EACF;AACF;ACzHA,0BAA0B;AAC1B;EACE,mBAAmB;;EAEnB;IACE,aAAa;;IAEb;MACE,4BAA4B;IAC9B;;IAEA;MACE,gBAAgB;MAChB,aAAa;MACb,8BAA8B;MAC9B,uBAAuB;;MAEvB;QACE,sBAAsB;QACtB,uBAAuB;;QAEvB;UACE,oBAAoB;QACtB;MACF;;MAEA;QACE,mBAAmB;QACnB,qBAAqB;QACrB,cAAc;QACd,kCAA6B;QAA7B,6BAA6B;MAC/B;IACF;;IAEA;MACE;QACE,iBAAiB;QACjB,qBAAqB;MACvB;;MAEA;QACE,gBAAgB;MAClB;IACF;;IAEA;MACE,mBAAmB;MACnB,iBAAiB;;MAEjB;QACE,sBAAsB;QACtB,kBAAkB;MACpB;IACF;EACF;AACF;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;;EAElB;IACE,YAAY;IACZ,mBAAmB;;IAEnB;MACE,mBAAmB;MACnB,iCAAiC;MACjC,4BAA4B;MAC5B,aAAa;MACb,iBAAiB;MACjB,aAAa;MACb,sBAAsB;MACtB,8BAA8B;;MAE9B;QACE,wBAAwB;MAC1B;;MAEA;;QAEE,SAAS;MACX;;MAEA,gCAAgC;MAChC;QACE,uBAAuB;QACvB,UAAU;QACV,SAAS;QACT,YAAY;QACZ,YAAY;;QAEZ;UACE,sBAAsB;UACtB,YAAY;UACZ,WAAW;QACb;MACF;;MAEA;QACE,qBAAqB;;QAErB;UACE,gBAAgB;QAClB;MACF;IACF;;IAEA;MACE,WAAW;IACb;EACF;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA,uBAAuB;AACvB;EACE;IACE;MACE,iCAAiC;MACjC,kBAAkB;MAClB,aAAa;MACb,YAAY;MACZ,kBAAkB;MAClB,gBAAgB;IAClB;;IAEA;MACE,kBAAkB;MAClB,qBAAqB;IACvB;;IAEA;MACE,gBAAgB;IAClB;EACF;;EAEA;IACE;MACE,YAAY;MACZ,cAAc;MACd,UAAU;;MAEV;QACE,kBAAkB;MACpB;IACF;EACF;;EAEA;IACE,kBAAkB;;IAElB;MACE,0CAA0C;IAC5C;EACF;;EAEA;IACE,kBAAkB;;IAElB;MACE,kBAAkB;MAClB,cAAc;MACd,QAAQ;IACV;EACF;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oGAAoG;;IAEpG,2BAA2B;;IAE3B,aAAa;IACb,sBAAsB;IACtB,aAAa;;IAEb;MACE,mBAAmB;IACrB;EACF;;EAEA;IACE;MACE;QACE,YAAY;MACd;IACF;;IAEA;MACE;QACE,0CAA0C;MAC5C;IACF;EACF;;EAEA;IACE,8DAA8D;IAC9D,aAAa;IACb,wBAAwB;IACxB,gBAAgB;IAChB,qBAAqB;EACvB;AACF;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;;EAEnB;IACE,cAAc;EAChB;AACF;;AAEA;EACE,qBAAqB;;EAErB;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,iGAAiG;AACjG;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,0BAA0B;EAC1B,gBAAgB;EAChB,UAAU;EACV,qBAAqB;;EAErB;IACE;MACE,WAAW;MACX,iBAAiB;IACnB;EACF;;EAEA;IACE,8BAA8B;IAC9B,mBAAmB;EACrB;AACF;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;ACjRA,qBAAqB;;AAErB;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE;MACE,sBAAsB;IACxB;EACF;;EAEA;;IAEE,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;;IAErB;MACE,YAAY;IACd;;IAEA;MACE,UAAU;MACV,gBAAgB;IAClB;EACF;;EAEA;IACE,uCAAuC;IACvC,aAAa;EACf;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA,iCAAiC;AACjC;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,eAAe;EACf,OAAO;EACP,gBAAgB;AAClB;;AAEA;;EAEE;IACE,OAAO;IACP,eAAe;IACf,sBAAsB;IACtB,qBAAqB;EACvB;AACF;ACnEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE;MACE,eAAe;IACjB;EACF;AACF;;AAEA;EACE;IACE,sBAAsB;;IAEtB;MACE,uBAAuB;IACzB;EACF;;EAEA;IACE;MACE,gBAAgB;IAClB;EACF;AACF;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;ACzCA,kFAAkF;AAClF,6CAA6C;;AAE7C;;;EAGE,oCAAoC;EACpC,uCAAuC;EACvC,sBAAsB;;EAEtB;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gCAAgC;IAChC,wBAAwB;;IAExB;MACE,sBAAsB;IACxB;;IAEA;MACE,aAAa;IACf;EACF;AACF;;AAEA;;;EAGE,sBAAsB;EACtB,uCAAuC;AACzC;;AAEA;;;EAGE,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;;;EAGE,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;;;EAGE,QAAQ;AACV;;AAEA;;;EAGE,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;;;EAGE,kCAAkC;EAClC,8CAA8C;EAC9C,oBAAoB;AACtB;;AAEA;;;EAGE,sBAAsB;EACtB,yBAAyB;EACzB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;;EAEX;IACE,OAAO;EACT;;EAEA;IACE,OAAO;EACT;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,YAAY;;IAEZ;MACE,gBAAgB;IAClB;EACF;;EAEA;IACE;MACE,OAAO;IACT;EACF;;EAEA;IACE,sBAAsB;;IAEtB;MACE,WAAW;IACb;EACF;;EAEA;IACE,qBAAqB;IACrB,oCAAoC;IACpC,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,gCAAgC;IAChC,sBAAsB;IACtB,wBAAwB;EAC1B;AACF;;AAEA,uBAAuB;AACvB;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;;EAEnB;IACE,wBAAwB;IACxB,2BAA2B;IAC3B,yBAAyB;IACzB,iBAAiB;IACjB,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,uCAAuC;IACvC,qBAAqB;IACrB,eAAe;IACf,sCAAsC;;IAEtC;MACE,mBAAmB;MACnB,8BAA8B;MAC9B,mCAAmC;MACnC,qBAAqB;MACrB,WAAW;MACX,YAAY;;MAEZ;QACE,4BAA4B;MAC9B;;MAEA;QACE,aAAa;MACf;IACF;EACF;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,YAAY;IACZ,UAAU;IACV,kBAAkB;;IAElB;MACE,aAAa;MACb,mBAAmB;MACnB,uBAAuB;IACzB;EACF;;EAEA;IACE,UAAU;IACV,uCAAuC;EACzC;;EAEA;IACE;MACE,aAAa;MACb,mBAAmB;IACrB;EACF;;EAEA;IACE,wBAAwB;IACxB,2BAA2B;IAC3B,iBAAiB;EACnB;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,4CAA4C;AClO5C,cAAc;;AAEd;EACE,4BAA4B;EAC5B,oCAAoC;EACpC,kBAAkB;;EAElB;IACE,aAAa;EACf;;EAEA;IACE;MACE,wCAAwC;IAC1C;;IAEA;MACE,0BAA0B;IAC5B;;IAEA;MACE,0BAA0B;IAC5B;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,0BAA0B;IAC5B;;IAEA,gBAAgB;IAChB;MACE,kBAAkB;IACpB;;IAEA;MACE,0BAA0B;IAC5B;;IAEA;MACE,0BAA0B;IAC5B;;IAEA;MACE,4BAA4B;IAC9B;;IAEA;MACE,gBAAgB;;MAEhB;;QAEE,aAAa;MACf;;;MAGA;QACE,aAAa;QACb,eAAe;QACf,0BAA0B;QAC1B,wBAAwB;QACxB,kBAAkB;QAClB,mBAAmB;QACnB,aAAa;QACb,2BAA2B;QAC3B,iBAAiB;QACjB,4BAA4B;;QAE5B;UACE,6BAA6B;UAC7B,4BAA4B;;UAE5B;YACE,0BAA0B;UAC5B;QACF;;QAEA;UACE;YACE,kBAAkB;YAClB,wBAAwB;YACxB,kBAAkB;UACpB;;UAEA;YACE,OAAO;YACP,oBAAoB;UACtB;QACF;;QAEA;UACE,2BAA2B;UAC3B,wBAAwB;UACxB,gBAAgB;UAChB,gBAAgB;;UAEhB;YACE,wBAAwB;UAC1B;QACF;;QAEA;UACE,wBAAwB;UACxB,cAAc;UACd,gBAAgB;QAClB;;QAEA,uDAAuD;QACvD;;;UAGE,kBAAkB;UAClB,WAAW;QACb;MACF;IACF;;IAEA;MACE,uCAAuC;MACvC,oBAAoB;MACpB,8BAA8B;;MAE9B;QACE;UACE,UAAU;QACZ;;QAEA;UACE,UAAU;QACZ;MACF;IACF;EACF;;EAEA,oEAAoE;EACpE;IACE,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;;IAEhB;MACE,mBAAmB;MACnB,oCAAoC;MACpC,kBAAkB;;MAElB;QACE,wCAAwC;MAC1C;;MAEA;QACE,kCAAkC;;QAElC;UACE,gCAAgC;QAClC;MACF;;MAEA;QACE,4BAA4B;MAC9B;;MAEA;QACE,kBAAkB;;QAElB;UACE,4BAA4B;UAC5B,6BAA6B;QAC/B;;QAEA;UACE,wBAAwB;UACxB,yBAAyB;UACzB,mBAAmB;QACrB;MACF;;MAEA;QACE,0BAA0B;QAC1B,0BAA0B;;QAE1B;UACE,wBAAwB;UACxB,iBAAiB;QACnB;MACF;IACF;EACF;AACF;AC7LA,yCAAyC;;AAEzC;EACE;;;;;;;GAOC;;EAED;;;IAGE,6BAA6B;EAC/B;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,qBAAqB;;IAErB;MACE,eAAe;IACjB;EACF;;EAEA;IACE;MACE,mCAAmC;IACrC;EACF;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,iDAAiD;EACjD,wBAAwB,EAAE,oCAAoC;EAC9D,qBAAqB;EACrB,iDAAiD;EACjD,gBAAgB;EAChB,gBAAgB;;EAEhB;IACE,OAAO;IACP,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,4BAA4B;IAC5B,gCAAgC;IAChC,wBAAwB;IACxB,sBAAsB;;IAEtB;MACE,yBAAyB;MACzB,gBAAgB;IAClB;;IAEA;MACE,yBAAyB;IAC3B;;IAEA;MACE,yBAAyB;IAC3B;;IAEA;MACE,yBAAyB;MACzB,iBAAiB;IACnB;EACF;;EAEA;IACE,kBAAkB;;IAElB;;MAEE,WAAW;MACX,YAAY;MACZ,WAAW;IACb;EACF;;EAEA;IACE,6BAA6B;IAC7B,sBAAsB;IACtB,4BAA4B;EAC9B;;EAEA;IACE,mBAAmB;;IAEnB;MACE,uBAAuB;;MAEvB;QACE,iBAAiB;MACnB;IACF;EACF;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,qBAAqB;;IAErB;MACE,wBAAwB;MACxB,cAAc;MACd,eAAe;MACf,oBAAoB;MACpB,yBAAyB;;MAEzB;QACE,oBAAoB;QACpB,gBAAgB;MAClB;IACF;EACF;AACF;ACpIA,2CAA2C;;AAE3C;EACE,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;EACrB,oBAAoB;EACpB,oBAAoB;EACpB,wBAAwB,EAAE,0BAA0B;EACpD,kBAAkB;EAClB,uBAAuB,EAAE,kBAAkB;EAC3C,oBAAoB;;EAEpB,sBAAsB;EACtB;IACE,qEAAqE;EACvE;;EAEA;IACE,qEAAkE;EACpE;;EAEA;IACE,WAAW;EACb;;EAEA;IACE;MACE,2CAA2C;IAC7C;EACF;;EAEA;IACE;MACE,oDAAoD;IACtD;EACF;;EAEA,2BAA2B;EAC3B;;IAEE,WAAW;;IAEX;MACE,yBAAyB;IAC3B;;IAEA;MACE,yBAAyB;IAC3B;;IAEA;MACE,yBAAyB;IAC3B;;IAEA;MACE,yBAAyB;IAC3B;EACF;;EAEA;IACE;;;;;;;KAOC;IACD,sBAAsB;;IAEtB;MACE,WAAW;;MAEX,wBAAwB;MACxB;QACE,4FAA4F;MAC9F;IACF;EACF;;EAEA;IACE,gCAAgC;IAChC,2CAA2C;;IAE3C;;MAEE,yBAAyB;IAC3B;;IAEA;MACE,uCAAuC;IACzC;EACF;;EAEA;;;;;;;;;IASE,WAAW;EACb;;EAEA;IACE,gGAAgG;;IAEhG;MACE,mCAAmC;IACrC;EACF;;EAEA,SAAS;EACT;;IAEE,gCAAgC;EAClC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IAEE,iCAAiC;IACjC,mDAAmD;EACrD;;EAJA;;IAEE,iCAAiC;IACjC,mDAAmD;EACrD;;EAEA;;;;IAIE,iCAAiC;IACjC,mDAAmD;EACrD;;EAEA,0EAA0E;EAC1E;IACE,iBAAiB;EACnB;;EAEA;IACE,iCAAiC;IACjC,UAAU,EAAE,YAAY;EAC1B;;EAHA;IACE,iCAAiC;IACjC,UAAU,EAAE,YAAY;EAC1B;;EAEA;IACE,qCAAqC;EACvC;AACF;AC3JA,gEAAgE;;AAEhE;EACE,uBAAuB;EACvB,oBAAoB;EACpB,4BAA4B;;EAE5B;IACE,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,uBAAuB;IACvB,wBAAwB;;IAExB;MACE,yBAAyB;IAC3B;EACF;;EAEA;IACE,qBAAqB;IACrB,gBAAgB;;IAEhB;MACE,sBAAsB;IACxB;EACF;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,eAAe;;IAEf;MACE,sBAAsB;MACtB,uBAAuB;IACzB;;IAEA;MACE,qBAAqB;MACrB,mBAAmB;MACnB,sBAAsB;IACxB;EACF;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sCAAsC;IACtC,kBAAkB;IAClB,aAAa;IACb,qBAAqB;IACrB,kBAAkB;;IAElB;MACE,cAAc;;MAEd;QACE,YAAY;MACd;IACF;EACF;;EAEA;IACE,yBAAyB;;IAEzB;MACE,gBAAgB;IAClB;EACF;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;;IAErB;MACE,sBAAsB;MACtB,mBAAmB;IACrB;EACF;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,0BAA0B;IAC1B,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,qBAAqB;IACrB,mBAAmB;;IAEnB;MACE,qCAAqC;IACvC;;IAEA;MACE,qCAAqC;IACvC;;IAEA;MACE,aAAa;MACb,sBAAsB;MACtB,mBAAmB;MACnB,WAAW;;MAEX;QACE,cAAc;QACd,eAAe;QACf,kBAAkB;QAClB,gCAAgC;QAChC,sBAAsB;QACtB,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,iBAAiB;QACjB,sBAAsB;QACtB,wBAAwB;MAC1B;;MAEA;QACE,wBAAwB;QACxB,kBAAkB;QAClB,sBAAsB;QACtB,kBAAkB;MACpB;;MAEA;QACE,yBAAyB;QACzB,cAAc;MAChB;;MAEA;QACE,sCAAsC;QACtC,cAAc;MAChB;;MAEA;QACE,iBAAiB;QACjB,sBAAsB;MACxB;IACF;;IAEA;MACE;QACE,aAAa;MACf;IACF;EACF;;EAEA;IACE,UAAU;IACV,6BAA6B;EAC/B;AACF","sourcesContent":["/** Note! Order of import below affects cascaded application of styles, so change with care. **/\n\n@import url(\"./reset.css\");\n@import url(\"./variables.css\");\n@import url(\"./fonts.css\");\n@import url(\"./typography.css\");\n@import url(\"./base.css\");\n@import url(\"./forms.css\");\n@import url(\"./inputs.css\");\n@import url(\"./label.css\");\n@import url(\"./buttons.css\");\n@import url(\"./links.css\");\n@import url(\"./img.css\");\n@import url(\"./modals.css\");\n@import url(\"./tables.css\");\n@import url(\"./lists.css\");\n@import url(\"./figure.css\");\n@import url(\"./timer.css\");\n@import url(\"./Help.css\");\n@import url(\"./AccountLinking.css\");\n@import url(\"./ChangePassword.css\");\n@import url(\"./DashboardMain.css\");\n@import url(\"./Emails.css\");\n@import url(\"./Footer.css\");\n@import url(\"./Header.css\");\n@import url(\"./Notifications.css\");\n@import url(\"./ResetPassword.css\");\n@import url(\"./SignupMain.css\");\n@import url(\"./Splash.css\");\n@import url(\"./Errors.css\");\n@import url(\"./Login.css\");\n@import url(\"./PersonalData.css\");\n@import url(\"./Ladok.css\");\n@import url(\"./reactSelect.css\");\n@import url(\"./accordion.css\");\n@import url(\"./landingPage.css\");\n@import url(\"./darkmode.css\");\n@import url(\"./StepContainer.css\");\n","/** Classic cross browser element reset **/\n\n/* http://meyerweb.com/eric/tools/css/reset/\n   v2.0 | 20110126\n   License: none (public domain)\n*/\n\nhtml,\nbody,\ndiv,\nspan,\napplet,\nobject,\niframe,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nblockquote,\npre,\na,\nabbr,\nacronym,\naddress,\nbig,\ncite,\ncode,\ndel,\ndfn,\nem,\nimg,\nins,\nkbd,\nq,\ns,\nsamp,\nsmall,\nstrike,\nstrong,\nsub,\nsup,\ntt,\nvar,\nb,\nu,\ni,\ncenter,\ndl,\ndt,\ndd,\nol,\nul,\nli,\nfieldset,\nform,\nlabel,\nlegend,\ntable,\ncaption,\ntbody,\ntfoot,\nthead,\ntr,\nth,\ntd,\narticle,\naside,\ncanvas,\ndetails,\nembed,\nfigure,\nfigcaption,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\noutput,\nruby,\nsection,\nsummary,\ntime,\nmark,\naudio,\nvideo {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font-size: 100%;\n  font-family: inherit;\n  vertical-align: baseline;\n}\n\n/* HTML5 display-role reset for older browsers */\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\nsection {\n  display: block;\n}\n\nbody {\n  line-height: 1;\n}\n\nol,\nul {\n  list-style: none;\n}\n\nblockquote,\nq {\n  quotes: none;\n}\n\nblockquote::before,\nblockquote::after,\nq::before,\nq::after {\n  content: \"\";\n  content: none;\n}\n\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n","/** System wide variables to reuse for consistency **/\n\n/*\n * Colors\n * ========================================================================== */\n\n/* CSS vars to enable dark mode overrides */\n:root {\n  --contrast-color: #fff;\n  --body-txt: #161616;\n  --body-gray: #f4f4f4;\n  --txt-gray: #5e5e5e; /* text on bg gray */\n  --border-gray: #d8d8d8;\n  --txt-orange: #c23400; /* text on gray or orange */\n  --bg-orange: #ffe7dd;\n  --error-red: #d2143a;\n  --error-red-t: #d2143a80; /* with 50% transparency */\n  --bg-gray: #ebebeb;\n  --shadow-green: #c1e1cd;\n  --txt-green: #12633d;\n  --bright-orange-filter: brightness(0) saturate(100%) invert(25%) sepia(28%) saturate(6161%) hue-rotate(4deg)\n    brightness(93%) contrast(101%);\n  --bright-orange: #ff4500; /* eduID, highlights */\n  --btn-orange: #db3a00; /* white on orange */\n  --success-green: #177d4d;\n\n  /*\n   * Typography\n   * ========================================================================== */\n  --inter-bold: \"Inter-SemiBold\", \"Arial\", \"Helvetica\", \"sans-serif\"; /* bold enough for normal text */\n  --inter-regular: \"Inter-Regular\", \"Arial\", \"Helvetica\", \"sans-serif\";\n  --inter-medium: \"Inter-Medium\", \"Arial\", \"Helvetica\", \"sans-serif\";\n  --inter-light: \"Inter-light\", \"Arial\", \"Helvetica\", \"sans-serif\";\n  --akkurat: \"Akkurat\", \"Arial\", \"Helvetica\", \"sans-serif\";\n  --txt-xs: 0.75rem; /* 12px */\n  --txt-sm: 0.875rem; /* 14px */\n  --txt-md: 1rem; /* 16px (body 100%, default) */\n  --txt-lg: 1.125rem; /* 18px */\n  --txt-xl: 1.25rem; /* 20px */\n  --txt-xxl: 1.375rem; /* 22px */\n  --line-height: 1.4;\n  --margin: 1rem;\n  --list-indent: 2.25rem;\n\n  /*\n   * Layout\n   * ========================================================================== */\n  --border-width: 2px;\n\n  /*\n   * Shadows\n   * ========================================================================== */\n  --shadow-sm: 0 1px 3px 2px rgb(0 0 0 / 5%);\n  --shadow-md: 0 4px 14px rgb(89 89 89 / 7%);\n  --shadow-lg: 0 5px 17px rgb(89 89 89 / 7%);\n  --shadow-nav: 0 -6px 17px rgb(89 89 89 / 7%);\n}\n\n/*\n * Breakpoints\n * ========================================================================== */\n\n@custom-media --bp-xs (max-width: 414px);\n@custom-media --bp-sm (max-width: 568px);\n@custom-media --bp-md (max-width: 768px);\n@custom-media --bp-lg (max-width: 823px);\n@custom-media --bp-xl (max-width: 1200px);\n\n/* min-width variants */\n@custom-media --bp-xs-up (min-width: 414px);\n@custom-media --bp-sm-up (min-width: 568px);\n@custom-media --bp-md-up (min-width: 768px);\n@custom-media --bp-lg-up (min-width: 823px);\n@custom-media --bp-xl-up (min-width: 1200px);\n","@font-face {\n  font-family: Akkurat;\n  src: url(\"../fonts/Akkurat-Mono.ttf\") format(\"truetype\"), url(\"../fonts/Akkurat-Mono.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: Inter-Bold;\n  src: url(\"../fonts/Inter-Bold.ttf\") format(\"truetype\"), url(\"../fonts/Inter-Bold.woff\") format(\"woff\"),\n    url(\"../fonts/Inter-Bold.woff2\") format(\"woff2\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: Inter-SemiBold;\n  src: url(\"../fonts/Inter-SemiBold.ttf\") format(\"truetype\"), url(\"../fonts/Inter-SemiBold.woff\") format(\"woff\"),\n    url(\"../fonts/Inter-SemiBold.woff2\") format(\"woff2\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: Inter-Medium;\n  src: url(\"../fonts/Inter-Medium.ttf\") format(\"truetype\"), url(\"../fonts/Inter-Medium.woff\") format(\"woff\"),\n    url(\"../fonts/Inter-Medium.woff2\") format(\"woff2\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: Inter-Regular;\n  src: url(\"../fonts/Inter-Regular.ttf\") format(\"truetype\"), url(\"../fonts/Inter-Regular.woff\") format(\"woff\"),\n    url(\"../fonts/Inter-Regular.woff2\") format(\"woff2\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: Inter-Light;\n  src: url(\"../fonts/Inter-Light.ttf\") format(\"truetype\"), url(\"../fonts/Inter-Light.woff\") format(\"woff\"),\n    url(\"../fonts/Inter-Light.woff2\") format(\"woff2\");\n  font-weight: normal;\n  font-style: normal;\n}\n","/** Site wide typography **/\n\nh1,\nh2,\nh3,\nh4,\nh5,\n.heading-2,\n.heading-4 {\n  margin-top: 0;\n  margin-bottom: 1em;\n  line-height: 1.2;\n  font-family: var(--inter-bold);\n  font-weight: normal;\n\n  @media (--bp-md) {\n    overflow-wrap: anywhere;\n  }\n}\n\nh1 {\n  font-size: 2rem;\n  margin-top: 0.5em;\n  margin-bottom: 0.5em;\n  font-family: var(--inter-light);\n\n  @media (--bp-md) {\n    font-size: 1.75rem;\n  }\n}\n\nh2,\n.heading-2 {\n  font-size: 1.5rem;\n  margin-bottom: 0.75em;\n\n  @media (--bp-md) {\n    font-size: 1.375rem;\n  }\n}\n\nh3 {\n  font-size: 1.375rem;\n  margin-bottom: 0.75em;\n\n  @media (--bp-md) {\n    font-size: 1.25rem;\n  }\n}\n\nh4,\n.heading-4 {\n  font-size: 1.25rem;\n  margin-bottom: 0.5em;\n}\n\nh5,\n.heading-5 {\n  font-family: var(--inter-light);\n  text-transform: uppercase;\n  font-size: var(--txt-sm);\n  margin-bottom: 0.5em;\n}\n\n.lead {\n  margin-bottom: 2rem;\n  padding-bottom: 0.5rem;\n  border-bottom: 2px solid var(--border-gray);\n\n  p {\n    font-size: var(--txt-xl);\n  }\n\n  @media (--bp-md) {\n    margin-bottom: 1.25rem;\n    padding-bottom: 0;\n\n    p {\n      font-size: var(--txt-lg);\n    }\n  }\n}\n\np {\n  font-size: var(--txt-lg);\n  line-height: var(--line-height);\n  margin-bottom: 1rem;\n\n  + p {\n    margin-top: -0.5rem;\n  }\n\n  @media (--bp-md) {\n    font-size: var(--txt-md);\n  }\n}\n\np.verified {\n  color: var(--body-txt);\n}\n\np.no-data.data {\n  color: var(--txt-gray);\n}\n\n.text-large {\n  font-size: var(--txt-lg);\n}\n\n.text-medium {\n  font-size: var(--txt-md);\n}\n\n.text-small {\n  font-size: var(--txt-sm);\n}\n\n/* only for body text, Akkurat links and buttons need separate handling */\nstrong,\nb,\n.text-bold {\n  font-family: var(--inter-bold);\n  font-weight: normal;\n}\n\nem {\n  font-style: italic;\n}\n\n.verbatim {\n  text-transform: none;\n}\n\ncode,\n.code {\n  font-family: monospace;\n  color: var(--txt-gray);\n}\n\n.error-txt {\n  color: var(--error-red);\n  font-size: var(--txt-sm) !important;\n}\n\n.suggestion-txt {\n  font-style: italic;\n  color: var(--txt-green);\n  font-size: var(--txt-sm);\n  display: block;\n  line-height: normal;\n\n  &.md {\n    font-size: var(--txt-md);\n  }\n}\n","/* Overall page structure */\n\n* {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n*,\n::after,\n::before {\n  box-sizing: border-box;\n}\n\nbody {\n  min-height: 100vh;\n  font-family: var(--inter-regular);\n  font-size: 16px;\n  line-height: 1.5;\n  color: var(--body-txt);\n  scroll-behavior: smooth;\n  display: flex;\n  padding: env(safe-area-inset-top, 1.25rem) env(safe-area-inset-right, 1.25rem) env(safe-area-inset-bottom, 1.25rem)\n    env(safe-area-inset-left, 1.25rem);\n}\n\n#root,\n.page-wrapper {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n}\n\n.panel {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  background-color: var(--body-gray);\n\n  .content {\n    padding-top: 2rem;\n    padding-bottom: 4rem;\n\n    @media (--bp-lg) {\n      padding-top: 1.5rem;\n      padding-bottom: 3rem;\n    }\n  }\n}\n\n/* in common for content pages and landing */\n#content {\n  height: 100%;\n}\n\n/* same styling as .phoneview-form-container, #delete-account-container,#change-password-container */\n\n/* in Email.js = replaced these with with <article> */\n#content article {\n  margin-bottom: 2.5rem;\n  padding-bottom: 2.5rem;\n  border-bottom: 1px solid var(--border-gray);\n\n  &:last-of-type {\n    border-bottom: none;\n    margin-bottom: 0;\n  }\n\n  @media (--bp-md) {\n    margin-bottom: 1.75rem;\n    padding-bottom: 1.75rem;\n  }\n\n  /* nested */\n  article {\n    margin-bottom: 1.75rem;\n    padding-bottom: 1.75rem;\n    border-bottom: 1px dashed var(--border-gray);\n\n    @media (--bp-md) {\n      margin-bottom: 1rem;\n      padding-bottom: 1rem;\n    }\n\n    &:last-of-type {\n      padding-bottom: 0;\n    }\n  }\n}\n\n/* this is a horizontal-margin and should be renamed */\n.horizontal-content-margin,\n.vertical-content-margin {\n  padding: 0;\n  width: 58%;\n  max-width: 870px;\n  margin: 0 auto;\n\n  /* this is added to prevent margin collapse (look for other solution if causing problems) */\n  display: flex;\n  flex-direction: column;\n}\n\n/* Mimic lead paragraph border */\nhr.border-line {\n  margin: 0.5rem 0 2rem;\n  border-bottom: 2px solid var(--border-gray);\n  border-top: none;\n  opacity: unset;\n}\n\nhr.border-line-lesser {\n  border-bottom: 1px dashed var(--border-gray);\n}\n\n/* eg for help-texts */\n.top-divider {\n  border-top: 1px dashed var(--txt-gray);\n  margin: 0.5rem 0 0;\n  padding: 0.5rem 1rem 0.25rem 0;\n  display: block;\n}\n\n@media (--bp-lg) {\n  .horizontal-content-margin,\n  .vertical-content-margin {\n    width: calc(80% - 2rem);\n  }\n}\n\n@media (--bp-md) {\n  .horizontal-content-margin,\n  .vertical-content-margin {\n    width: calc(80% - 1.25rem);\n  }\n}\n\n@media (--bp-sm) {\n  .horizontal-content-margin,\n  .vertical-content-margin {\n    width: calc(100% - 2rem);\n  }\n}\n\n@media (--bp-xs) {\n  .horizontal-content-margin,\n  .vertical-content-margin {\n    width: calc(100% - 2 * var(--margin));\n  }\n}\n\n/* Utility classes - possibly move to separate file */\n.flex-between {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  &.baseline {\n    align-items: baseline;\n  }\n}\n\n/* hides object from view but still accessible to screen readers */\n.visuallyhidden {\n  border: 0;\n  clip-path: inset(50%);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n\n.display-none {\n  display: none;\n}\n\n/* Spacing utility classes */\n.m-b-md {\n  margin-bottom: 1.5rem;\n}\n","/* Form layout elements */\n\n/* top margin here assumes that text above has bottom margin of 1rem */\n.single-input-form .form-group {\n  margin-bottom: 0;\n  width: 100%;\n\n  & .text-muted {\n    margin-top: 0;\n  }\n}\n\n/* text under inputs */\n.small,\nsmall {\n  font-size: 100% !important;\n\n  &.form-text {\n    margin-top: 0 !important;\n  }\n}\n\n.form-group {\n  margin-bottom: 0;\n}\n\nform {\n  display: flex;\n  flex-direction: column;\n  margin-top: 1.25rem;\n\n  .form-wrapper {\n    min-height: 6rem;\n    margin-bottom: 0.5rem;\n  }\n\n  /* places two wrapped input groups on one row */\n  .input-pair {\n    @media (--bp-xl-up) {\n      display: flex;\n      justify-content: space-between;\n      align-items: flex-start;\n      column-gap: 1rem;\n\n      > .form-wrapper {\n        flex: 1;\n      }\n    }\n  }\n}\n\n.input-container {\n  margin-bottom: 1.125rem;\n  margin-right: 0.5rem;\n  flex: 1;\n}\n\n.element-pair,\n.button-pair {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n}\n\n.element-pair {\n  margin-top: 1rem;\n  align-items: unset;\n}\n\n/* single input and button on a row */\n.single-input-form {\n  flex-direction: row;\n  align-items: center;\n\n  .buttons {\n    align-self: center;\n  }\n\n  button {\n    margin: 0.5rem 0 0 1rem;\n  }\n\n  @media (--bp-sm) {\n    flex-direction: column;\n\n    button {\n      margin: 0;\n    }\n  }\n}\n\n#reset-password-email-form {\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n\n  @media (--bp-sm) {\n    flex-direction: column;\n    align-items: unset;\n\n    button {\n      width: 100%;\n      margin-top: 1rem;\n    }\n  }\n}\n\n/* fieldset used to group, possibly incorrectly */\nfieldset {\n  width: 100%;\n  position: relative;\n\n  &:not(:empty, :last-of-type) {\n    margin-bottom: 1.25em;\n  }\n\n  legend {\n    display: flex;\n    flex-direction: column;\n    font-size: var(--txt-md);\n    font-family: var(--inter-bold);\n    letter-spacing: 0.5px;\n    line-height: 1;\n    color: var(--body-txt);\n    margin: 0 5px 5px 0;\n  }\n\n  legend.required::after {\n    content: \" *\";\n    color: var(--txt-orange);\n  }\n}\n\n.input-validate-error {\n  font-family: monospace;\n  font-size: var(--txt-xs);\n  color: var(--error-red);\n  display: inline-block;\n  line-height: 1.3;\n  margin-top: 5px;\n}\n\n.input-label-help-text-container,\n.response-code-inputs {\n  display: flex;\n  flex-flow: row wrap;\n  align-items: baseline;\n\n  & label {\n    letter-spacing: 0;\n    font-size: var(--txt-md);\n  }\n\n  /* for orange asterisk after label */\n  & label.required::after {\n    content: \" *\";\n    color: var(--txt-orange);\n  }\n\n  /* is this used? I think not // */\n  & .help-block {\n    font-size: var(--txt-md);\n    text-transform: lowercase;\n  }\n}\n\n.response-code-inputs {\n  label {\n    width: 100%;\n  }\n}\n\n/* smallish grayish additional info underneath corresponding form elements */\n.help-text {\n  margin: 0.5rem 0 0;\n  color: var(--txt-gray);\n  font-size: var(--txt-sm);\n  line-height: 1.3;\n\n  &.black {\n    color: var(--body-txt);\n  }\n\n  .btn + & {\n    @media (--bp-md) {\n      text-align: center;\n    }\n\n    @media (--bp-xs) {\n      margin: 0 0 0.75rem;\n    }\n  }\n}\n","/* Inputs and form controls, mainly non button */\ninput {\n  box-sizing: border-box;\n  font-family: var(--inter-regular);\n  font-size: var(--txt-xl);\n  color: var(--body-txt);\n  box-shadow: none;\n  border-radius: 0;\n  border: none;\n  width: 100%;\n  padding: 1.25rem 0.5rem;\n  height: 3rem;\n  background-color: var(--contrast-color);\n}\n\n/* Form controls and interactive states */\ninput,\ninput.is-valid,\ninput:focus,\ninput.is-valid:focus {\n  outline: var(--border-width) solid var(--border-gray);\n  background-image: none;\n  background-color: var(--contrast-color);\n  transition: none;\n  border: none;\n  box-shadow: none;\n}\n\ninput::placeholder {\n  font-family: var(--inter-regular);\n  font-size: var(--txt-xl);\n}\n\n:hover:not(:focus, :disabled) {\n  &[type=\"text\"],\n  &[type=\"password\"],\n  &[type=\"email\"] {\n    padding-top: calc(1.25rem + var(--border-width));\n    border-bottom: var(--border-width) solid var(--body-txt) !important;\n  }\n}\n\ninput.is-invalid,\ninput.is-invalid:focus {\n  outline: var(--border-width) solid var(--error-red-t);\n  background-image: none;\n}\n\n/* tab-focus */\n:focus-visible,\n#mfa-security-key:focus {\n  outline: var(--border-width) dashed var(--body-txt) !important;\n  transition: none !important;\n\n  /* has parents with overflow hidden */\n  table & {\n    outline-offset: calc(-1 * var(--border-width));\n  }\n\n  &.toggle-checkbox + .toggle-switch {\n    outline: var(--border-width) dashed var(--body-txt) !important;\n    transition: none;\n  }\n}\n\ninput:disabled,\ninput[readonly] {\n  color: var(--txt-txt);\n  background-color: var(--bg-gray);\n  pointer-events: none;\n  cursor: not-allowed;\n\n  :focus,\n  :hover {\n    outline: none;\n  }\n}\n\ninput[readonly] {\n  outline: none;\n}\n\n/* removing chrome autocomplete babyblue */\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ntextarea:-webkit-autofill,\ntextarea:-webkit-autofill:hover,\ntextarea:-webkit-autofill:focus,\nselect:-webkit-autofill,\nselect:-webkit-autofill:hover,\nselect:-webkit-autofill:focus {\n  box-shadow: 0 0 0 1000px var(--contrast-color) inset !important;\n}\n\n/* Radio buttons */\ninput[type=\"radio\"] {\n  /* remove standard background appearance */\n  appearance: none;\n  outline: none;\n  margin: 0;\n\n  /* create custom radio button appearance */\n  display: inline-block;\n  width: 1rem;\n  height: 1rem;\n  min-width: 1rem;\n  min-height: 1rem;\n  align-self: center;\n\n  /* background-color only for content */\n  background-clip: content-box;\n  box-shadow: var(--shadow-lg);\n  border: var(--border-width) solid var(--bright-orange);\n  background-color: transparent;\n  border-radius: 50%;\n\n  /* to prevent overwrite from input padding, this ensures that the radio button remains round */\n  padding: 0;\n\n  &:hover {\n    background-color: var(--bright-orange);\n    cursor: pointer;\n    border: none;\n  }\n\n  &:checked {\n    background-color: var(--bright-orange);\n    border: none;\n\n    .error {\n      background: var(--error-red);\n      color: var(--contrast-color);\n      border: none;\n    }\n  }\n}\n\n/* optional styles for centering radio buttons */\n.radio-input-container {\n  display: flex;\n\n  label {\n    margin-top: 5px;\n\n    &:hover {\n      cursor: pointer;\n    }\n  }\n\n  span {\n    font-size: var(--txt-xl);\n    align-self: center;\n    color: var(--body-txt);\n    font-family: var(--inter-regular);\n    font-weight: normal;\n    margin: 0 2rem 0 0;\n    margin-left: 8px;\n  }\n}\n\n/* Login username-pw / reset-password set-new-password */\n.password-input {\n  position: relative;\n\n  input[name=\"currentPassword\"].is-valid {\n    background-image: none;\n  }\n}\n\n#copy-new-password {\n  background-color: var(--bg-gray);\n}\n\ninput#display-none-new-password {\n  display: none;\n}\n\n/* Checkbox */\ninput[type=\"checkbox\"] {\n  height: 1rem;\n  width: 1rem;\n  margin-right: 0.5rem;\n  border: none;\n  outline: none;\n  box-shadow: none;\n}\n\n/* Switch toggle */\n.toggle {\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  > legend,\n  > span {\n    flex: 1;\n  }\n\n  > span {\n    margin-right: 10px;\n  }\n}\n\n.toggle-switch {\n  display: inline-block;\n  background: var(--border-gray);\n  border-radius: 16px;\n  width: 54px;\n  height: 28px;\n  position: relative;\n  vertical-align: middle;\n  transition: all 0.25s;\n\n  &::before,\n  &::after {\n    content: \"\";\n  }\n\n  &::before {\n    display: block;\n    background: var(--contrast-color);\n    border-radius: 50%;\n    width: 22px;\n    height: 22px;\n    position: absolute;\n    top: 3px;\n    left: 3px;\n    transition: left 0.25s;\n  }\n\n  .toggle:hover &::before {\n    transform: scale(0.9);\n  }\n\n  .toggle-checkbox:checked + & {\n    background: var(--bright-orange);\n\n    &::before {\n      left: 29px;\n    }\n  }\n}\n\n/* orange moon bc default light bg */\n#color-mode + .toggle-switch {\n  background-repeat: no-repeat;\n  background-image: url(\"../../img/moon-icon-orange.png\");\n  background-position: 82%;\n  background-size: 17px;\n}\n\n/* checked is dark mode */\n#color-mode:checked + .toggle-switch {\n  background-image: url(\"../../img/sun-icon-white.png\");\n  background-position: 10%;\n  background-size: 22px;\n}\n\n.toggle-checkbox {\n  position: absolute;\n  border: 0;\n  clip-path: inset(50%);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  width: 1px;\n}\n\n/* Select */\nselect {\n  padding: 5px;\n  border-radius: 3px;\n  width: 100%;\n  background-color: var(--contrast-color);\n  height: 40px;\n  margin-top: 3px;\n}\n\n/* react-select */\n/* stylelint-disable-next-line selector-class-pattern */\n.select__multi-value__label {\n  font-size: var(--txt-xl) !important;\n  align-self: center !important;\n}\n\n/* Cross browser */\n\n/* Chrome, Safari, Edge, Opera */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=\"number\"] {\n  appearance: textfield;\n}\n\ninput.display-none {\n  display: none;\n}\n\ninput:-webkit-autofill {\n  background-color: transparent !important;\n  box-shadow: 0 0 0 50px var(--contrast-color) inset;\n}\n\n/* Responsive */\n@media (--bp-sm) {\n  input,\n  .radio-input-container span {\n    font-size: var(--txt-md);\n  }\n\n  .input-container {\n    margin: 0;\n  }\n\n  input::placeholder {\n    font-size: var(--txt-md);\n  }\n\n  footer .toggle {\n    flex-direction: column;\n    align-self: end;\n\n    > span {\n      margin: 0 0 5px;\n    }\n  }\n}\n\n@media (--bp-md) {\n  .radio-input-container {\n    flex-direction: column;\n\n    label {\n      margin-bottom: 10px;\n    }\n  }\n}\n","label,\n.form-label {\n  display: flex;\n  font-size: var(--txt-md);\n  font-family: var(--inter-bold);\n  letter-spacing: 0.5px;\n  line-height: 1;\n  color: var(--body-txt);\n  margin: 0 5px 5px 0;\n}\n\n.border-toggle-area {\n  border-color: var(--border-gray);\n  border-width: var(--border-width);\n  border-style: solid;\n  border-radius: 10px;\n  padding: var(--margin);\n\n  label {\n    margin: 0;\n  }\n\n  legend {\n    margin-right: 5px;\n  }\n}\n\n/* stylelint-disable-next-line selector-id-pattern */\n#uniqueId-container label {\n  white-space: nowrap;\n}\n","button:disabled {\n  cursor: not-allowed;\n  pointer-events: all;\n  opacity: 0.4;\n}\n\na.button,\nbutton {\n  font-family: var(--akkurat);\n  letter-spacing: 1px;\n  font-size: var(--txt-md);\n  font-weight: bold;\n  line-height: 1;\n  text-transform: uppercase;\n  height: 3rem;\n  border-radius: 1.5rem;\n  box-shadow: var(--shadow-lg);\n  transition: all 0.3s ease;\n  outline: 0;\n  border: none;\n  cursor: pointer;\n}\n\nbutton:disabled,\nbutton.disabled {\n  cursor: not-allowed !important;\n  pointer-events: all !important;\n  border-color: inherit;\n  color: var(--contrast-color);\n\n  &.primary {\n    background-color: var(--btn-orange);\n  }\n}\n\nbutton.primary,\nbutton.primary:not(:disabled, .disabled):active,\nbutton.primary:not(:disabled, .disabled):focus,\nbutton.primary:not(:disabled, .disabled):active:focus,\nbutton.primary:not(:disabled, .disabled):hover {\n  color: #fff;\n  border: solid 2px var(--bright-orange);\n  background-color: var(--btn-orange);\n  box-shadow: none;\n  min-width: 100px;\n  padding: 0 1.125rem;\n\n  &.sm {\n    padding: 0.5rem 1rem;\n    font-size: 13px;\n    min-width: fit-content;\n    width: auto;\n    height: auto;\n    margin-top: 0;\n    margin-bottom: 0;\n    letter-spacing: 1px;\n  }\n}\n\nbutton.secondary,\nbutton.secondary:not(:disabled, .disabled):active,\nbutton.secondary:not(:disabled, .disabled):focus,\nbutton.secondary:not(:disabled, .disabled):active:focus,\nbutton.secondary:not(:disabled, .disabled):hover {\n  color: var(--txt-orange);\n  border: solid 2px var(--bright-orange);\n  background-color: var(--contrast-color);\n  box-shadow: none;\n  min-width: 100px;\n  padding: 0 1.125rem;\n\n  /* Login, Logout, Register button in Header */\n  &.sm {\n    padding: 0.5rem 1rem;\n    font-size: 13px;\n    min-width: fit-content;\n    width: auto;\n    height: auto;\n    margin-top: 0;\n    margin-bottom: 0;\n    letter-spacing: 1px;\n  }\n}\n\nbutton.primary,\nbutton.secondary,\n/* stylelint-disable-next-line selector-class-pattern */\n.mfa-select .react-select__control {\n  &:hover {\n    transform: scale(0.95);\n\n    &:disabled,\n    .disabled {\n      transform: scale(1);\n    }\n  }\n}\n\n/* CLOSE buttons in modals */\nbutton.close {\n  background-color: transparent;\n  margin: 0;\n  box-shadow: none;\n  height: 1rem;\n  width: 1rem;\n  position: relative;\n  display: inline-block;\n  cursor: pointer;\n\n  &:hover,\n  &:not(:disabled, .disabled):active,\n  &:not(:disabled, .disabled):focus,\n  &:not(:disabled, .disabled):active:focus {\n    background-color: transparent;\n    box-shadow: none;\n    transform: scale(0.8);\n  }\n\n  &.sm {\n    font-size: var(--txt-xs);\n  }\n}\n\n.close::before,\n.close::after {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 20px;\n  height: 2px;\n  background-color: var(--body-txt);\n  transform-origin: center;\n\n  :hover > & {\n    background-color: var(--bright-orange);\n  }\n}\n\n.close::before {\n  transform: translate(-50%, -50%) rotate(45deg);\n}\n\n.close::after {\n  transform: translate(-50%, -50%) rotate(-45deg);\n}\n\n/* styles for links that are also buttons */\nbutton.link {\n  background-color: transparent;\n  color: var(--txt-orange);\n  border-radius: 0;\n  border: none;\n  box-shadow: none;\n  margin: 0;\n  text-decoration: none;\n  padding: 0;\n  line-height: 1.25;\n\n  &:hover,\n  &:active {\n    color: var(--txt-orange);\n    background-color: transparent;\n    text-decoration: underline;\n    box-shadow: none;\n  }\n\n  &.sm {\n    font-size: var(--txt-xs);\n  }\n\n  &.normal-case {\n    text-transform: none;\n  }\n\n  &.disabled,\n  &:disabled,\n  &[disabled] {\n    color: var(--txt-gray);\n    opacity: 1;\n    box-shadow: none;\n    text-decoration: none;\n  }\n}\n\n/* icon left of button text */\nbutton.icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  svg,\n  img {\n    margin-right: 0.5rem;\n    width: auto;\n    transition: transform 0.5s;\n  }\n\n  /* round arrow update link */\n  &.refresh:hover svg {\n    transform-origin: center;\n    transform: rotate(360deg);\n  }\n\n  &.refresh[disabled]:hover svg {\n    transform: none;\n  }\n\n  span {\n    text-align: left;\n    line-height: var(--line-height);\n  }\n}\n\n/* TODO possibly replace with .buttons - check SAMLResponseForm */\n.flex-buttons {\n  display: flex;\n  column-gap: 1rem;\n  margin: 1em 0 0;\n\n  button {\n    min-width: 100px;\n  }\n\n  button[type=\"submit\"] {\n    order: 2;\n  }\n}\n\n/* Wraps all buttons for responsive behaviour independent on number */\n.buttons {\n  display: flex;\n  column-gap: 1rem;\n  padding: 0.5rem 0;\n  width: 100%;\n\n  &.flex-direction-column {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 0.5rem;\n    width: 100%;\n  }\n\n  button {\n    min-width: 100px;\n  }\n\n  @media (--bp-xs-up) {\n    width: auto;\n  }\n\n  @media (--bp-md) {\n    justify-content: center;\n    align-self: normal;\n  }\n\n  @media (--bp-xs) {\n    flex-direction: column-reverse;\n\n    &.flex-direction-column {\n      grid-template-columns: 1fr;\n    }\n\n    button[type=\"submit\"] {\n      order: 1;\n    }\n\n    button {\n      margin: 0.5rem 0 !important;\n    }\n  }\n}\n\n.buttons-center {\n  display: flex;\n  column-gap: 1rem;\n  padding: 0.5rem 0;\n  width: 100%;\n  align-items: center;\n}\n\n/* textual toggle control, eg. copy/copied right after input */\n.txt-toggle-btn {\n  height: auto;\n\n  /* and show/hide just before input */\n  &:has(+ input) {\n    position: absolute;\n    right: 0;\n    top: -1.1rem;\n  }\n}\n\n/* Instance/icon unique styles to be set in targeted css */\nbutton.icon-only {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: none;\n  background: transparent;\n  border-color: transparent;\n  margin: 0;\n  padding: 0;\n}\n\n@media (--bp-xs) {\n  button:not(.sm) {\n    font-size: var(--txt-sm);\n  }\n\n  button.primary,\n  button.secondary {\n    width: 100%;\n  }\n\n  button.link {\n    width: auto;\n    padding: 0;\n  }\n}\n\n/* menu name control */\nbutton.header-user {\n  &:hover,\n  &:focus-within {\n    background-color: var(--body-gray) !important;\n  }\n}\n\n/* Scroll To top button */\nbutton.scroll-to-top {\n  display: block;\n  position: fixed;\n  bottom: 7rem;\n  right: 1rem;\n\n  /* round button */\n  border-radius: 50% !important;\n  min-width: fit-content !important;\n  width: 50px;\n  height: 50px;\n  padding: 0 !important;\n\n  @media (--bp-sm) {\n    width: 40px;\n    height: 40px;\n    right: 0.5rem;\n    bottom: 6.5rem;\n  }\n}\n\n.remove {\n  width: 1.2rem;\n  height: 1.2rem !important;\n  background-image: url(\"../../img/remove-icon.svg\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n  cursor: pointer;\n  box-shadow: none !important;\n  background-color: transparent;\n  filter: brightness(0) saturate(100%);\n\n  &:not(:disabled):hover {\n    filter: var(--bright-orange-filter);\n    transform: scale(0.8);\n  }\n}\n\n.copybutton {\n  position: absolute;\n  width: auto !important;\n  right: 1rem;\n\n  svg {\n    color: var(--body-txt);\n  }\n\n  #icon-check {\n    display: none;\n  }\n\n  .tool-tip-text {\n    visibility: hidden;\n    width: 100px;\n    background-color: var(--body-txt);\n    color: var(--contrast-color);\n    font-size: var(--txt-sm);\n    font-family: var(--inter-regular);\n    border-radius: 4px;\n    padding: 6px;\n    position: absolute;\n    z-index: 5;\n    bottom: 85%;\n    left: 1rem;\n    margin-left: -75px;\n    opacity: 0;\n    transition: opacity 0.3s;\n    text-transform: none;\n    line-height: 1.2;\n  }\n\n  .tool-tip-text::after {\n    content: \"\";\n    position: absolute;\n    top: 100%;\n    left: 2.6rem;\n    margin-left: 20px;\n    border-width: 5px;\n    border-style: solid;\n    border-color: var(--body-txt) transparent transparent transparent;\n  }\n\n  &:hover .tool-tip-text {\n    visibility: visible;\n    opacity: 1;\n  }\n}\n\nbutton.flex {\n  display: flex;\n  align-items: center;\n\n  img {\n    width: auto;\n    padding-right: 10px;\n  }\n}\n","/* Textual non-button-styled links */\n\na {\n  color: var(--txt-orange);\n  font-family: var(--akkurat);\n  text-decoration: none;\n  transition: all 0.2s ease;\n  cursor: pointer;\n  border-bottom: none;\n\n  &:hover {\n    color: var(--txt-orange);\n    border-bottom: none;\n    text-decoration: underline;\n  }\n\n  /* hiding opt in beta link */\n  &#stable-link.hidden {\n    display: none;\n  }\n}\n\na .disabled,\na.disabled {\n  color: var(--txt-gray);\n  text-decoration: none;\n  pointer-events: none;\n\n  &:hover {\n    cursor: not-allowed;\n  }\n}\n\n.wizard-link-wrapper {\n  display: flex;\n  justify-content: space-between;\n  padding-top: 2.5rem;\n  gap: 20px;\n  font-size: var(--txt-sm);\n\n  a,\n  .link {\n    display: grid;\n    align-items: center;\n    overflow-wrap: anywhere;\n\n    &.left {\n      grid-template-columns: 0.1fr 1fr;\n    }\n\n    &.right {\n      grid-template-columns: 1fr 0.1fr;\n      justify-items: end;\n      text-align: end;\n    }\n  }\n\n  .link {\n    font-size: 0.875rem;\n    font-weight: 400;\n    letter-spacing: normal;\n  }\n}\n","img {\n  width: 100%;\n}\n\n/* TODO - reuse btn-close instead of these svg icons: remove (Orcid, TableList) and close (CreateGroup, Notifications) */\nsvg {\n  &.remove,\n  &.close {\n    transform-origin: center;\n    transform: rotate(45deg);\n    margin: 0;\n    padding: 0;\n\n    &.remove,\n    &.remove:hover {\n      fill: #ff500d;\n    }\n\n    &.close {\n      fill: #808080;\n\n      &:hover {\n        fill: var(--txt-gray);\n      }\n    }\n  }\n}\n\n.close {\n  opacity: 1;\n}\n\n.circle-icon {\n  box-shadow: var(--shadow-sm);\n  border-radius: 50%;\n  width: 24px !important;\n  height: 24px !important;\n  margin-right: 0.75rem;\n  vertical-align: text-top;\n\n  &.bankid-icon {\n    background: #fff;\n  }\n\n  @media (--bp-md) {\n    width: 20px !important;\n    height: 20px !important;\n    margin-right: 0.5rem;\n  }\n}\n","/* Modals\n-------------------------------------------------- */\ndialog[open] {\n  all: unset;\n}\n\n.modal {\n  display: flex !important;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  overflow: hidden auto;\n  outline: 0;\n  z-index: 100;\n\n  &.show {\n    background-color: rgb(0 0 0 / 50%);\n    transition: opacity 0.3s ease;\n  }\n\n  .modal-dialog.security-confirm-modal {\n    .modal-body {\n      display: block;\n    }\n  }\n\n  /* Note: .modal-dialog styles are defined outside this block\n     because native CSS nesting & does not support BEM concatenation */\n}\n\n.modal-dialog {\n  max-width: calc(870px - 4rem);\n  background-color: var(--contrast-color);\n  border-radius: 20px;\n  margin: auto;\n\n  .modal-content {\n    background-color: var(--contrast-color);\n    border-radius: 20px;\n\n    .modal-header {\n      border-bottom: none;\n      padding: 1.5rem 1.5rem 0;\n      align-items: baseline;\n      display: flex;\n\n      .modal-title {\n        width: 100%;\n        display: flex;\n        text-transform: none;\n        justify-content: space-between;\n        font-size: 1.5rem;\n        margin-bottom: 0.75em;\n      }\n    }\n\n    .modal-body {\n      padding: 0 1.5rem 1rem;\n      display: flex;\n      flex-direction: column;\n      font-size: var(--txt-xl);\n      line-height: 1.4;\n\n      /* captcha image */\n      img {\n        padding-bottom: 1rem;\n      }\n\n      audio {\n        margin-bottom: 1rem;\n      }\n\n      input {\n        background-color: var(--body-gray);\n      }\n\n      form {\n        margin-top: 0;\n      }\n\n      /* move to lists? */\n      ol {\n        list-style-position: inside;\n        list-style-type: decimal;\n\n        li {\n          margin-bottom: 1.125rem;\n\n          span {\n            margin-top: 0.5rem;\n            font-family: var(--inter-bold);\n            display: block;\n            font-size: var(--txt-md);\n          }\n        }\n      }\n\n      @media (--bp-lg) {\n        font-size: var(--txt-lg);\n\n        input {\n          font-size: inherit;\n\n          &::placeholder {\n            font-size: inherit;\n          }\n        }\n      }\n    }\n\n    .modal-footer {\n      border-top: none;\n      margin: 1rem 1rem 2rem;\n      padding-top: 0;\n      padding-bottom: 0;\n      display: flex;\n      justify-content: center;\n      flex-direction: column;\n      align-items: center;\n      text-align: center;\n    }\n  }\n\n  @media (--bp-lg) {\n    .modal-body {\n      font-size: var(--txt-lg);\n\n      input {\n        font-size: inherit;\n\n        &::placeholder {\n          font-size: inherit;\n        }\n      }\n    }\n  }\n}\n","/** Table styles **/\n\ntable {\n  width: 100%;\n  font-size: var(--txt-lg);\n  font-family: var(--inter-light);\n  table-layout: fixed;\n  background-color: var(--contrast-color);\n\n  @media (--bp-md) {\n    font-size: var(--txt-md);\n  }\n\n  & tbody {\n    margin-bottom: 1rem;\n\n    & th:first-child {\n      padding-left: 1rem;\n      line-height: 1;\n    }\n\n    & td {\n      text-align: left;\n      vertical-align: middle;\n      line-height: 1;\n\n      &.value-status {\n        & button {\n          margin: 0;\n          padding: 0;\n        }\n\n        & span {\n          font-family: var(--akkurat);\n          letter-spacing: 1px;\n          font-weight: bold;\n          padding: 0;\n          font-size: var(--txt-xs);\n          text-transform: uppercase;\n        }\n      }\n\n      .verified {\n        text-transform: uppercase;\n        font-size: var(--txt-xs);\n        font-family: var(--inter-bold);\n        font-weight: normal;\n      }\n\n      &.remove-data {\n        & .icon-button {\n          margin: 0;\n          padding: 0;\n        }\n      }\n\n      &.primary {\n        color: var(--body-txt);\n      }\n\n      &.verified,\n      &.unverified,\n      &.primary {\n        padding: 0.75rem 1rem;\n      }\n\n      .btn-remove-webauthn {\n        padding: 0;\n      }\n    }\n\n    & tr {\n      &.border-row {\n        font-size: var(--txt-xs);\n        border-bottom: 1px solid var(--border-gray);\n        height: 2rem;\n\n        &:last-of-type {\n          border-bottom: none;\n        }\n      }\n\n      &td:first-child {\n        padding-left: 1rem;\n        padding-right: 1rem;\n      }\n    }\n\n    & tr.status {\n      height: auto;\n\n      td:last-child {\n        text-align: center;\n\n        a {\n          font-size: var(--txt-xs);\n        }\n      }\n    }\n\n    & tr.display-none {\n      display: none;\n    }\n  }\n\n  .email-display & {\n    tr.display-none {\n      display: none;\n    }\n\n    tr {\n      display: grid;\n      grid-template-columns: 3fr 1.5fr 0.5fr;\n      gap: 5px;\n      align-items: center;\n    }\n\n    tr > * {\n      overflow: hidden;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n    }\n\n    tr:not(:last-child) {\n      border-bottom: 1px solid var(--body-gray);\n    }\n  }\n}\n\ncaption {\n  caption-side: top;\n  color: inherit;\n}\n\n/* Help page list */\n.keys,\n  /* Security keys in use */\n  .active-keys {\n  table-layout: auto;\n  font-size: var(--txt-sm);\n\n  tr {\n    height: auto;\n  }\n\n  th {\n    border-bottom: 2px dashed var(--border-gray);\n    padding: 1rem 0.5rem 0.75rem;\n\n    &:first-child {\n      width: 2rem;\n    }\n  }\n\n  th,\n  td {\n    vertical-align: top;\n    line-height: 1.25;\n\n    &:first-child {\n      padding-left: 1rem;\n    }\n\n    &:last-child {\n      padding-right: 1rem;\n    }\n  }\n\n  td {\n    overflow-wrap: break-word;\n    padding: 0.5rem;\n  }\n}\n\n.keys {\n  font-family: monospace;\n  color: var(--txt-gray);\n\n  tr {\n    &:nth-child(even) {\n      background-color: var(--bg-gray);\n    }\n\n    th {\n      &:first-child {\n        width: 2rem;\n      }\n    }\n  }\n}\n\n.key-update {\n  display: flex;\n  align-items: center;\n  column-gap: 2rem;\n\n  label {\n    display: inline-block;\n  }\n}\n\n.table-responsive {\n  overflow-x: inherit;\n}\n","/* styles for ordered list with large number */\n\n.listed-steps {\n  margin-left: var(--list-indent);\n  list-style-type: decimal;\n\n  li {\n    font-size: var(--txt-lg);\n    line-height: 1.25;\n    margin-bottom: 2em;\n\n    &::marker {\n      font-size: var(--txt-md);\n      font-family: var(--akkurat);\n      font-weight: bold;\n    }\n\n    fieldset:last-of-type {\n      margin-bottom: 0;\n    }\n  }\n\n  @media (--bp-sm) {\n    /* counteracts additional list left margin in mobile mode */\n    .x-adjust {\n      margin-left: calc(-1 * var(--list-indent));\n    }\n  }\n}\n\ndl.terms {\n  dt {\n    font-size: 1.25rem;\n    margin-bottom: 0.5em;\n  }\n\n  dd {\n    margin-bottom: 0.5rem;\n    font-size: var(--txt-md);\n    display: list-item;\n    list-style-position: inside;\n\n    + dt {\n      margin-top: 1.5rem;\n    }\n  }\n\n  margin-bottom: 1rem;\n}\n\n.nested {\n  margin: 0.5rem 0 0 0.5rem;\n  list-style: circle;\n\n  li {\n    margin: 0 0 0.75rem 1.75rem;\n  }\n}\n\nul.bullets,\nol.numbers {\n  list-style-position: inside;\n  margin-bottom: 1.5rem;\n\n  > li {\n    list-style-position: inside;\n    margin-bottom: 1rem;\n  }\n}\n\nul.bullets {\n  list-style-type: disc;\n}\n\nol.numbers {\n  list-style: numeric;\n}\n\nul.bullets ol {\n  list-style: numeric;\n  list-style-position: inside;\n  margin-bottom: 1rem;\n  margin-top: 0.5rem;\n  margin-left: 1rem;\n}\n","/* White plate to highlight content, use .figure if not semantically a \"figure\" */\n\nfigure,\n.figure {\n  background: var(--contrast-color);\n  text-align: center;\n  margin: 1em 0;\n  padding: 1em;\n  position: relative;\n\n  figcaption,\n  .figcaption {\n    font-size: var(--txt-sm);\n    font-weight: bold;\n    font-family: var(--akkurat);\n    color: var(--body-txt);\n  }\n\n  &.identity-summary {\n    padding: 1em 0.5em;\n    align-items: center;\n    margin: 0;\n\n    @media (--bp-md) {\n      padding: 0.5em;\n    }\n\n    &:not(:last-of-type) {\n      border-bottom: 1px solid var(--bg-gray);\n    }\n\n    &:last-of-type {\n      margin-bottom: 1em;\n    }\n  }\n\n  &.tight {\n    padding: 0.5rem 1rem;\n  }\n\n  &.grid-container {\n    display: grid;\n    grid-template-columns: 10% 35% 50% 5%;\n    text-align: left;\n    vertical-align: middle;\n    line-height: 1;\n\n    > div {\n      padding: 0.3rem;\n      align-self: center;\n\n      .display-data.verified {\n        font-size: var(--txt-md);\n      }\n    }\n\n    .close {\n      align-self: center;\n    }\n  }\n}\n\n.captcha-responsive {\n  width: 70%;\n  margin-left: auto;\n  margin-right: auto;\n\n  button.refresh {\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  @media (--bp-md) {\n    width: 100%;\n\n    audio {\n      width: 100%;\n    }\n  }\n}\n\n/* white with orange rounded border */\n.notice-box {\n  padding: 1.25rem 1rem 0.5rem;\n  margin: 1rem 0;\n  border: 1px solid var(--bright-orange);\n  border-radius: 10px;\n  background: var(--contrast-color);\n\n  .help-text {\n    padding-bottom: 0.75rem;\n  }\n\n  ul.bullets {\n    list-style-position: inside;\n    list-style-type: disc;\n    margin-bottom: 1.5rem;\n  }\n}\n\n/* SECURITY TABLE */\nfigure.webauthn-token-holder {\n  display: grid;\n  grid-template-columns: 7% 93%;\n  padding: 0.5rem 1rem;\n  text-align: left;\n  margin: 0;\n  border-bottom: 1px solid var(--bg-gray);\n\n  > div span[aria-label=\"date used\"] {\n    margin-left: 1.5em;\n  }\n\n  img {\n    margin-top: 0.3rem;\n    width: 80%;\n  }\n\n  &:first-of-type {\n    margin-top: 1rem;\n  }\n\n  &:last-of-type {\n    border-bottom: none;\n    margin-bottom: 1rem;\n  }\n\n  & div:first-child {\n    display: flex;\n    justify-content: space-between;\n  }\n\n  & div:nth-child(2) {\n    & p:last-child {\n      margin-left: 1rem;\n    }\n  }\n\n  span {\n    font-size: var(--txt-sm);\n    margin-bottom: 0.2rem;\n  }\n\n  .verified {\n    strong {\n      font-family: var(--akkurat);\n      letter-spacing: 1px;\n      font-weight: bold;\n      padding: 0;\n      font-size: var(--txt-xs);\n      text-transform: uppercase;\n    }\n  }\n\n  .link {\n    height: auto;\n    margin-right: 2rem;\n  }\n\n  button.close {\n    justify-self: flex-end;\n  }\n}\n","/** Digital timer **/\n\n.expires-meter {\n  color: var(--body-txt);\n  font-size: var(--txt-xl);\n  text-align: center;\n\n  .expires-symbol {\n    padding-right: 0.5rem;\n    line-height: 1;\n\n    svg {\n      height: 1.25rem;\n      width: 1.25rem;\n    }\n  }\n\n  .timer {\n    margin-top: 0;\n    font-family: var(--akkurat);\n\n    a {\n      margin-right: 0.5rem;\n    }\n\n    .display-none {\n      display: none;\n    }\n\n    span#timer-in {\n      font-family: var(--akkurat);\n      color: var(--txt-gray);\n      font-size: var(--txt-md);\n    }\n  }\n}\n",".help-content > li {\n  border-bottom: 1px solid var(--border-gray);\n  padding-top: 2rem;\n  padding-bottom: 2rem;\n\n  &:last-child {\n    border-bottom: none;\n  }\n}\n\n.help-content {\n  article {\n    padding-bottom: 1em !important;\n\n    > h5 {\n      margin-top: -2rem;\n      padding-top: 2rem;\n    }\n  }\n\n  h3 {\n    line-height: 1.2;\n    font-size: 1.5rem;\n    margin-bottom: 0.75em;\n  }\n\n  h4:not(:first-of-type) {\n    margin-top: 1.25em;\n  }\n\n  p {\n    font-size: inherit;\n    margin-bottom: 1.25em;\n  }\n\n  section {\n    padding: 1.25rem 1rem 0.5rem;\n    margin: 1rem 0;\n    border: 1px solid var(--bright-orange);\n    border-radius: 10px;\n    background: var(--contrast-color);\n  }\n\n  .accordion:not(:last-child) {\n    margin-bottom: 1rem;\n  }\n\n  dl.link-list {\n    margin-bottom: 2rem;\n\n    dt {\n      margin-bottom: 0.5rem;\n    }\n\n    dd a::before {\n      content: \"➔ \";\n    }\n  }\n}\n","table.orcid {\n  tr {\n    height: auto;\n\n    td {\n      &.orcid-link {\n        vertical-align: middle;\n        padding: 0.75rem 0;\n      }\n\n      &:first-of-type,\n      &:last-of-type {\n        vertical-align: top;\n        width: 3rem;\n        padding: 0.75rem 1rem;\n      }\n    }\n  }\n}\n\nspan.orcid-logo {\n  background: url(\"../../img/vector_iD_icon.svg\");\n  background-repeat: no-repeat;\n}\n\n/* remove or merge with above? */\n.orcid-logo {\n  display: inline-flex;\n  height: 22px;\n  width: 22px;\n  position: relative;\n}\n\n.orcid-link {\n  font-size: var(--txt-md);\n  line-height: 1.2;\n  overflow-wrap: anywhere;\n\n  a {\n    margin: 0;\n  }\n}\n\nbutton .orcid-logo {\n  height: 22px;\n  width: 22px;\n}\n","fieldset.toggle-change-password-options {\n  padding-bottom: 2rem;\n  margin-bottom: 0.75rem;\n  border-bottom: 1px solid var(--border-gray);\n}\n\n.pw-suggested {\n  margin-top: 1.25rem;\n}\n\n.password-custom-help {\n  list-style-type: disc;\n  margin: 1rem;\n}\n\n/* Password strength meter */\n\n.meter-wrapper {\n  background: var(--border-gray);\n  border-radius: 10px;\n  height: 20px;\n  overflow: hidden;\n  line-height: 0;\n  margin-bottom: 1.25rem;\n\n  .form-field-error-area:empty + & {\n    display: none;\n  }\n}\n\nmeter {\n  width: 100%;\n  height: 20px;\n  border: none;\n  background: repeating-linear-gradient(\n    -55deg,\n    var(--border-gray),\n    var(--border-gray) 10px,\n    var(--bg-gray) 10px,\n    var(--bg-gray) 20px\n  );\n}\n\n/* Webkit browsers */\nmeter::-webkit-meter-bar {\n  height: 20px;\n  background: repeating-linear-gradient(\n    -55deg,\n    var(--border-gray),\n    var(--border-gray) 10px,\n    var(--bg-gray) 10px,\n    var(--bg-gray) 20px\n  );\n}\n\nmeter::-webkit-meter-optimum-value {\n  background: var(--txt-gray);\n  border-top-left-radius: 10px;\n  border-bottom-left-radius: 10px;\n}\n\n/* Works in case we need more steps and colors, eg 1-4. */\n\n/* meter[value=\"1\"]::-webkit-meter-optimum-value { */\n\n/*   background: var(--error-red); */\n\n/* } */\n\n/* Gecko browsers */\n:-moz-meter-optimum::-moz-meter-bar {\n  background: var(--txt-gray);\n}\n\n.form-field-error-area {\n  font-size: var(--txt-xs) !important;\n  color: var(--error-red) !important;\n  font-weight: bold;\n  margin-top: 0.75rem;\n  display: inline-block;\n}\n\n.form-field-error-area.success {\n  color: var(--txt-green) !important;\n}\n","/* --- PROFILE STYLES --- // */\n.profile-grid-cell {\n  display: flex;\n  flex-direction: column;\n\n  .display-nin-show-hide {\n    display: flex;\n\n    /* show and hide button */\n    button {\n      margin: 0 0.5rem;\n      height: auto;\n    }\n  }\n}\n\n/* stylelint-disable-next-line selector-id-pattern */\n#uniqueId-container {\n  display: flex;\n  flex-direction: row;\n  align-items: baseline;\n\n  button.link {\n    padding: 0.75rem 0 0.75rem 1rem;\n  }\n}\n\n.display-data {\n  font-size: var(--txt-xl);\n  overflow-wrap: break-word;\n\n  &:not(a) {\n    font-family: var(--inter-light);\n  }\n\n  &.no-data {\n    color: var(--txt-gray);\n  }\n\n  &.verified {\n    color: var(--body-txt);\n  }\n\n  @media (--bp-md) {\n    font-size: var(--txt-lg);\n\n    &:not(a) {\n      font-family: var(--inter-light);\n    }\n  }\n}\n\n/* --- STATUS OVERVIEW STYLES--- // */\n.status-boxes {\n  margin: 1rem 0;\n}\n\n.status-box {\n  box-shadow: var(--shadow-sm);\n  border-radius: 6px;\n  overflow: hidden;\n  display: grid;\n  grid-template-columns: 30px 1fr;\n  grid-template-rows: auto;\n  gap: 10px;\n  align-items: center;\n  padding: 1rem;\n  background-color: var(--contrast-color);\n  margin-top: 0.5rem;\n  border: 1px var(--success-green) solid;\n\n  h3 {\n    line-height: 1.4;\n    margin-bottom: 0.3rem;\n    color: var(--body-txt);\n  }\n\n  p {\n    margin-bottom: 0.5rem;\n  }\n\n  &.success {\n    border-color: rgb(23 125 77 / 25%);\n\n    &:nth-of-type(1) {\n      background-color: #f3f9f5;\n      background-color: rgb(23 125 77 / 10%);\n    }\n\n    &:nth-of-type(2) {\n      background-color: #e6f3eb;\n      background-color: rgb(23 125 77 / 20%);\n    }\n\n    &:nth-of-type(3) {\n      background-color: #daede1;\n      background-color: rgb(23 125 77 / 30%);\n    }\n\n    &:nth-of-type(4) {\n      background-color: #cde7d7;\n      background-color: rgb(23 125 77 / 40%);\n    }\n  }\n}\n\n.checkbox-wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  input[type=\"checkbox\"] {\n    display: block;\n    width: 20px;\n    height: 20px;\n  }\n\n  svg {\n    color: var(--txt-green);\n    height: 1.5rem;\n\n    &.disabled {\n      color: var(--border-gray);\n    }\n  }\n\n  div {\n    width: 1.5rem;\n    height: 1.5rem;\n    border: 2px solid var(--border-gray);\n    border-radius: 50%;\n    background-color: var(--contrast-color);\n  }\n}\n\n/* alt option divider */\n.or-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  width: 100%;\n  margin: 2rem auto 0;\n  color: var(--txt-gray);\n\n  span {\n    max-width: 80%;\n    text-align: center;\n  }\n\n  .line {\n    flex: 1;\n    height: 1px;\n    background-color: var(--border-gray);\n  }\n}\n","#suggested-password {\n  display: table;\n  padding: 0.125rem 0.5rem;\n  background: var(--bg-orange);\n  font-size: var(--txt-xxl);\n  border: none;\n  color: var(--bright-orange);\n}\n\n.form-content {\n  width: 100%;\n}\n\n.hide {\n  display: none;\n}\n","footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  padding: 1rem;\n  border-top: 6px solid var(--bright-orange);\n  background-color: var(--body-gray);\n  font-size: var(--txt-sm);\n\n  .logo-wrapper {\n    display: flex;\n    align-items: baseline;\n    font-size: var(--txt-xs);\n\n    .sunet-logo {\n      width: 40px;\n      height: 50px;\n      margin-right: 8px;\n      background-image: url(\"../../img/sunet_logo.svg\");\n      background-size: contain;\n      background-repeat: no-repeat;\n    }\n  }\n}\n\nfooter nav ul {\n  display: flex;\n  align-items: baseline;\n  margin: 0;\n  padding: 0;\n}\n\nfooter nav {\n  /* button link lookalike */\n  .help-link {\n    padding: 0;\n    margin-right: 1rem;\n    letter-spacing: 1px;\n    font-size: var(--txt-sm);\n    line-height: 1;\n  }\n\n  button {\n    height: auto;\n    font-size: var(--txt-sm);\n    font-weight: normal;\n  }\n}\n\nfooter nav .lang-selected {\n  margin: 0;\n  cursor: pointer;\n  color: var(--txt-orange);\n  font-size: var(--txt-sm);\n}\n\n#language-selector {\n  display: flex;\n\n  button.link {\n    svg {\n      margin-right: 0.2rem;\n    }\n  }\n}\n\n.non-selected {\n  margin: 0;\n  display: none;\n}\n\n@media (--bp-xs) {\n  footer {\n    align-items: flex-end;\n\n    nav ul {\n      display: flex;\n      flex-direction: column;\n      align-items: flex-end;\n\n      .help-link {\n        margin-right: 0;\n      }\n    }\n  }\n}\n","/* (desktop first) */\n\nheader {\n  background-color: var(--contrast-color);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem;\n\n  .eduid-logo {\n    width: 113px;\n    height: 40px;\n    background-image: url(\"../../img/eduid-logo.png\");\n    background-size: contain;\n    background-repeat: no-repeat;\n    margin-right: var(--margin);\n    display: flex;\n    flex: 1;\n    text-align: left;\n\n    @media (--bp-md) {\n      height: 34px;\n      width: 95px;\n    }\n  }\n\n  nav {\n    flex: 2;\n\n    .mobile-user-btn {\n      display: none;\n    }\n\n    .nav-menu {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n\n      a {\n        transition: none;\n\n        &.active,\n        &:hover {\n          color: var(--txt-orange) !important;\n        }\n      }\n\n      /* top level menu item */\n      .menu-item-wrapper {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        width: 100%;\n        padding-left: 0.85rem;\n\n        a {\n          color: var(--body-txt);\n          font-size: var(--txt-sm);\n          flex: 1;\n        }\n\n        &:has(a.active) {\n          background-color: var(--body-gray);\n          border-radius: 1.5rem;\n          margin: 0.5rem 0 0.25rem;\n        }\n\n        /* chevron */\n        button {\n          background-color: transparent;\n          box-shadow: none;\n          padding: 0 0.75rem;\n\n          svg {\n            color: var(--body-txt);\n          }\n\n          @media (--bp-xl) {\n            &:hover svg {\n              color: var(--bright-orange);\n            }\n          }\n        }\n      }\n\n      /* note: submenu-open only applied for mobile */\n      .submenu,\n      .submenu-open {\n        li a {\n          color: var(--txt-gray);\n          font-size: var(--txt-xs);\n          display: inline-block;\n          padding: 0.625rem 0.85rem;\n        }\n      }\n\n      .submenu {\n        max-height: 0;\n        margin-bottom: 0;\n        opacity: 0;\n        visibility: hidden;\n      }\n\n      /* individual desktop submenus */\n      @media (--bp-xl-up) {\n        li {\n          display: inline-block;\n        }\n\n        .submenu {\n          position: absolute;\n          min-width: 10rem;\n          z-index: 100;\n          padding-top: 0.5rem;\n          filter: drop-shadow(var(--shadow-nav));\n\n          li {\n            border-bottom: 1px solid var(--body-gray);\n            background: var(--contrast-color);\n            padding-top: 0.25rem;\n\n            &:first-child {\n              border-top-left-radius: 10px;\n              border-top-right-radius: 10px;\n            }\n\n            &:last-child {\n              border-bottom-left-radius: 10px;\n              border-bottom-right-radius: 10px;\n              padding-bottom: 0.375rem;\n            }\n          }\n        }\n\n        /* visible submenus on hover */\n        li:hover {\n          svg {\n            transform: rotate(180deg);\n          }\n\n          .submenu {\n            opacity: 1;\n            visibility: visible;\n            display: flex;\n            flex-direction: column;\n          }\n        }\n      }\n\n      .logout-button-wrapper {\n        display: flex;\n        align-items: center;\n      }\n    }\n\n    /* 2 items: in desktop header / mobile menu */\n    .user-name {\n      overflow: hidden;\n      max-width: 40vw;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      display: inline-block;\n      padding: 0.5rem 1rem 0.5rem 0;\n      font-family: var(--inter-bold);\n      font-size: var(--txt-sm);\n      text-align: right;\n    }\n  }\n\n  /* combined mobile menu */\n  @media (--bp-xl) {\n    nav {\n      flex: unset;\n\n      .mobile-user-btn {\n        display: flex;\n        text-transform: lowercase;\n        background: none;\n        box-shadow: none;\n        padding: 0;\n        align-items: center;\n        color: var(--body-txt);\n\n        svg {\n          font-size: 1.5rem;\n          width: 24px;\n        }\n\n        &:hover svg {\n          color: var(--bright-orange);\n        }\n      }\n\n      .nav-menu {\n        display: none;\n\n        ul {\n          width: 100%;\n        }\n\n        /* visible nav on click */\n        &.active {\n          display: flex;\n          flex-direction: column;\n          opacity: 1;\n          position: absolute;\n          top: 4.5rem;\n          right: var(--margin);\n          width: 20rem;\n          background-color: var(--contrast-color);\n          box-shadow: var(--shadow-nav);\n          border-radius: 10px;\n          padding: var(--margin);\n          z-index: 200;\n          transition: all 0.5s ease;\n        }\n\n        .logout-button-wrapper {\n          margin: 0.5rem 0;\n          padding-top: 1rem;\n          border-top: 1px solid var(--border-gray);\n          width: calc(100% - 1.7rem);\n\n          .user-name {\n            display: none;\n          }\n        }\n\n        /* small screen full width menu */\n        @media (--bp-xs) {\n          min-width: calc(100% - 2 * var(--margin));\n          left: var(--margin);\n        }\n      }\n    }\n  }\n}\n","/** Dynamic user communications **/\n\n/* Top notification bar */\n.notifications-area {\n  width: 100%;\n  position: sticky;\n  top: 0;\n  z-index: 150;\n  opacity: 0.95;\n}\n\n.alert.alert-dismissible {\n  position: relative;\n  margin: 0;\n  padding: 1rem 0;\n  border-radius: 0;\n\n  &.alert-danger,\n  &.alert-success {\n    color: var(--error-red);\n    background-color: var(--bg-orange);\n    border: none;\n  }\n\n  span {\n    padding-right: 0.5rem;\n\n    @media (--bp-sm) {\n      margin: 0;\n    }\n  }\n\n  .close {\n    position: absolute;\n    height: 1.5rem;\n    width: 1.5rem;\n    right: 1rem;\n    top: 1rem;\n    padding: 0;\n    border-radius: 50%;\n\n    &:hover {\n      color: var(--bright-orange);\n    }\n\n    @media (--bp-sm) {\n      font-size: var(--txt-xs);\n    }\n  }\n\n  @media (--bp-sm) {\n    padding: 1rem;\n  }\n}\n\n/* Green italic recommendation, see typography */\n.suggestion {\n  @media (--bp-xl-up) {\n    position: absolute;\n    right: 0;\n    max-width: 25%;\n    top: 1rem;\n  }\n\n  .status-box & {\n    position: static;\n    max-width: 100%;\n  }\n\n  .options & {\n    margin: 1rem auto 0;\n    width: 75%;\n  }\n}\n\n/* Hover info bubble */\n.custom-tooltip-wrapper {\n  position: relative;\n  display: inline-block;\n\n  .trigger {\n    width: 2.25rem;\n    height: 2.25rem;\n    min-width: 2.25rem;\n    min-height: 2.25rem;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    background: var(--contrast-color);\n    margin-left: 0.5rem;\n    box-shadow: none;\n    border-radius: 50%;\n    color: var(--txt-orange);\n\n    &:hover {\n      transform: scale(0.8);\n    }\n\n    svg {\n      pointer-events: none;\n      height: 1em;\n    }\n\n    @media (--bp-xs) {\n      width: 2rem;\n      height: 2rem;\n      min-width: 2rem;\n      min-height: 2rem;\n    }\n  }\n\n  .custom-tooltip-popover {\n    position: absolute;\n    top: 110%;\n    transform: translateX(-50%);\n    z-index: 1000;\n    min-width: 250px;\n    max-width: 260px;\n    box-shadow: var(--shadow-md);\n    border-radius: 10px;\n    background: var(--contrast-color);\n    padding: 1rem 1rem 1.125rem;\n\n    @media (--bp-lg) {\n      transform: translateX(-82.5%);\n    }\n  }\n}\n","/** Reset pw flow specific styles **/\n\n.description-without-security {\n  margin-top: 1.5rem;\n}\n\n#reset-password-form {\n  margin-top: 0;\n\n  &.form-group {\n    margin-bottom: 0;\n  }\n}\n\n@media (--bp-sm) {\n  #reset-password-form {\n    flex-direction: column;\n    align-items: unset;\n\n    & #reset-password-button {\n      width: 100%;\n      margin-left: 0;\n    }\n  }\n}\n","/** Signup flow specific styles **/\n\nh3 {\n  &.register-header {\n    margin-top: 0;\n    margin-bottom: 1rem;\n  }\n}\n\n#captcha {\n  transform: scale(1.2);\n  transform-origin: 0 0;\n  margin-bottom: 2rem;\n}\n\n#resend-button {\n  width: fit-content;\n  justify-content: center;\n}\n\n.signup-timer-wrapper {\n  display: flex;\n  align-items: center;\n\n  span {\n    margin-right: 0.5rem;\n  }\n}\n\n@media (--bp-sm) {\n  #resend-button {\n    width: 100%;\n  }\n}\n\n@media (--bp-xs) {\n  #captcha {\n    transform: scale(0.9);\n    margin-bottom: 0;\n  }\n\n  .captcha {\n    margin: 0;\n  }\n}\n\n/* TODO: consider using --bp-xs (414px) instead of hardcoded 375px.\n   375px matches iPhone SE/6/7/8 portrait — likely a targeted fix for text overflow on small phones. */\n@media (width <= 375px) {\n  #resend-button {\n    font-size: var(--txt-xs);\n  }\n}\n\n.enter-code,\n.expiration-info {\n  form {\n    margin-bottom: 1.25rem;\n  }\n\n  /* TODO: This is a duplicate of the same things from Other Device */\n\n  @media (--bp-md) {\n    .response-code-inputs {\n      input {\n        margin: 5px -1px 5px 0;\n        height: 3rem;\n        width: 2.5rem;\n\n        &:nth-child(4) {\n          margin-right: 1rem;\n        }\n      }\n    }\n  }\n\n  @media (--bp-xs) {\n    .response-code-inputs {\n      display: flex;\n      justify-content: space-around;\n    }\n  }\n}\n\n.response-code-inputs {\n  input {\n    display: inline-block;\n    border: 2px solid var(--border-gray);\n    font-size: 1.75rem;\n    margin: 5px;\n    height: 4rem;\n    width: 3.5rem;\n    text-align: center;\n    border-radius: 5px;\n    outline: none;\n\n    &:focus {\n      box-shadow: none;\n      position: relative;\n    }\n\n    &:nth-child(4) {\n      margin-right: 1.5rem;\n    }\n  }\n\n  &:first-child {\n    margin-left: 0;\n  }\n}\n\nsection#register-with-name,\n.register-password {\n  margin-top: 2rem;\n}\n\n.with-digital-id .buttons {\n  margin-top: 1rem;\n}\n\n.digital-id-option {\n  > div {\n    padding: 0.5rem 1rem;\n    border: 1px var(--success-green) solid;\n    border-radius: 6px;\n    margin-top: 1rem;\n\n    button#signup-eidas img {\n      background: white;\n      padding: 5px;\n      object-fit: contain;\n    }\n  }\n\n  .flex-column {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n\n    p {\n      margin: 0;\n    }\n  }\n}\n\n/* signup recommendation-box  */\n\n.access-requirements {\n  margin: 1.5rem 0;\n}\n\n.recommendation-box {\n  display: flex;\n}\n\n.recommendation-box span {\n  background-color: var(--success-green);\n  height: max-content;\n  color: white;\n  font-size: 13px;\n  font-weight: 800;\n  padding: 2px 5px;\n}\n","/** Content wrapping load spinner **/\n\n#eduid-splash-and-children {\n  position: relative;\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n}\n\n#eduid-splash-spinner {\n  height: 100%;\n  width: calc(100% + 2 * (var(--border-width)));\n  left: -var(--border-width);\n  background-color: var(--body-gray);\n  position: absolute;\n  z-index: 100;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  /* Pure-CSS loading spinner: a rotating conic-gradient arc, masked to a ring. */\n  .spinner {\n    width: 2.5rem;\n    height: 2.5rem;\n    border-radius: 50%;\n    color: var(--txt-gray);\n    background: conic-gradient(from 0deg, transparent 0 8%, currentcolor);\n    mask: radial-gradient(farthest-side, transparent calc(100% - 4px), #000 0);\n    animation: splash-spin 1s linear infinite;\n  }\n}\n\n@keyframes splash-spin {\n  to {\n    transform: rotate(1turn);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  #eduid-splash-spinner .spinner {\n    animation-duration: 5s;\n  }\n}\n",".error-page {\n  h1 {\n    color: var(--error-red);\n  }\n\n  & span {\n    line-height: 1.5;\n    font-family: var(--inter-bold);\n    font-size: var(--txt-xxl);\n  }\n\n  & ul {\n    margin-bottom: 3.5rem;\n    font-size: var(--txt-xl);\n\n    div {\n      margin-left: 2rem;\n\n      li:nth-child(1),\n      li:nth-child(3),\n      li:nth-child(5) {\n        list-style-type: disc;\n        margin-top: 1rem;\n        font-family: var(--inter-bold);\n      }\n\n      li:nth-child(even) {\n        margin-top: 0;\n      }\n    }\n  }\n\n  & li {\n    line-height: 1.5;\n    font-family: var(--inter-regular);\n    margin-top: 24px;\n  }\n\n  & .technical-info-heading span {\n    font-family: var(--inter-bold);\n    font-size: var(--txt-xl);\n  }\n\n  & .technical-info-box {\n    background-color: var(--contrast-color);\n    padding: 1rem;\n\n    .technical-info-text {\n      display: flex;\n      justify-content: flex-start;\n\n      p {\n        font-size: var(--txt-md);\n        padding-bottom: 0;\n      }\n\n      p:first-child {\n        text-transform: uppercase;\n        font-family: var(--inter-bold);\n        width: 8.125rem;\n        padding-right: 1rem;\n      }\n\n      p:last-child {\n        color: var(--error-red);\n      }\n    }\n  }\n\n  .specific-error {\n    margin-bottom: 1.5rem;\n  }\n}\n\n/* small reddish alert with exclamation symbol */\n.warning-text {\n  color: var(--error-red);\n  font-size: var(--txt-sm);\n\n  .warning-symbol {\n    padding-right: 0.5rem;\n  }\n}\n\n@media (--bp-sm) {\n  .technical-info-text {\n    flex-direction: column;\n\n    p:last-child {\n      color: var(--error-red);\n    }\n  }\n}\n\n.error-info {\n  text-align: left;\n  font-size: var(--txt-md);\n\n  tr {\n    height: auto;\n  }\n\n  td:not(.plain-cell) {\n    &:first-child {\n      text-transform: uppercase;\n      padding-left: 0;\n    }\n\n    &:last-child {\n      color: var(--error-red);\n    }\n  }\n\n  th,\n  td {\n    padding: 0.325rem 0;\n\n    &:last-child {\n      width: 70%;\n    }\n  }\n}\n","/* username and password */\n.username-pw {\n  margin-bottom: 2rem;\n\n  form {\n    margin-top: 0;\n\n    .form-group {\n      margin-bottom: var(--margin);\n    }\n\n    .welcome-back-container {\n      margin: 0 0 1rem;\n      display: flex;\n      justify-content: space-between;\n      align-items: flex-start;\n\n      @media (--bp-sm) {\n        flex-direction: column;\n        align-items: flex-start;\n\n        h3 {\n          margin-bottom: 0.5em;\n        }\n      }\n\n      legend {\n        font-size: 1.375rem;\n        margin-bottom: 0.75em;\n        display: block;\n        width: fit-content !important;\n      }\n    }\n\n    .links {\n      a {\n        margin: 0.25rem 0;\n        display: inline-block;\n      }\n\n      @media (--bp-xl) {\n        margin-top: 1rem;\n      }\n    }\n\n    .flex-between {\n      flex-direction: row;\n      text-align: right;\n\n      @media (--bp-xl) {\n        flex-direction: column;\n        text-align: center;\n      }\n    }\n  }\n}\n\n/* multi-factor authentication */\n.options {\n  display: flex;\n  justify-content: center;\n  flex-flow: column;\n  align-items: center;\n  margin-top: var(--margin);\n  position: relative;\n\n  .option-wrapper {\n    width: 330px;\n    margin-bottom: 2rem;\n\n    .option {\n      border-radius: 20px;\n      background: var(--contrast-color);\n      box-shadow: var(--shadow-md);\n      padding: 1rem;\n      min-height: 210px;\n      display: flex;\n      flex-direction: column;\n      justify-content: space-between;\n\n      h3 {\n        font-size: var(--txt-xl);\n      }\n\n      h3,\n      .help-text {\n        margin: 0;\n      }\n\n      /* duplicate in _buttons.scss? */\n      .icon {\n        background: transparent;\n        padding: 0;\n        margin: 0;\n        height: auto;\n        border: none;\n\n        svg {\n          color: var(--body-txt);\n          height: 1rem;\n          width: 1rem;\n        }\n      }\n\n      .bottom {\n        align-items: flex-end;\n\n        img {\n          max-width: 178px;\n        }\n      }\n    }\n\n    @media (--bp-xs) {\n      width: 100%;\n    }\n  }\n\n  .help-text {\n    text-align: center;\n    margin-bottom: 2rem;\n  }\n}\n\n/* use another device */\n.use-another-device {\n  &.device1 {\n    .response-code-inputs {\n      background: var(--contrast-color);\n      text-align: center;\n      margin: 1em 0;\n      padding: 1em;\n      position: relative;\n      margin-bottom: 0;\n    }\n\n    .input-validate-error {\n      margin-top: 0.5rem;\n      display: inline-block;\n    }\n\n    .buttons {\n      margin-top: 1rem;\n    }\n  }\n\n  &.device2 .response-code-inputs {\n    input {\n      border: none;\n      width: 1.75rem;\n      padding: 0;\n\n      &:nth-child(3) {\n        margin-right: 1rem;\n      }\n    }\n  }\n\n  .expiration-info {\n    position: relative;\n\n    @media (--bp-sm) {\n      margin-left: calc(-1 * var(--list-indent));\n    }\n  }\n\n  .expires-meter {\n    margin-top: 1.5rem;\n\n    @media (--bp-md-up) {\n      position: absolute;\n      bottom: 0.5rem;\n      right: 0;\n    }\n  }\n\n  form.response-code-form {\n    margin-top: 0;\n  }\n\n  .finished.device2 {\n    /* TODO: $warning_size was an unused SCSS variable — remove or convert to --warning-size if needed */\n\n    /* $warning_size: 1.5rem; */\n\n    display: flex;\n    flex-direction: column;\n    row-gap: 1rem;\n\n    .response-code-form {\n      align-items: center;\n    }\n  }\n\n  .listed-steps {\n    figure {\n      img.qr-code {\n        width: 200px;\n      }\n    }\n\n    @media (--bp-sm) {\n      .x-adjust {\n        margin-left: calc(-1 * var(--list-indent));\n      }\n    }\n  }\n\n  .developer {\n    /* show QR URL at the bottom for non-production environments */\n    height: 10rem;\n    font-size: var(--txt-xs);\n    overflow: hidden;\n    word-break: break-all;\n  }\n}\n\n/* security zone info */\nsection.intro .status-box {\n  margin-bottom: 2rem;\n\n  &.passkey {\n    display: block;\n  }\n}\n\nsection.username-pw-option {\n  margin-bottom: 1.5rem;\n\n  a {\n    text-align: right;\n    margin-bottom: 1rem;\n  }\n\n  fieldset.border-toggle-area {\n    margin-top: 1.5rem;\n  }\n}\n\nsection.other-device-option .buttons {\n  margin-top: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n/* Remove margin-bottom from password field to eliminate extra space above forgot password link */\nsection.username-pw-option form .form-group:nth-of-type(2) {\n  margin-bottom: 0;\n}\n\n.passkey-option .status-box {\n  display: block;\n  background-color: transparent;\n  border: 0 solid !important;\n  box-shadow: none;\n  padding: 0;\n  margin-bottom: 1.5rem;\n\n  .text-wrapper {\n    img {\n      width: 6rem;\n      margin-left: 1rem;\n    }\n  }\n\n  .buttons {\n    justify-content: space-between;\n    align-items: center;\n  }\n}\n\nsection.add-key-section {\n  margin-top: 1rem;\n  position: relative;\n}\n","/** Edit name form **/\n\n.personal-data {\n  .title {\n    margin-bottom: 1.25rem;\n  }\n\n  @media (--bp-xs) {\n    .button-pair {\n      flex-direction: column;\n    }\n  }\n\n  .heading,\n  .title {\n    display: flex;\n    justify-content: space-between;\n    align-items: baseline;\n\n    .link {\n      height: 100%;\n    }\n\n    .close {\n      padding: 0;\n      border-radius: 0;\n    }\n  }\n\n  .edit-data {\n    background-color: var(--contrast-color);\n    padding: 1rem;\n  }\n}\n\n#add-personal-data {\n  align-self: unset;\n}\n\n.personal-data-info {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n/* styles for input on white bg */\n.edit-data {\n  p.verified {\n    padding-bottom: 0;\n  }\n}\n\n/* styles for displayed names */\n.external-names {\n  display: flex;\n  flex-wrap: wrap;\n  flex: 1;\n  margin-bottom: 0;\n}\n\n.external-names,\n.personal-data-info {\n  .profile-grid-cell {\n    flex: 1;\n    flex-basis: 47%;\n    justify-content: unset;\n    margin: 0 1rem 1rem 0;\n  }\n}\n",".ladok {\n  svg {\n    transform: none;\n  }\n\n  input {\n    height: initial;\n  }\n\n  label {\n    &.flex-between {\n      margin-right: 0;\n    }\n  }\n}\n\n.ladok-university {\n  @media (--bp-md) {\n    flex-direction: column;\n\n    &.flex-between {\n      align-items: flex-start;\n    }\n  }\n\n  @media (--bp-md-up) {\n    label {\n      margin-bottom: 0;\n    }\n  }\n}\n\n.ladok-university-name {\n  flex-grow: 1;\n  text-align: right;\n  white-space: nowrap;\n}\n\n.ladok-universities-status {\n  color: var(--error-red);\n  font-size: var(--txt-md);\n}\n","/** React-select style overrides, final-form element prefixed by \"react-select\" **/\n/* stylelint-disable selector-class-pattern */\n\nform .react-select__control,\n.basic-multi-select .select__control,\n.select--is-disabled .select__control {\n  border: 2px solid var(--border-gray);\n  background-color: var(--contrast-color);\n  color: var(--body-txt);\n\n  .react-select__indicator {\n    color: var(--txt-gray);\n  }\n\n  .react-select__single-value {\n    color: var(--txt-gray);\n  }\n\n  &--is-disabled {\n    background-color: var(--bg-gray);\n    font-size: var(--txt-xl);\n\n    * {\n      color: var(--txt-gray);\n    }\n\n    .select__indicators {\n      display: none;\n    }\n  }\n}\n\nform .react-select__menu,\n.basic-multi-select .select__menu,\n.select--is-disabled .select__menu {\n  color: var(--body-txt);\n  background-color: var(--contrast-color);\n}\n\nform .react-select__control:hover,\n.basic-multi-select .select__control:hover,\n.select--is-disabled .select__control:hover {\n  border: 2px solid var(--txt-gray);\n  box-shadow: none;\n}\n\n/* also focus-visible */\nform .react-select__control--is-focused,\n.basic-multi-select .select__control--is-focused,\n.select--is-disabled .select__control--is-focused {\n  outline: 2px dashed var(--body-txt) !important;\n  box-shadow: none;\n}\n\nform .react-select__indicator-separator,\n.basic-multi-select .select__indicator-separator,\n.select--is-disabled .select__indicator-separator {\n  width: 0;\n}\n\nform .react-select__placeholder,\n.basic-multi-select .select__placeholder,\n.select--is-disabled .select__placeholder {\n  font-family: var(--inter-regular);\n  color: var(--body-txt);\n}\n\nform .react-select__option--is-focused,\n.basic-multi-select .select__option--is-focused,\n.select--is-disabled .select__option--is-focused {\n  background-color: var(--bg-orange);\n  outline: 1px dashed var(--body-txt) !important;\n  outline-offset: -1px;\n}\n\nform .react-select__option--is-selected,\n.basic-multi-select .select__option--is-selected,\n.select--is-disabled .select__option--is-selected {\n  color: var(--txt-gray);\n  background-color: inherit;\n  font-family: var(--inter-bold);\n  font-weight: normal;\n}\n\n.select-group {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-top: 0.75rem;\n  gap: 0.5rem;\n\n  > div:nth-child(1) {\n    flex: 2;\n  }\n\n  > div:nth-child(2) {\n    flex: 1;\n  }\n\n  .select__control,\n  div.default-surname {\n    min-height: 3rem;\n  }\n\n  input {\n    height: auto;\n\n    &:focus {\n      box-shadow: none;\n    }\n  }\n\n  @media (--bp-md) {\n    > div:nth-child(1) {\n      flex: 1;\n    }\n  }\n\n  @media (--bp-sm) {\n    flex-direction: column;\n\n    > div {\n      width: 100%;\n    }\n  }\n\n  div.default-surname {\n    display: inline-block;\n    border: 2px solid var(--border-gray);\n    border-radius: 4px;\n    padding: 6px 12px;\n    cursor: not-allowed;\n    background-color: var(--bg-gray);\n    color: var(--txt-gray);\n    font-size: var(--txt-xl);\n  }\n}\n\n/* login react select */\n.mfa-select {\n  height: 3rem;\n  min-width: 100px;\n  padding: 0 1.125rem;\n\n  .react-select__placeholder {\n    color: var(--txt-orange);\n    font-family: var(--akkurat);\n    text-transform: uppercase;\n    font-weight: bold;\n    font-size: var(--txt-md);\n  }\n\n  .css-tj5bde-Svg {\n    color: var(--txt-orange);\n  }\n\n  .react-select__control {\n    display: flex;\n    height: 3rem;\n    align-items: center;\n    background-color: var(--contrast-color);\n    border-radius: 1.5rem;\n    cursor: pointer;\n    border: solid 2px var(--bright-orange);\n\n    &.react-select__control--is-disabled {\n      cursor: not-allowed;\n      pointer-events: all !important;\n      background-color: var(--btn-orange);\n      border-color: inherit;\n      color: #fff;\n      opacity: 0.4;\n\n      .react-select__placeholder {\n        color: var(--contrast-color);\n      }\n\n      svg.css-tj5bde-Svg {\n        display: none;\n      }\n    }\n  }\n\n  .react-select__control:hover {\n    border: solid 2px var(--bright-orange);\n  }\n\n  .react-select__value-container {\n    height: 3rem;\n    padding: 0;\n    text-align: center;\n\n    .react-select__single-value {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n  }\n\n  .react-select__menu {\n    width: 90%;\n    background-color: var(--contrast-color);\n  }\n\n  .react-select__menu-list {\n    .react-select__option {\n      display: flex;\n      align-items: center;\n    }\n  }\n\n  .select-option-text {\n    color: var(--txt-orange);\n    font-family: var(--akkurat);\n    font-weight: bold;\n  }\n}\n\n.mfa-select__control--is-focused {\n  border-color: transparent;\n}\n\n.mfa-select__control:not(.custom-select__control--is-focused) {\n  border-color: transparent;\n}\n\n/* stylelint-enable selector-class-pattern */","/* Accordion */\n\n.accordion {\n  box-shadow: var(--shadow-sm);\n  border: 2px solid var(--border-gray);\n  border-radius: 6px;\n\n  form {\n    margin-top: 0;\n  }\n\n  & details {\n    & + details {\n      border-top: 2px solid var(--border-gray);\n    }\n\n    &:first-of-type summary > div {\n      border-radius: 4px 4px 0 0;\n    }\n\n    &:last-of-type summary > div {\n      border-radius: 0 0 4px 4px;\n    }\n\n    &:last-of-type[open] summary > div {\n      border-radius: 0;\n    }\n\n    &:last-of-type > .accordion-panel {\n      border-radius: 0 0 4px 4px;\n    }\n\n    /* single item */\n    &:only-of-type summary > div {\n      border-radius: 4px;\n    }\n\n    &:only-of-type[open] summary > div {\n      border-radius: 4px 4px 0 0;\n    }\n\n    &:only-of-type > .accordion-panel {\n      border-radius: 0 0 4px 4px;\n    }\n\n    &[open] > summary > div {\n      background: var(--bg-orange);\n    }\n\n    & summary {\n      list-style: none;\n\n      &::marker,\n      &::-webkit-details-marker {\n        display: none;\n      }\n\n\n      & > div {\n        display: flex;\n        cursor: pointer;\n        background: var(--bg-gray);\n        color: var(--txt-orange);\n        position: relative;\n        align-items: center;\n        padding: 1rem;\n        font-family: var(--akkurat);\n        font-weight: bold;\n        transition: all 0.1s ease-in;\n\n        &:hover {\n          background: var(--btn-orange);\n          color: var(--contrast-color);\n\n          & h3 {\n            text-decoration: underline;\n          }\n        }\n\n        & > span:first-child {\n          & svg {\n            text-align: center;\n            font-size: var(--txt-sm);\n            margin-right: 10px;\n          }\n\n          & + div {\n            flex: 1;\n            margin-right: 1.5rem;\n          }\n        }\n\n        & h3 {\n          font-family: var(--akkurat);\n          font-size: var(--txt-lg);\n          line-height: 1.4;\n          margin-bottom: 0;\n\n          @media (--bp-md) {\n            font-size: var(--txt-md);\n          }\n        }\n\n        & > div > span {\n          font-size: var(--txt-xs);\n          display: block;\n          margin-bottom: 0;\n        }\n\n        /* stylelint-disable-next-line selector-class-pattern */\n        & > svg.svg-inline--fa.fa-chevron-up,  \n        /* stylelint-disable-next-line selector-class-pattern */\n        & > svg.svg-inline--fa.fa-chevron-down {\n          position: absolute;\n          right: 1rem;\n        }\n      }\n    }\n\n    & > .accordion-panel {\n      background-color: var(--contrast-color);\n      padding: 1.5rem 1rem;\n      animation: fadein 0.2s ease-in;\n\n      @keyframes fadein {\n        0% {\n          opacity: 0;\n        }\n\n        100% {\n          opacity: 1;\n        }\n      }\n    }\n  }\n\n  /* Nested variant: card-like display for internal accordion groups */\n  &.nested {\n    border: none;\n    box-shadow: none;\n    border-radius: 0;\n\n    & details {\n      margin-bottom: 10px;\n      border: 2px solid var(--border-gray);\n      border-radius: 6px;\n\n      & + details {\n        border-top: 2px solid var(--border-gray);\n      }\n\n      &:hover {\n        border-color: var(--bright-orange);\n\n        &[open] {\n          border-color: var(--border-gray);\n        }\n      }\n\n      &[open] > summary > div {\n        background: var(--bg-orange);\n      }\n\n      & summary > div {\n        border-radius: 4px;\n\n        &:hover {\n          color: var(--contrast-color);\n          background: var(--btn-orange);\n        }\n\n        & h3 {\n          font-size: var(--txt-md);\n          text-transform: uppercase;\n          letter-spacing: 1px;\n        }\n      }\n\n      & > .accordion-panel {\n        padding: 1rem 1rem 1.25rem;\n        border-radius: 0 0 4px 4px;\n\n        & p {\n          font-size: var(--txt-lg);\n          line-height: 1.25;\n        }\n      }\n    }\n  }\n}\n","/* Pre login/register root landing page */\n\n.landing {\n  background-image: radial-gradient(\n    ellipse at 112% 100%,\n    var(--body-gray) 0,\n    var(--body-gray) 45%,\n    #fafafa 45%,\n    #fafafa 75%,\n    var(--contrast-color) 75%\n  );\n\n  header,\n  .panel,\n  footer {\n    background-color: transparent;\n  }\n\n  footer {\n    border-top: none;\n  }\n}\n\n.landing-content {\n  h1 {\n    font-size: 2.75rem;\n    margin-bottom: 0.75em;\n\n    @media (--bp-md) {\n      font-size: 2rem;\n    }\n  }\n\n  p {\n    &.med-txt {\n      font-size: var(--txt-sm) !important;\n    }\n  }\n\n  .buttons {\n    padding: 0.25rem 0 1rem;\n  }\n}\n\n.landing-how-to {\n  filter: drop-shadow(0 -6px 0 var(--shadow-green));\n  transform: translateZ(0); /* prevent weird Safari filter bug */\n  align-items: flex-end;\n  box-shadow: 0 10px 10px -10px rgb(89 89 89 / 50%);\n  overflow: hidden;\n  margin-top: 1rem;\n\n  div {\n    flex: 1;\n    padding: 4rem 3rem 2.5rem;\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    margin-left: -1rem;\n    margin-right: -1rem;\n    border-radius: 100% 100% 0 0;\n    font-family: var(--inter-medium);\n    font-size: var(--txt-sm);\n    color: var(--txt-gray);\n\n    &:nth-of-type(1) {\n      background-color: #f3f9f5;\n      margin-top: 1rem;\n    }\n\n    &:nth-of-type(2) {\n      background-color: #e6f3eb;\n    }\n\n    &:nth-of-type(3) {\n      background-color: #daede1;\n    }\n\n    &:nth-of-type(4) {\n      background-color: #cde7d7;\n      padding-top: 5rem;\n    }\n  }\n\n  .icon-holder {\n    margin-top: 0.5rem;\n\n    img,\n    svg {\n      width: auto;\n      height: 24px;\n      margin: 5px;\n    }\n  }\n\n  @media (--bp-lg-up) {\n    max-width: calc(870px + 4rem);\n    margin: 1rem auto 2rem;\n    border-radius: 0 0 4rem 3rem;\n  }\n\n  @media (--bp-lg) {\n    margin: 1rem auto 0;\n\n    div {\n      padding: 3rem 2rem 2rem;\n\n      &:nth-of-type(4) {\n        padding-top: 3rem;\n      }\n    }\n  }\n\n  @media (--bp-md) {\n    flex-direction: column;\n    align-items: center;\n    margin: 1rem 0 0.5rem;\n\n    div {\n      width: calc(100% + 4rem);\n      margin-left: 0;\n      margin-right: 0;\n      margin-bottom: -5rem;\n      padding: 3.5rem 3rem 6rem;\n\n      &:nth-of-type(4) {\n        padding-bottom: 4rem;\n        margin-bottom: 0;\n      }\n    }\n  }\n}\n","/* System/browser set dark mode overrides */\n\nhtml.dark {\n  --contrast-color: #000;\n  --body-txt: #f4f4f4;\n  --body-gray: #2e2e2e;\n  --txt-gray: #bdbdbd;\n  --border-gray: #5e5e5e;\n  --txt-orange: #ff6d32;\n  --bg-orange: #36251e;\n  --error-red: #ff5965;\n  --error-red-t: #ff596580; /* with 50% transparency */\n  --bg-gray: #202020;\n  --shadow-green: #177d4d; /* success green */\n  --txt-green: #30d98a;\n\n  /* header and footer */\n  header .eduid-logo {\n    background-image: url(\"../../img/eduid-logo-darkmode.png\") !important;\n  }\n\n  footer .sunet-logo {\n    background-image: url(\"../../img/sunet_logo_white.svg\") !important;\n  }\n\n  .header-user {\n    color: #fff;\n  }\n\n  @media (--bp-xl) {\n    header nav .nav-menu.active {\n      box-shadow: 0 -6px 17px rgb(89 89 89 / 30%);\n    }\n  }\n\n  @media (--bp-xl-up) {\n    header nav .nav-menu .submenu {\n      filter: drop-shadow(0 -6px 17px rgb(89 89 89 / 30%));\n    }\n  }\n\n  /* landing and start page */\n  .status-box.success,\n  .landing-how-to div {\n    color: #fff;\n\n    &:nth-of-type(1) {\n      background-color: #15221a;\n    }\n\n    &:nth-of-type(2) {\n      background-color: #273e30;\n    }\n\n    &:nth-of-type(3) {\n      background-color: #355543;\n    }\n\n    &:nth-of-type(4) {\n      background-color: #3b634c;\n    }\n  }\n\n  .landing {\n    background-image: radial-gradient(\n      ellipse at 112% 100%,\n      var(--body-gray) 0,\n      var(--body-gray) 45%,\n      var(--bg-gray) 45%,\n      var(--bg-gray) 75%,\n      var(--contrast-color) 75%\n    );\n    color: var(--body-txt);\n\n    .icon-holder {\n      color: #fff;\n\n      /* success green color */\n      img {\n        filter: brightness(0) saturate(100%) invert(94%) sepia(19%) hue-rotate(24deg) contrast(105%);\n      }\n    }\n  }\n\n  .step-container {\n    background-color: var(--bg-gray);\n    box-shadow: 0 -6px 17px rgb(89 89 89 / 30%);\n\n    figure,\n    #copy-new-password {\n      background-color: #273e30;\n    }\n\n    .step-indicator .step-item:not(.active, .completed) .step-number {\n      background-color: var(--contrast-color);\n    }\n  }\n\n  button.secondary,\n  button.secondary:not(:disabled, .disabled):active,\n  button.secondary:not(:disabled, .disabled):focus,\n  button.secondary:not(:disabled, .disabled):active:focus,\n  button.secondary:not(:disabled, .disabled):hover,\n  /* stylelint-disable-next-line selector-class-pattern */\n  .mfa-select .react-select__placeholder,\n  /* stylelint-disable-next-line selector-class-pattern */\n  .mfa-select .react-select__single-value .select-option-text {\n    color: #fff;\n  }\n\n  .remove {\n    filter: invert(97%) sepia(0%) saturate(7500%) hue-rotate(295deg) brightness(105%) contrast(102%);\n\n    &:hover {\n      filter: var(--bright-orange-filter);\n    }\n  }\n\n  /* form */\n  input:disabled,\n  input[readonly] {\n    background-color: var(--bg-gray);\n  }\n\n  input:focus {\n    color: var(--body-txt);\n  }\n\n  input:is(:-webkit-autofill, :autofill),\n  input:-internal-autofill-selected {\n    color: var(--txt-gray) !important;\n    -webkit-text-fill-color: var(--txt-gray) !important;\n  }\n\n  input:-webkit-autofill,\n  input:-webkit-autofill:hover,\n  input:-webkit-autofill:focus,\n  input:-webkit-autofill:active {\n    color: var(--txt-gray) !important;\n    -webkit-text-fill-color: var(--txt-gray) !important;\n  }\n\n  /* Akkurat less legible in the dark, possibly add letter-spacing as well */\n  a {\n    font-weight: bold;\n  }\n\n  ::placeholder {\n    color: var(--txt-gray) !important;\n    opacity: 1; /* Firefox */\n  }\n\n  .modal.show {\n    background-color: rgb(46 46 46 / 75%);\n  }\n}\n","/* Plate to highlight content, with numbered steps at bottom.  */\n\n.step-container {\n  background-color: white;\n  padding: 1rem 1.5rem;\n  box-shadow: var(--shadow-sm);\n\n  @media (--bp-sm-up) {\n    margin: 0 -1.5rem;\n  }\n\n  h1 {\n    margin-bottom: 0.25em;\n  }\n\n  .destination-info {\n    color: var(--txt-green);\n    font-size: var(--txt-md);\n\n    span {\n      text-transform: uppercase;\n    }\n  }\n\n  .lead {\n    margin-bottom: 1.5rem;\n    margin-top: 1rem;\n\n    p {\n      color: var(--txt-gray);\n    }\n  }\n\n  .digital-id-option .buttons button.primary.sm {\n    align-self: center;\n    height: 33px;\n    padding: 0 1rem;\n\n    img.circle-icon {\n      width: 18px !important;\n      height: 18px !important;\n    }\n\n    span {\n      display: inline-block;\n      line-height: normal;\n      vertical-align: middle;\n    }\n  }\n\n  img.passkey-image {\n    width: 5rem !important;\n  }\n\n  .mfa-alternative {\n    border: 1px var(--success-green) solid;\n    border-radius: 6px;\n    padding: 1rem;\n    margin-bottom: 1.5rem;\n    margin-top: 1.5rem;\n\n    .wizard-link-wrapper {\n      padding-top: 0;\n\n      button {\n        height: 2rem;\n      }\n    }\n  }\n\n  figure {\n    background-color: #daede1;\n\n    &.signin-details {\n      text-align: left;\n    }\n  }\n\n  .heading {\n    display: flex;\n    justify-content: space-between;\n    align-items: baseline;\n\n    @media (--bp-sm) {\n      flex-direction: column;\n      margin-bottom: 1rem;\n    }\n  }\n\n  #copy-new-password {\n    background-color: #daede1;\n  }\n\n  .hint {\n    font-size: 14px !important;\n    font-style: italic;\n    border: 1px solid green;\n    border-radius: 6px;\n    padding: 1rem;\n    margin-top: 0.5rem;\n  }\n\n  .border-line {\n    margin-top: 1.5rem;\n  }\n\n  .step-indicator {\n    display: grid;\n    justify-items: center;\n    margin-bottom: 1rem;\n\n    &.steps-5 {\n      grid-template-columns: repeat(5, 1fr);\n    }\n\n    &.steps-6 {\n      grid-template-columns: repeat(6, 1fr);\n    }\n\n    .step-item {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      gap: 0.5rem;\n\n      .step-number {\n        width: 2.25rem;\n        height: 2.25rem;\n        border-radius: 50%;\n        background-color: var(--bg-gray);\n        color: var(--body-txt);\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-weight: bold;\n        font-family: monospace;\n        font-size: var(--txt-sm);\n      }\n\n      .step-label {\n        font-size: var(--txt-xs);\n        text-align: center;\n        color: var(--txt-gray);\n        padding: 0 0.25rem;\n      }\n\n      &.completed .step-number {\n        background-color: #cde7d7;\n        color: #161616;\n      }\n\n      &.active .step-number {\n        background-color: var(--success-green);\n        color: #f4f4f4;\n      }\n\n      &.active .step-label {\n        font-weight: bold;\n        color: var(--body-txt);\n      }\n    }\n\n    @media (width <= 768px) {\n      .step-item .step-label {\n        display: none;\n      }\n    }\n  }\n\n  .edit-data {\n    padding: 0;\n    background-color: transparent;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
